import React, { useState, useEffect, useRef } from "react";
import { Grid, MenuItem, TextField, Button, Tooltip } from "@material-ui/core";
//import "./AddSir.scss";
//import Select, { SelectChangeEvent } from '@mui/material/Select';
//import 'date-fns';
//import DateFnsUtils from '@date-io/date-fns';
import * as FileSaver from "file-saver";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import InputLabel from "@material-ui/core/InputLabel";
import {
  baseApiURL,
  baseURL,
  tableIconsInputScreen,
} from "../../Utilities/Utility";
import FormControl from "@material-ui/core/FormControl";
import "./Addisir.scss";

import {
  BootstrapInput,
  getTodayDate,
  getTodayDateMoment,
} from "../../Utilities/Utility";
import { useLocation } from "react-router-dom";

import Select from "@material-ui/core/Select";
//import DialogActions from "@material-ui/core/DialogActions";
//import Dialog from '@material-ui/core/Dialog';
//import DialogContent from '@material-ui/core/DialogContent
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import {
  downloadFile,
  getAllIsirDetails,
  getAutomatedWorkFlowNumber,
  getDevelopment,
  getTypeDDL,
  getGroupcategory,
  getRDLocation,
  getrolesForSupplier,
  getSeverity,
  getStatus,
  getSupplierEmail,
  getSupplierName,
  getuploadedDatainDownLoadFile,
  SaveasDraft,
  submit,
  uploadTemplateFileData,
  uploadTemplateFileDataTab2,
  addPOTextDetails,
  getSqe,
  getSpr,
  getOpr,
  addClosureDate,
  getPOText,
  getCheckboxesDetails,
  getRdUsers,
  getWholeRDemailId,
  getMasterAttachmentApiData,
  getUploadDocumentData,
  getCloseEnableDataCondition,
  saveOrUpdateIsirDocumentList,
  getIsirDocumentList,
} from "../../Redux/APIs/api_view";
//import uploadTemplateFileDataTab2

import moment from "moment";
import Loading from "../../Components/Loader/Loader";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
//import Customer_Template from "../../Common/CustomerMaster Template.xlsx";
import Isir_template from "./../../Common/NewFolder/Isir_template.xlsx";

//import SnackbarCustom from "../../../Components/Snackbar/Snackbar";

import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import GetAppOutlinedIcon from "@material-ui/icons/GetAppOutlined";
import InputAdornment from "@material-ui/core/InputAdornment";
import { useDispatch, useSelector } from "react-redux";
import IconButton from "@material-ui/core/IconButton";
//this is new tab creation data
//import React from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import MaterialTable from "material-table";
import SnackbarCustom from "../../Components/Snackbar/Snackbar";
import { authenticateUserWithMyID } from "../../Redux/APIs/api_login";
import AddIsirRoot from "./AddIsirRoot";
import {
  uploadFileValidationAction,
  is3DUploadedAction,
  isToolSpecificationAction,
  isIsirPdfuploadedAction,
  tfcAction,
  dfmAction,
  trmAction,
  ppapAction,
  iipAction,
  poTextAction,
  draftTfcAction,
  draftTrmAction,
  draftDfmAction,
  draftPpapAction,
  hideTb1,
  drawingUpload,
  threeDUpload,
  toolSpecificationUpload,
  isirUpload,
  ppapxlsmAction,
  incomingQualityReportAction,
  componentApprovalFormAction,
  closeBtnAction,
  afterClosingIsirAction,
  justCloseBtnPress,
  apqpAction,
  storeIsirDocumentList,
  closeEnableForChildTypeAction,
  sqmCheckApqpAction,
} from "../../Redux/Actions/actions";
import Remark from "./remark";
import {
  InfoOutlined,
  CloseIcon,
  DownloadOutlinedIcon,
} from "@material-ui/icons";
import { getFileHistory } from "../../Redux/APIs/api_Common";
import { baseApiURLS } from "./NewDownload";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    marginTop: `15px`,
    //paddingTop: `65px`,
  },
  responsiveDialog: {
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "50%",
    },
    margin: "auto",
  },
}));

//const [isirDocumentList, setIsirDocumentList] = useState([]);

// export const RenderAllParts = () => {
//   const [isirDocumentList, setIsirDocumentList] = useState([]);

//   return (
//     <>
//       <AddIsir setIsirDocumentList={setIsirDocumentList} />
//       <PartOne isirDocumentList={isirDocumentList || []} />
//       <PartTwo />
//     </>
//   );
// };

// Start of Part One
const PartOne = ({
  isirNumberPassed,
  groupData,
  prevDataAdd,
  developmentData,
  documentList,
  test,
}) => {
  console.log("documentList", documentList);
  const navigate = useNavigate();
  const closeBtnEnableDataStateFromTB2ChildType = useSelector(
    (state) => state.closeEnableForChildTypeReducer.closeEnableForChildTypeValue
  );
  console.log(
    "closeBtnEnableDataStateFromTB2ChildType",
    closeBtnEnableDataStateFromTB2ChildType
  );

  const is3DUploaded = useSelector(
    (state) => state.is3DUploadedReducer.is3DUploaded
  );
  const isToolSpecification = useSelector(
    (state) => state.toolSpecificationnReducer.isToolSpecification
  );

  //let isirDocumentList = useSelector((state) => state.saveIsirDocumentList.isir);

  const token = useSelector((state) => state.saveTokenReducer.token);
  const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData
  );
  const fileUploadDetails = useSelector(
    (state) => state.uploadFileValidationReducer.files
  );
  const fileUploadDetailss = useSelector(
    (state) => state.uploadFileValidationReducer.isDrawingsUploaded
  );
  const tfcActiondataState = useSelector(
    (state) => state.istfcCheckedorNotReducer.tfcCheckedValue
  );

  const trmActionDataState = useSelector(
    (state) => state.istrmCheckedorNotReducer.trmCheckedValue
  );

  const ppapActionDataState = useSelector(
    (state) => state.isppapCheckedorNotReducer.ppapCheckedValue
  );

  const dfmActionDataState = useSelector(
    (state) => state.isDfmCheckedorNotReducer.dfmCheckedValue
  );
  const hideTabData2ActionState = useSelector(
    (state) => state.hideTabPart2Reducer.hidetb2Value
  );

  const uploadDrawingActionState = useSelector(
    (state) => state.drawingUploadReducer.drawingUploadVlaue
  );

  const upload3DActionState = useSelector(
    (state) => state.threeDUploadReducer.threeDUploadValue
  );

  const uploadToolSpecification = useSelector(
    (state) => state.toolSpecificationReducer.toolSpecificationValue
  );

  const uploadIsirActionState = useSelector(
    (state) => state.isirUploadReducer.isirUploadValue
  );
  const afterClosingIsirActionDataState = useSelector(
    (state) => state.afterClosingIsirReducer.afterClosingIsirValue
  );
  //const justCloseBtnPressActionDataState = useSelector((state) => state.justClosebtnPressReducer.justClosebtnPressValue);

  const sqmCheckApqpDataState = useSelector(
    (state) => state.sqmCheckApqpReducer.sqmCheckApqpValue
  );
  console.log("sqmCheckApqpDataState", sqmCheckApqpDataState);

  const dispatch = useDispatch();
  const classes = useStyles();
  const [file, setFile] = useState();
  const [inputFileValueASMTDoc, setInputFileValueASMTDoc] = useState(Date.now);

  const [drawingpdf, setDrawingPDF] = useState(Date.now);
  const [threeDpdf, setThreeDpdf] = useState("");
  const [toolspecificationPdf, setToolSpecificationPdf] = useState("");

  //new one after writing function
  const [fileData, setFileData] = useState();
  const [selectedFileDept, setSelectedFileDept] = useState(null); //firstfileupload
  const [drawingpdfKey, setDrawingpdf] = useState(Date.now);
  const [selectedFileSecond, setSelectedFileSecond] = useState(null); //secondfileupload
  const [secondFileKey, setSecondFileKey] = useState(Date.now);
  const [selectedFileThird, setSelectedFileThird] = useState(null); //secondfileupload
  const [thirdFileKey, setThirdFileKey] = useState(Date.now);
  const [selectedFileFourth, setSelectedFileFourth] = useState(null); //secondfileupload
  const [fourthFileKey, setFourthdFileKey] = useState(Date.now);
  const [selectedFileFifth, setSelectedFileFifth] = useState(null); //secondfileupload
  const [fifthFileKey, setFifthdFileKey] = useState(Date.now);
  const [selectedFileSix, setSelectedFileSix] = useState(null); //secondfileupload
  const [sixFileKey, setSixFileKey] = useState(Date.now);
  const [selectedFileSeven, setSelectedFileSeven] = useState(null); //secondfileupload
  const [sevenFileKey, setSevenxFileKey] = useState(Date.now);
  const [selectedFil122dfm, setSelectedFil122dfm] = useState(null); //secondfileupload
  const [dfm22FileKey, setDfm22FileKey] = useState(Date.now);

  //setSelectedFileSecond
  //for supplier tab1 dwonload uploadtype

  //states for downloadocx
  const [uploadedData, setuploadData] = useState();
  const [downloadDocxFirst, setDownloadDocxFirst] = useState(""); ///downloadFileData[0].fileurl
  const [downloadDocxSecond, setDownloadDocxSecond] = useState("");
  const [downloadDocxThird, setDownloadDocxThird] = useState("");
  const [downloadDocxFourth, setDownloadDocxFourth] = useState("");
  const [downloadDocxFourthNew, setDownloadDocxFourthNew] = useState("");

  const [downloadFileData, setDownloadFileData] = useState([]);

  const [attachmentResponse, setAttachmentRespence] = useState();

  const [fileName, setFileName] = useState("");
  const [fileType, setFileType] = useState("");
  const [fileUrl, setFileUrl] = useState("");

  //helperTextfor uploaded files
  const [firstNameHelperText, setFirstNameHelperText] = useState("");

  const downloadDocxFirstHandle = (e) => {
    setDownloadDocxFirst(downloadFileData[0].fileUrl);
  };
  const downloadDocxSecondHandle = (e) => {
    setDownloadDocxSecond(downloadFileData[1].fileUrl);
  };
  const downloadDocxThirdHandle = (e) => {
    setDownloadDocxThird(downloadFileData[2].fileUrl);
  };
  const downloadDocxFourthHandle = (e) => {
    setDownloadDocxFourth(downloadFileData[3].fileUrl);
  };
  const downloadDocxFifthHandle = (e) => {
    setDownloadDocxFifth(downloadFileData[4].fileUrl);
  };
  const downloadDocxSixHandle = (e) => {
    setDownloadDocxSix(downloadFileData[5].fileUrl);
  };
  const downloadDocxSevenHandle = (e) => {
    setDownloadDocxSeven(downloadFileData[6].fileUrl);
  };
  const [openDialog, setOpenDialog] = React.useState(false);
  const [snapshotFile, setSnapshotFile] = useState(null);
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleClickOpen = () => {
    setOpenDialog(true);
  };
  //const [uploadImageData, setUploadImageData] = useState("");
  const [open, setOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const handleSnackOpen = (text, type) => {
    setSnackMessage(text);
    setAlertType(type);
    setOpen(true);
  };
  let [inputFileValue, setInputFileValue] = useState(Date.now);
  const [isLoader, setIsLoader] = useState(false);
  const handleClose = (e) => {
    setOpen(false);
  };
  const [isLoaderFeedback, setIsLoaderFeedback] = useState(false);
  //const handleCloseDialog = () => {
  // setOpenDialog(false);
  // };

  //azure ad
  const siteToken = useSelector((state) => state.saveBearerTokenReducer);
  const azureToken = useSelector((state) => state.saveTokenReducer);
  const UID = useSelector((state) => state.saveUserIdReducer);
  //see role data
  const [roleBasedData, setRoleBasedData] = useState([]);

  var columns = [
    {
      title: "ISIR ID.",
      field: "isirNumber",
      ender: (rowData) => rowData.automatedIsirnumber,
      //render: (rowData) => navigateToComplaintsPage(rowData),
    },

    {
      title: "file Name",
      field: "filename",
      render: (rowData) => rowData.fileName,
    },
    {
      title: "fileurl",
      field: "fileurl",
      render: (rowData) => rowData.fileUrl,
    },
    {
      title: "filetype",
      field: "fileurl",
      render: (rowData) => rowData.filetype,
    },
    {
      title: "attachmentid",
      field: "attachmentid",
      render: (rowData) => rowData.isirattachmentId,
    },
    {
      title: "Release Date",
      field: "targetdate",
      //render: (rowData) => <span>{renderDate(rowData.targetdate)}</span>
    },

    {
      title: "Status",
      field: "status",
    },
  ];

  const [getCheckValues, setGetCheckValues] = useState();
  function getMasterCheckboxD() {
    getCheckboxesDetails(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        console.log("getuploadedmastertypefiles", response);
        setGetCheckValues(response);
        let MasterAttachment = response;
      })
      .catch((error) => {
        console.log(error);
      });
  }
  //DownloadFilemaster1

  useEffect(() => {
    getMasterCheckboxD();
  }, []);

  useEffect(() => {
    console.log("test", test);
    console.log("documentList", documentList);
  });

  //filename from getapi
  const [fileFour, setFileFour] = useState();
  const [fileFive, setFileFive] = useState();
  const [fileSix, setFileSix] = useState();

  const [fileSeven, setFileSeven] = useState();
  const [fileEight, setFileEight] = useState();

  const [file22, setFile22] = useState();
  ///downloadable files url
  const [downloadDocxFifth, setDownloadDocxFifth] = useState("");
  const [downloadDocxSix, setDownloadDocxSix] = useState("");
  const [downloadDocxSeven, setDownloadDocxSeven] = useState("");
  const [downLoadDocx22dfm, setDownloadDocx22dfm] = useState("");
  const [masterType1, setMasterType1] = useState();
  const [masterType2, setMasterType2] = useState();
  const [masterType3, setMasterType3] = useState();
  const [masterType4, setMasterType4] = useState();
  const [masterType5, setMasterType5] = useState();
  const [masterType6, setMasterType6] = useState();

  useEffect(() => {
    dispatch(isIsirPdfuploadedAction(false));
    if (getCheckValues != undefined && getCheckValues?.length > 0) {
      getCheckValues.map((item) => {
        switch (item.masterType) {
          case 5:
            setMasterType5(item.masterType);
            setDownloadDocxFourth(item.fileUrlWithSasToken);
            setFileFour(item.filename);
            dispatch(isIsirPdfuploadedAction(true));
            break;
          case 6:
            setMasterType6(item.masterType);
            setDownloadDocxFourthNew(item.fileUrlWithSasToken);
            setFileEight(item.filename);
            dispatch(isIsirPdfuploadedAction(true));
            break;
          case 1:
            setMasterType1(item.masterType);
            setDownloadDocxFifth(item.fileUrlWithSasToken);
            setFileFive(item.filename);
            break;
          case 3:
            setMasterType3(item.masterType);
            setDownloadDocxSix(item.fileUrlWithSasToken);
            setFileSix(item.filename);
            break;
          case 4:
            setMasterType4(item.masterType);
            setDownloadDocxSeven(item.fileUrlWithSasToken);
            setFileSeven(item.filename); //6
            break;

          case 2:
            setMasterType2(item.masterType);
            setDownloadDocx22dfm(item.fileUrlWithSasToken);
            setFile22(item.filename);
            break;
          default:
        }
      });
    }
  }, [getCheckValues]);

  //DownloadFilemaster1
  // getMasterAttachmentApiData
    function getMasterFileName1() {
    const options = {
      method: "get",
        url: baseApiURL + "/Admin/MasterAttachmentFileName",
        headers: {

            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken.token,
            UserEmail: userDetails.userEmail,
            RoleName: userDetails.role,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            userId: UID.id,
        },

      params: {
          masterid: masterType1,
          userId: userDetails.userId,
      },
    };
    return axios(options)
      .then((response) => {
        let fileName = response.data;

        if (fileName !== "" && fileName) {
          getMastersFileData1(fileName);
        }
        return response.data.result;
      })
      .catch((error) => {
        console.log("Error : ", error);
      });
  }
  function getMastersFileData1(fileName) {
    setIsLoader(true);
    const options = {
        responseType: "arraybuffer",
        headers: {

            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken.token,
            UserEmail: userDetails.userEmail,
            RoleName: userDetails.role,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            userId: UID.id,
        },
    };
    axios
      .get(
        baseURL +
          "/api/Admin/GetMasterAttachmentsBasedOnId?masterid=" +
          masterType1 +
          "&userId=" +
          userDetails.userId,
        options
      )
      .then((response) => {
        setIsLoader(false);
        if (response.status === 200) {
          //let fileNameVar = response.headers["content-disposition"];
          //var regExp = /filename=(.*?)\;/;
          //let fileName = regExp.exec(fileNameVar);
          if (response.data) {
            var blob = new Blob([response.data], {
              type: "application/octet-stream",
            });
            FileSaver.saveAs(blob, fileName !== null ? fileName : "sample");
            setIsLoader(false);
            alert("File downloaded.");
          } else {
            setIsLoader(false);
            alert("No Records are Found");
          }
        } else {
          alert("File Not Found !!");
        }
      })
      .catch((err) => {
        setIsLoader(false);
        alert("Error !!");
      });

    
  }
  function getMasterFileName2() {
    const options = {
      method: "get",
        url: baseApiURL + "/Admin/MasterAttachmentFileName",
        headers: {

            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken.token,
            UserEmail: userDetails.userEmail,
            RoleName: userDetails.role,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            userId: UID.id,
        },

      params: {
        masterid: masterType2,
          userId: userDetails.userId,
      },
    };
    return axios(options)
      .then((response) => {
        let fileName = response.data;

        if (fileName !== "" && fileName) {
          getMastersFileData2(fileName);
        }
        return response.data.result;
      })
      .catch((error) => {
        console.log("Error : ", error);
      });
  }
  function getMastersFileData2(filename) {
    setIsLoader(true);
    const options = {
        responseType: "arraybuffer",
        headers: {

            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken.token,
            UserEmail: userDetails.userEmail,
            RoleName: userDetails.role,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            userId: UID.id,
        },
    };
    axios
      .get(
        baseURL +
          "/api/Admin/GetMasterAttachmentsBasedOnId?masterid=" +
          masterType2 +
          "&userId=" +
          userDetails.userId,
        options
      )
      .then((response) => {
        setIsLoader(false);
        if (response.status === 200) {
          //let fileNameVar = response.headers["content-disposition"];
          //var regExp = /filename=(.*?)\;/;
          //let fileName = regExp.exec(fileNameVar);
          if (response.data) {
            var blob = new Blob([response.data], {
              type: "application/octet-stream",
            });
            FileSaver.saveAs(blob, filename !== null ? filename : "sample");
            setIsLoader(false);
            alert("File downloaded.");
          } else {
            setIsLoader(false);
            alert("No Records are Found");
          }
        } else {
          alert("File Not Found !!");
        }
      })
      .catch((err) => {
        setIsLoader(false);
        alert("Error !!");
      });

    
  }
  function getMasterFileName3() {
    const options = {
      method: "get",
        url: baseApiURL + "/Admin/MasterAttachmentFileName",
        headers: {

            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken.token,
            UserEmail: userDetails.userEmail,
            RoleName: userDetails.role,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            userId: UID.id,
        },

      params: {
        masterid: masterType3,
          userId: userDetails.userId,
      },
    };
    return axios(options)
      .then((response) => {
        let fileName = response.data;

        if (fileName !== "" && fileName) {
          getMastersFileData3(fileName);
        }
        return response.data.result;
      })
      .catch((error) => {
        console.log("Error : ", error);
      });
  }
  function getMastersFileData3(filename) {
    setIsLoader(true);
    const options = {
        responseType: "arraybuffer",
        headers: {

            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken.token,
            UserEmail: userDetails.userEmail,
            RoleName: userDetails.role,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            userId: UID.id,
        },
    };
    axios
      .get(
        baseURL +
          "/api/Admin/GetMasterAttachmentsBasedOnId?masterid=" +
          masterType3 +
          "&userId=" +
          userDetails.userId,
        options
      )
      .then((response) => {
        setIsLoader(false);
        if (response.status === 200) {
          //let fileNameVar = response.headers["content-disposition"];
          //var regExp = /filename=(.*?)\;/;
          //let fileName = regExp.exec(fileNameVar);
          if (response.data) {
            var blob = new Blob([response.data], {
              type: "application/octet-stream",
            });
            FileSaver.saveAs(blob, filename !== null ? filename : "sample");
            setIsLoader(false);
            alert("File downloaded.");
          } else {
            setIsLoader(false);
            alert("No Records are Found");
          }
        } else {
          alert("File Not Found !!");
        }
      })
      .catch((err) => {
        setIsLoader(false);
        alert("Error !!");
      });

    
  }
  function getMasterFileName4() {
    const options = {
      method: "get",
        url: baseApiURL + "/Admin/MasterAttachmentFileName",
        headers: {

            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken.token,
            UserEmail: userDetails.userEmail,
            RoleName: userDetails.role,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            userId: UID.id,
        },

      params: {
        masterid: masterType4,
          userId: userDetails.userId,
      },
    };
    return axios(options)
      .then((response) => {
        let fileName = response.data;

        if (fileName !== "" && fileName) {
          getMastersFileData4(fileName);
        }
        return response.data.result;
      })
      .catch((error) => {
        console.log("Error : ", error);
      });
  }
  function getMastersFileData4(filename) {
    setIsLoader(true);
    const options = {
        responseType: "arraybuffer",
        headers: {

            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken.token,
            UserEmail: userDetails.userEmail,
            RoleName: userDetails.role,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            userId: UID.id,
        },
    };
    axios
      .get(
        baseURL +
          "/api/Admin/GetMasterAttachmentsBasedOnId?masterid=" +
          masterType4 +
          "&userId=" +
          userDetails.userId,
        options
      )
      .then((response) => {
        setIsLoader(false);
        if (response.status === 200) {
          //let fileNameVar = response.headers["content-disposition"];
          //var regExp = /filename=(.*?)\;/;
          //let fileName = regExp.exec(fileNameVar);
          if (response.data) {
            var blob = new Blob([response.data], {
              type: "application/octet-stream",
            });
            FileSaver.saveAs(blob, filename !== null ? filename : "sample");
            setIsLoader(false);
            alert("File downloaded.");
          } else {
            setIsLoader(false);
            alert("No Records are Found");
          }
        } else {
          alert("File Not Found !!");
        }
      })
      .catch((err) => {
        setIsLoader(false);
        alert("Error !!");
      });

    
  }
  function getMasterFileName5() {
    const options = {
      method: "get",
        url: baseApiURL + "/Admin/MasterAttachmentFileName",

        headers: {
          
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken.token,
            UserEmail: userDetails.userEmail,
            RoleName: userDetails.role,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            userId: UID.id,
        },



      params: {
          masterid: masterType5,
          userId: userDetails.userId,
      },
    };
    return axios(options)
      .then((response) => {
        let fileName = response.data;

        if (fileName !== "" && fileName) {
          getMastersFileData5(fileName);
        }
        return response.data.result;
      })
      .catch((error) => {
        console.log("Error : ", error);
      });
  }
  function getMastersFileData5(filename) {
    setIsLoader(true);
    const options = {
        responseType: "arraybuffer",
        headers: {
           
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken.token,
            UserEmail: userDetails.userEmail,
            RoleName: userDetails.role,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            userId: UID.id,
        },
    };
    axios
      .get(
        baseURL +
          "/api/Admin/GetMasterAttachmentsBasedOnId?masterid=" +
          masterType5 +
          "&userId=" +
          userDetails.userId,
        options
      )
      .then((response) => {
        setIsLoader(false);
        if (response.status === 200) {
          //let fileNameVar = response.headers["content-disposition"];
          //var regExp = /filename=(.*?)\;/;
          //let fileName = regExp.exec(fileNameVar);
          if (response.data) {
            var blob = new Blob([response.data], {
              type: "application/octet-stream",
            });
            FileSaver.saveAs(blob, filename !== null ? filename : "sample");
            setIsLoader(false);
            alert("File downloaded.");
          } else {
            setIsLoader(false);
            alert("No Records are Found");
          }
        } else {
          alert("File Not Found !!");
        }
      })
      .catch((err) => {
        setIsLoader(false);
        alert("Error !!");
      });

    
  }

  //  New Added Field Changes
  function getMasterFileName6() {
    const options = {
      method: "get",
        url: baseApiURL + "/Admin/MasterAttachmentFileName",
        headers: {
           
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken.token,
            UserEmail: userDetails.userEmail,
            RoleName: userDetails.role,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            userId: UID.id,
        },


      params: {
        masterid: masterType5,
          userId: userDetails.userId,
      },
    };
    return axios(options)
      .then((response) => {
        let fileName = response.data;

        if (fileName !== "" && fileName) {
          getMastersFileData6(fileName);
        }
        return response.data.result;
      })
      .catch((error) => {
        console.log("Error : ", error);
      });
  }
  function getMastersFileData6(filename) {
    setIsLoader(true);
    const options = {
        responseType: "arraybuffer",
        headers: {
           
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken.token,
            UserEmail: userDetails.userEmail,
            RoleName: userDetails.role,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            userId: UID.id,
        },
    };
    axios
      .get(
        baseURL +
          "/api/Admin/GetMasterAttachmentsBasedOnId?masterid=" +
          masterType6 +
          "&userId=" +
          userDetails.userId,
        options
      )
      .then((response) => {
        setIsLoader(false);
        if (response.status === 200) {
          if (response.data) {
            var blob = new Blob([response.data], {
              type: "application/octet-stream",
            });
            FileSaver.saveAs(blob, filename !== null ? filename : "sample");
            setIsLoader(false);
            alert("File downloaded.");
          } else {
            setIsLoader(false);
            alert("No Records are Found");
          }
        } else {
          alert("File Not Found !!");
        }
      })
      .catch((err) => {
        setIsLoader(false);
        alert("Error !!");
      });
    }



   

  //const [color, setColor] = useState("grey");
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const handleChangeFileASMT = (e) => {
    setDrawingPDF(e.target.value);
  };

  const [tfcdres, setTCFdres] = useState(false); //initially it was "" in useState("")
  const [trmdres, setTRMdres] = useState(false);
  const [ppapdres, setPPAPdres] = useState(false);
  const [dfmdres, setDFMdres] = useState(false);

  const [getisirDetailsData, setGetisirDetailsData] = useState([]);
  function getDetailsForIsir() {
    setIsLoader(true);

    getAllIsirDetails(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        setGetisirDetailsData(response);
        let particularUserDraft = response;
        let getRes = particularUserDraft.filter(
          (item) => item.automatedIsirnumber == prevDataAdd.automatedIsirnumber
        );

        if (getRes?.length === 1) {
          let tfcDraftgetRes = getRes.map((x) => x.tfmcheckbox);

          setTCFdres(tfcDraftgetRes[0]);
          let ppapDraftgetRes = getRes.map((x) => x.ppapcheckbox);
          setPPAPdres(ppapDraftgetRes[0]);
          let trmDraftgetRes = getRes.map((x) => x.trmcheckbox);

          setTRMdres(trmDraftgetRes[0]);
          let dfmDraftgetRes = getRes.map((x) => x.dfmcheckbox);
          setDFMdres(dfmDraftgetRes[0]);
        }

        setIsLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }
  const [tfcPrevD, setTfcPrevD] = useState();

  useEffect(() => {
    getDetailsForIsir();
  }, []);

  const [trmChecked, setTrmChecked] = useState(true);
  const [ppapChecked, setppapChecked] = useState(true);
  const [apqpChecked, setAPQPChecked] = useState(true);
  const [tfcChecked, setTfcChecked] = useState(true);
  const [dfmChecked, setDfmChecked] = useState(true);

  const handleDfmChecked = (e) => {
    setDfmChecked(e.target.checked);
    dispatch(dfmAction(e.target.checked));
  };
  const handleTfcChecked = (e) => {
    setTfcChecked(e.target.checked);

    dispatch(tfcAction(e.target.checked));
  };

  const handlePpapChecked = (e) => {
    setppapChecked(e.target.checked);
    dispatch(ppapAction(e.target.checked));
  };
  const handleAPQPChecked = (e) => {
    setAPQPChecked(e.target.checked);
    dispatch(apqpAction(e.target.checked));
  };
  const handleTrmChecked = (e) => {
    setTrmChecked(e.target.checked);
    dispatch(trmAction(e.target.checked));
  };

  const [uploadedFiles, setUploadedFiles] = useState({});

  const handleFileUpload = (e, documentId) => {
    const file = e.target.files[0];
    setUploadedFiles((prev) => ({
      ...prev,
      [documentId]: file,
    }));
  };

  const isMissingMandatory = (doc) => {
    return doc.isMandatory && !uploadedFiles[doc.documentId];
  };

  const handlefirstfileUpload = (e) => {
    setSelectedFileDept(e.target.files[0]);
  };
  const handleSecondFileupload = (e) => {
    setSelectedFileSecond(e.target.files[0]);
  };
  const handleChangeFileThird = (e) => {
    setSelectedFileThird(e.target.files[0]);
  };
  const handleChangeFileFourth = (e) => {
    setSelectedFileFourth(e.target.files[0]);
  };
  const handleChangeFileFifth = (e) => {
    setSelectedFileFifth(e.target.files[0]);
  };
  const handleChangeFileSix = (e) => {
    setSelectedFileSix(e.target.files[0]);
  };
  const handleChangeFileSeven = (e) => {
    setSelectedFileSeven(e.target.files[0]);
  };
  const handleFile22Dfm = (e) => {
    setSelectedFil122dfm(e.target.files[0]);
  };

  const [getAttchRes, segetAttchRest] = useState([]);

  const handleUploadFileData = (e) => {
    let tabData1 = new FormData();

    tabData1.append("userId", userDetails.userId);
    tabData1.append("AutomatedISIRNumber", isirNumberPassed);
    tabData1.append("fileDrawings", selectedFileDept);

    tabData1.append("file3DStp", selectedFileSecond);
    tabData1.append("fileToolSpecification", selectedFileThird);
    tabData1.append("fileISIRTemplate", selectedFileFourth);
    tabData1.append("fileTFM", selectedFileFifth);
    tabData1.append("fileTRM", selectedFileSix);
    tabData1.append("filePPAP", selectedFileSeven);
    tabData1.append("fileDFM", selectedFil122dfm);
    //tabData1.append("DocumentID", mandatoryDocumentIds);

    setIsLoaderFeedback(true);

    uploadTemplateFileData(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      tabData1
    ).then((response) => {
      if (response.response) {
        const resattch = response.responseAttachments;
        console.log("resattch", resattch);
        segetAttchRest(resattch);
        resattch.map((item) => {
          switch (item.uploadfiletype) {
            case 1:
              //setDownloadDocxFirst(item.fileUrl);
              //dispatch(uploadFileValidationAction(true));
              // console.log("upload1", item.uploadfiletype)
              //setUploadTypeValue1(item.uploadfiletype)

              setFileOne(item.fileName);
              setSelectedFileDept(null);
              document.getElementById("drawingFile").value = "";
              break;
            case 2:
              //setDownloadDocxFirst(item.fileUrl);
              //dispatch(uploadFileValidationAction(true));
              setFileTwo(item.fileName);
              setSelectedFileSecond(null);
              document.getElementById("stpFile").value = "";
              break;
            case 3:
              setFileThree(item.fileName);
              setSelectedFileThird(null);
              document.getElementById("toolFile").value = "";
              //setDownloadDocxFirst(item.fileUrl);
              //dispatch(uploadFileValidationAction(true));
              break;
            default:
          }
        });

        setIsLoaderFeedback(false);

        handleSnackOpen(response.responseMsg, "success");
        dispatch(hideTb1(true));
      } else {
        setIsLoaderFeedback(false);
        handleSnackOpen(response.responseMsg, "error");
      }
      setAttachmentRespence(response.responseAttachments);

      let attachmentResp = response.responseAttachments;
      if (attachmentResp != undefined && attachmentResp?.length > 0) {
        attachmentResp.map((item) => {
          switch (item.uploadfiletype) {
            case 1:
              setDownloadDocxFirst(item.fileUrl);
              dispatch(uploadFileValidationAction(true));
              break;
            case 2:
              setDownloadDocxSecond(item.fileUrl);
              dispatch(is3DUploadedAction(true));
              break;
            case 3:
              setDownloadDocxThird(item.fileUrl);
              dispatch(isToolSpecificationAction(true));
              break;
            default:
          }
        });
      }
    });
  };
  const [uploadTypeValue1, setUploadTypeValue1] = useState();
  const [uploadTypeValue2, setUploadTypeValue2] = useState();
  const [uploadTypeValue3, setUploadTypeValue3] = useState();

  function handleDownloadTb1Data(isirNumberPassed) {
    getuploadedDatainDownLoadFile(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      isirNumberPassed
    )
      .then((response) => {
        setDownloadFileData(response);

        let attachementDatatab1 = response;
        if (
          attachementDatatab1 != undefined &&
          attachementDatatab1?.length > 0
        ) {
          attachementDatatab1.map((item) => {
            switch (item.uploadfiletype) {
              case 1:
                setUploadTypeValue1(item.uploadfiletype);
                //setDownload1Docx(item.fileUrl);
                break;
              case 2:
                setUploadTypeValue2(item.uploadfiletype);
                // setDownload2Docx(item.fileUrl);
                break;
              case 3:
                setUploadTypeValue3(item.uploadfiletype);
                // setDownload3Docx(item.fileUrl);
                break;
              default:
                break;
            }
          });
        }
        // if(name=='nidhi'){
        //   attachementDatatab1.map((item) => {
        //     switch (item.uploadfiletype) {
        //       case 1:
        //         setFileOne(item.fileName);

        //         setDownloadDocxFirst(item.fileUrl);

        //         dispatch(drawingUpload(true));

        //         break;
        //       case 2:
        //         setFileTwo(item.fileName);
        //         setDownloadDocxSecond(item.fileUrl);

        //         dispatch(threeDUpload(true));
        //         break;
        //       case 3:
        //         setFileThree(item.fileName);
        //         setDownloadDocxThird(item.fileUrl);
        //         dispatch(toolSpecificationUpload(true));
        //         break;
        //       case 4:
        //         setFileFour(item.fileName);
        //         setDownloadDocxFourth(item.fileUrl);
        //         dispatch(isirUpload(true));

        //         break;
        //       case 5:
        //         setFileFive(item.fileName);
        //         setDownloadDocxFifth(item.fileUrl);
        //         //dispatch(isIsirPdfuploadedAction(true));
        //         break;
        //       case 6:
        //         setFileSix(item.fileName);
        //         setDownloadDocxSix(item.fileUrl);
        //         dispatch(dfmAction(true));
        //         break;
        //       case 7:
        //         setFileSeven(item.fileName);
        //         setDownloadDocxSeven(item.fileUrl);
        //         dispatch(trmAction(true));
        //         break;
        //       case 22:
        //         setFile22(item.fileName);
        //         setDownloadDocx22dfm(item.fileUrl);
        //         dispatch(ppapAction(true));
        //         break;
        //     }
        //   });
        // }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  function downloadBallon1() {
    //let x = downloadTab2Data.filter((x) => x.uploadfiletype === 8);
    //console.log("x", x);
    let attachmentData = {
      AutomatedIsirnumber: isirNumberPassed,
      Uploadfiletype: uploadTypeValue1,
    };

    window.open(
      baseURL +
        "/ISIRdownloadfile?AutomatedIsirnumber=" +
        isirNumberPassed +
        "& Uploadfiletype=" +
        uploadTypeValue1,
      "_blank"
    );
  }
  function downloadBallontb1sec() {
    //let x = downloadTab2Data.filter((x) => x.uploadfiletype === 8);
    //console.log("x", x);
    let attachmentData = {
      AutomatedIsirnumber: isirNumberPassed,
      Uploadfiletype: uploadTypeValue2,
    };

    window.open(
      baseURL +
        "/ISIRdownloadfile?AutomatedIsirnumber=" +
        isirNumberPassed +
        "& Uploadfiletype=" +
        uploadTypeValue2,
      "_blank"
    );
  }
  function downloadBallontb1third() {
    //let x = downloadTab2Data.filter((x) => x.uploadfiletype === 8);
    //console.log("x", x);
    let attachmentData = {
      AutomatedIsirnumber: isirNumberPassed,
      Uploadfiletype: uploadTypeValue3,
    };

    window.open(
      baseURL +
        "/ISIRdownloadfile?AutomatedIsirnumber=" +
        isirNumberPassed +
        "& Uploadfiletype=" +
        uploadTypeValue3,
      "_blank"
    );
  }
  const [masterData, setMasterData] = useState([]);
  //getMasterAttachmentApiData
  //function getMastersFileData() {

  //    getMasterAttachmentApiData(masterId, userDetails.userId)
  //        .then((response) => {
  //            console.log("masterFiles", response)

  //            //setRdGetRDemail(response);

  //        })
  //        .catch((error) => {
  //            console.log(error);

  //        });
  //};

  useEffect(() => {
    //dispatch(uploadFileValidationAction(false));
    //dispatch(is3DUploadedAction(false));
    ////// dispatch(isIsirPdfuploadedAction(false));

    dispatch(tfcAction(false));
    dispatch(trmAction(false));
    dispatch(dfmAction(false));
    dispatch(ppapAction(false));
    dispatch(hideTb1(false));
    dispatch(drawingUpload(false));
    dispatch(threeDUpload(false));
    // dispatch(toolSpecificationUpload(false));
    dispatch(isirUpload(false));
    if (prevDataAdd) {
      handleDownloadTb1Data(prevDataAdd.automatedIsirnumber);
    } else {
      handleDownloadTb1Data(isirNumberPassed);
    }

    //console.log('')
  }, []);

  const [fileOne, setFileOne] = useState();
  const [fileTwo, setFileTwo] = useState();
  const [fileThree, setFileThree] = useState();

  useEffect(() => {
    console.log("downloadFileData.length:", downloadFileData);
    console.log("getAttchRes.length:", getAttchRes.length);
    dispatch(sqmCheckApqpAction(false));
    //   dispatch(uploadFileValidationAction(false));
    //   dispatch(is3DUploadedAction(false));
    //   ////// dispatch(isIsirPdfuploadedAction(false));

    //   dispatch(tfcAction(false));
    //   dispatch(trmAction(false));
    //   dispatch(dfmAction(false));
    //   dispatch(ppapAction(false));
    //   dispatch(hideTb1(false));
    //   dispatch(drawingUpload(false));
    //   dispatch(threeDUpload(false));
    //  // dispatch(toolSpecificationUpload(false));
    //   dispatch(isirUpload(false));

    downloadFileData.map((item) => {
      switch (item.uploadfiletype) {
        case 1:
          setFileOne(item.fileName);

          setDownloadDocxFirst(item.fileUrl);

          dispatch(drawingUpload(true));

          break;
        case 2:
          setFileTwo(item.fileName);
          setDownloadDocxSecond(item.fileUrl);

          dispatch(threeDUpload(true));
          break;
        case 3:
          setFileThree(item.fileName);
          setDownloadDocxThird(item.fileUrl);
          dispatch(toolSpecificationUpload(true));
          break;
        case 4:
          setFileFour(item.fileName);
          setDownloadDocxFourth(item.fileUrl);
          dispatch(isirUpload(true));

          break;
        case 5:
          setFileFive(item.fileName);
          setDownloadDocxFifth(item.fileUrl);
          //dispatch(isIsirPdfuploadedAction(true));
          break;
        case 6:
          setFileSix(item.fileName);
          setDownloadDocxSix(item.fileUrl);
          dispatch(dfmAction(true));
          break;
        case 7:
          setFileSeven(item.fileName);
          setDownloadDocxSeven(item.fileUrl);
          dispatch(trmAction(true));
          break;
        case 22:
          setFile22(item.fileName);
          setDownloadDocx22dfm(item.fileUrl);
          dispatch(ppapAction(true));
          break;

        case 40:
          if (item.uploadfiletype == 40) {
            dispatch(sqmCheckApqpAction(true));
            break;
          }
      }
    });
  }, [downloadFileData]);

  // History of Files
  const [openFileHistoryDialog, setOpenFileHistoryDialog] = useState(false);
  const [historyTableData, setHistoryTableData] = useState(null);
  const [tableStringContent, setTableStringContent] = useState(null);

  async function fetchFileHistory(uploadFileType) {
    setIsLoader(true);
    const response = await getFileHistory(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      isirNumberPassed,
      uploadFileType
    );
    if (response) {
      if (response !== null && typeof response === "string") {
        setTableStringContent(response);
      } else if (response !== null && typeof response === "object") {
        setHistoryTableData(response);
      } else {
        setTableStringContent("Error in fetching data.");
      }
      setIsLoader(false);
      setOpenFileHistoryDialog(true);
      return response;
    } else {
      setTableStringContent("Error in fetching data.");
      setIsLoader(false);
      setOpenFileHistoryDialog(true);
    }
  }
  const infoIconClick = (uploadType) => {
    const resp = fetchFileHistory(uploadType);
  };
  function closeFileHistoryDialog(event, reason) {
    if (reason === "backdropClick") {
      return;
    }
    setOpenFileHistoryDialog(false);
  }

  function downloadIcon(rowData) {
    let rData = rowData;
    const fileNameLoc = rowData?.fileName?.trim();
    const fileType = rowData?.filetype?.split(".")[1].trim();
    let mimeType;
    switch (fileType.toLowerCase().trim()) {
      case "pdf":
        mimeType = "application/pdf";
        break;
      case "xlsx":
        mimeType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        break;
      case "xls":
        mimeType = "application/vnd.ms-excel";
        break;
      case "csv":
        mimeType = "text/csv";
        break;
      default:
        mimeType = "application/octet-stream";
    }
    function downloadFilesSelected() {
      setIsLoader(true);
      const options = {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: "Bearer " + siteToken.token,
          AzureToken: azureToken.token,
          UserEmail: userDetails.userEmail,
          RoleName: userDetails.role,
          Gid: userDetails.gid,
          Roleid: userDetails.roleId,
          userId: UID.id,
        },
        responseType: "arraybuffer",
      };
      axios
        .get(
          baseApiURLS +
            "/api/Admin/ISIRHistoryDownloadfile?IsirAttachmentId=" +
            rData.isirattachmentId,
          options
        )
        .then((response) => {
          setIsLoader(false);
          if (response.status === 200) {
            if (response.data) {
              var fileBlob = new Blob([response.data], { type: mimeType });
              FileSaver.saveAs(fileBlob, fileNameLoc);
              setIsLoader(false);
              handleSnackOpen("File downloaded.", "success");
            } else {
              setIsLoader(false);
              handleSnackOpen("No Records are Found.", "warning");
            }
          } else {
            setIsLoader(false);
            handleSnackOpen("File Not Found !!", "warning");
          }
        })
        .catch((err) => {
          setIsLoader(false);
          handleSnackOpen("Error !!", "erroe");
        });
    }
    return (
      <IconButton
        className="p-0"
        target="_blank"
        onClick={downloadFilesSelected}
      >
        <GetAppOutlinedIcon />
      </IconButton>
    );
  }

  const columnsNew = [
    {
      title: "Download",
      render: (rowData) => downloadIcon(rowData),
    },
    {
      title: "File Name",
      field: "fileName",
    },
  ];
  const tableHeaderStyle = {
    backgroundColor: "var(--light-sand--type-1)",
    color: "var(--dark-blue)",
  };
  const tableOptionsUser = {
    headerStyle: tableHeaderStyle,
    showTitle: false,
    draggable: false,
    pageSize: 5,
    export: false,
    pageSizeOptions: [5, 10, 25, 50],
    paginationPosition: "bottom",
    maxBodyHeight: "600px",
  };

  // return{
  //   test
  // }

  const isDocumentMandatoryForRole = (docName) => {
    return (
      (userDetails.roleId === 1 ||
        userDetails.roleId === 2 ||
        userDetails.roleId === 6) &&
      documentList?.some(
        (doc) => doc.documentName === docName && doc.isMandatory
      )
    );
  };

  let drawingfileCheck =
    documentList &&
    documentList.some(
      (item) =>
        item.documentId == 1 &&
        item.documentName == "Drawings.pdf" &&
        item.isMandatory == true
    );
  console.log("drawingfileCheck", drawingfileCheck);
  let threeDstpCheck =
    documentList &&
    documentList.some(
      (item) =>
        item.documentId == 2 &&
        item.documentName == "3D.stp/.cdr/.igs (Zip file only!)" &&
        item.isMandatory == true
    );
  console.log("threeDstpCheck", threeDstpCheck);
  let toolSpecificationfileCheck =
    documentList &&
    documentList.some(
      (item) =>
        item.documentId == 3 &&
        item.documentName == "Tool Specification for Tool.docx" &&
        item.isMandatory == true
    );
  console.log("toolSpecificationfileCheck", toolSpecificationfileCheck);

  return (
    <div className="upload-section">
      <SnackbarCustom
        open={open}
        message={snackMessage}
        alertType={alertType}
        handleClose={handleClose}
      />

      <Grid>
        <Grid container spacing={2} className="seperator">
          {/*  <div className={drawingfileCheck ? "show" : "hidden"}>*/}
          {userDetails.roleId === 1 ||
          userDetails.roleId === 6 ||
          userDetails.roleId === 2 ? (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              className={drawingfileCheck ? "spaceremover" : "hidden"}
            >
              {isDocumentMandatoryForRole("Drawings.pdf") && (
                <TextField
                  label={
                    <>
                      Drawings.pdf
                      {(userDetails.roleId === 1 ||
                        userDetails.roleId === 2 ||
                        userDetails.roleId === 6) &&
                        documentList?.some(
                          (z) =>
                            z.documentName === "Drawings.pdf" && z.isMandatory
                        ) &&
                        !selectedFileDept && (
                          <span style={{ color: "red" }}>*</span>
                        )}
                    </>
                  }
                  type="file"
                  id="drawingFile"
                  name="drawingFile"
                  className="label-font"
                  fullWidth
                  key={drawingpdfKey}
                  onChange={handlefirstfileUpload}
                  helperText={firstNameHelperText}
                  disabled={
                    groupData === 3 ||
                    developmentData == 1 ||
                    prevDataAdd.groupId === 3 ||
                    prevDataAdd.developmentTypeId == 1
                  }
                  variant="filled"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    accept: "application/pdf/*",
                    multiple: false,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          className="p-0"
                          target="_blank"
                          href={downloadDocxFirst}
                          disabled={
                            userDetails.roleId === 8 ||
                            userDetails.roleId === 9 ||
                            userDetails.roleId === 10
                              ? true
                              : false
                          }
                        >
                          <CloudDownloadIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                ></TextField>
              )}
              {/* <span className="fname">{fileOne}</span> : " "} */}
              {downloadFileData.length >= 1 || getAttchRes.length > 0 ? (
                <div
                  className="iIconClass"
                  style={{ display: "flex", width: "100%" }}
                >
                  <span className="fname">{fileOne}</span>
                  {isDocumentMandatoryForRole("Drawings.pdf") && (
                    <span style={{ width: "20%", textAlign: "center" }}>
                      <InfoOutlined onClick={() => infoIconClick(1)} />
                    </span>
                  )}
                </div>
              ) : (
                ""
              )}

              {/* <span className="fname">{fileOne}</span> : ""} */}
              {/* {getAttchRes.length > 0 ? (
                <div
                  className="iIconClass"
                  style={{ display: "flex", width: "100%" }}
                >
                  <span className="fname">{fileOne}</span>
                  {isDocumentMandatoryForRole("Drawings.pdf") && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(1)} />
                  </span>
                  )}
                </div>
              ) : (
                ""
              )} */}
            </Grid>
          ) : (developmentData == 2 || prevDataAdd.developmentTypeId == 2) &&
            userDetails.roleId == 3 &&
            uploadTypeValue1 &&
            (groupData == 1 ||
              groupData == 2 ||
              groupData == 4 ||
              groupData == 5 ||
              prevDataAdd.groupId == 1 ||
              prevDataAdd.groupId == 2 ||
              prevDataAdd.groupId == 4 ||
              prevDataAdd.groupId == 5) ? (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              className={drawingfileCheck ? "spaceremover" : "hidden"}
            >
              {" "}
              <button className="link-filed1" onClick={downloadBallon1}>
                Download Drawing.pdf
              </button>
            </Grid>
          ) : (developmentData == 1 || prevDataAdd.developmentTypeId == 1) &&
            userDetails.roleId == 3 &&
            (groupData == 1 ||
              groupData == 2 ||
              groupData == 4 ||
              groupData == 5 ||
              prevDataAdd.groupId == 1 ||
              prevDataAdd.groupId == 2 ||
              prevDataAdd.groupId == 4 ||
              prevDataAdd.groupId == 5) ? (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              className={drawingfileCheck ? "spaceremover" : "hidden"}
            >
              {" "}
              <button className="dis-filed1" disabled>
                Download Drawing.pdf
              </button>
            </Grid>
          ) : (developmentData == 1 ||
              prevDataAdd.developmentTypeId == 1 ||
              prevDataAdd.developmentTypeId == 2 ||
              developmentData == 2) &&
            userDetails.roleId == 3 &&
            (groupData == 3 || prevDataAdd.groupId == 3) ? (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              className={drawingfileCheck ? "spaceremover" : "hidden"}
            >
              {" "}
              <button className="dis-filed1" disabled>
                Download Drawing.pdf
              </button>
            </Grid>
          ) : (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              className={drawingfileCheck ? "spaceremover" : "hidden"}
            >
              {downloadDocxFirst ? (
                <a target="_blank" href={downloadDocxFirst}>
                  <span className="link-filed">Download Drawings</span>
                </a>
              ) : (
                <></>
              )}
            </Grid>
          )}

          {/*  <div className={threeDstpCheck ? "show" : "hidden"}>*/}
          {userDetails.roleId === 1 ||
          userDetails.roleId === 6 ||
          userDetails.roleId === 2 ? (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              className={threeDstpCheck ? "spaceremover" : "hidden"}
            >
              {isDocumentMandatoryForRole(
                "3D.stp/.cdr/.igs (Zip file only!)"
              ) && (
                <TextField
                  // label="3D.stp/.cdr/.igs (Zip file only!)"
                  label={
                    <>
                      3D.stp/.cdr/.igs (Zip file only!)
                      {(userDetails.roleId === 1 ||
                        userDetails.roleId === 2 ||
                        userDetails.roleId === 6) &&
                        documentList?.some(
                          (z) =>
                            z.documentName ===
                              "3D.stp/.cdr/.igs (Zip file only!)" &&
                            z.isMandatory
                        ) &&
                        !selectedFileSecond && (
                          <span style={{ color: "red" }}>*</span>
                        )}
                    </>
                  }
                  type="file"
                  id="stpFile"
                  name="stpFile"
                  disabled={
                    groupData === 3 ||
                    developmentData == 1 ||
                    prevDataAdd.groupId === 3 ||
                    prevDataAdd.developmentTypeId == 1
                  }
                  className=""
                  fullWidth
                  key={secondFileKey}
                  onChange={handleSecondFileupload}
                  variant="filled"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    accept: "application/stp/cdr/igs/*",
                    multiple: false,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          className="p-0"
                          target="_blank"
                          href={downloadDocxSecond}
                        >
                          <CloudDownloadIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                ></TextField>
              )}
              {downloadFileData.length >= 1 || getAttchRes.length > 0 ? (
                <div
                  className="iIconClass"
                  style={{ display: "flex", width: "100%" }}
                >
                  <span className="fname">{fileTwo}</span>
                  {isDocumentMandatoryForRole(
                    "3D.stp/.cdr/.igs (Zip file only!)"
                  ) && (
                    <span style={{ width: "20%", textAlign: "center" }}>
                      <InfoOutlined onClick={() => infoIconClick(2)} />
                    </span>
                  )}
                </div>
              ) : (
                ""
              )}
              {/* <span className="fname">{fileTwo}</span> : " "} */}
              {/* {getAttchRes.length > 0 ? (
                <div
                  className="iIconClass"
                  style={{ display: "flex", width: "100%" }}
                >
                  <span className="fname">{fileTwo}</span>
                  {isDocumentMandatoryForRole("3D.stp/.cdr/.igs (Zip file only!)") && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(2)} />
                  </span>
                  )}
                </div>
              ) : (
                ""
              )} */}
              {/* <span className="fname">{fileTwo}</span> : ""} */}
            </Grid>
          ) : (developmentData == 2 || prevDataAdd.developmentTypeId == 2) &&
            userDetails.roleId == 3 &&
            uploadTypeValue2 &&
            (groupData == 1 ||
              groupData == 2 ||
              groupData == 4 ||
              groupData == 5 ||
              prevDataAdd.groupId == 1 ||
              prevDataAdd.groupId == 2 ||
              prevDataAdd.groupId == 4 ||
              prevDataAdd.groupId == 5) ? (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              className={threeDstpCheck ? "spaceremover" : "hidden"}
            >
              <button className="link-filed1" onClick={downloadBallontb1sec}>
                Download 3D
              </button>
            </Grid>
          ) : (developmentData == 1 || prevDataAdd.developmentTypeId == 1) &&
            userDetails.roleId == 3 &&
            (groupData == 1 ||
              groupData == 2 ||
              groupData == 4 ||
              groupData == 5 ||
              prevDataAdd.groupId == 1 ||
              prevDataAdd.groupId == 2 ||
              prevDataAdd.groupId == 4 ||
              prevDataAdd.groupId == 5) ? (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              className={threeDstpCheck ? "spaceremover" : "hidden"}
            >
              <button className="dis-filed1" disabled>
                Download 3D
              </button>
            </Grid>
          ) : (developmentData == 1 ||
              prevDataAdd.developmentTypeId == 1 ||
              developmentData == 2 ||
              prevDataAdd.developmentTypeId == 2) &&
            userDetails.roleId == 3 &&
            (groupData == 3 || prevDataAdd.groupId == 3) ? (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              className={threeDstpCheck ? "spaceremover" : "hidden"}
            >
              <button className="dis-filed1" disabled>
                Download 3D
              </button>
            </Grid>
          ) : (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              className={threeDstpCheck ? "spaceremover" : "hidden"}
            >
              {downloadDocxSecond ? (
                <a target="_blank" href={downloadDocxSecond}>
                  <span className="link-filed">Download 3D</span>
                </a>
              ) : (
                <></>
              )}
            </Grid>
          )}

          {/*        <Grid item xs={12} sm={6} md={4} className={drawingfileCheck ? "show" : "hidden"}>*/}
          {/*{userDetails.roleId === 1 ||*/}
          {/*userDetails.roleId === 6 ||*/}
          {/*userDetails.roleId === 2 ? (*/}
          {/*                    <Grid item xs={12} sm={6} md={4}>*/}
          {/*    {isDocumentMandatoryForRole("Drawings.pdf")  && (*/}
          {/*      <TextField*/}
          {/*        label={*/}
          {/*          <>*/}
          {/*            Drawings.pdf*/}
          {/*            {(userDetails.roleId === 1 ||*/}
          {/*              userDetails.roleId === 2 ||*/}
          {/*              userDetails.roleId === 6) &&*/}
          {/*              documentList?.some(*/}
          {/*                (z) =>*/}
          {/*                  z.documentName === "Drawings.pdf" && z.isMandatory*/}
          {/*              ) &&*/}
          {/*              !selectedFileDept && (*/}
          {/*                <span style={{ color: "red" }}>*</span>*/}
          {/*              )}*/}
          {/*          </>*/}
          {/*        }*/}
          {/*        type="file"*/}
          {/*        id="drawingFile"*/}
          {/*        name="drawingFile"*/}
          {/*        className="label-font"*/}
          {/*        fullWidth*/}
          {/*        key={drawingpdfKey}*/}
          {/*        onChange={handlefirstfileUpload}*/}
          {/*        helperText={firstNameHelperText}*/}
          {/*        disabled={*/}
          {/*          groupData === 3 ||*/}
          {/*          developmentData == 1 ||*/}
          {/*          prevDataAdd.groupId === 3 ||*/}
          {/*          prevDataAdd.developmentTypeId == 1*/}
          {/*        }*/}
          {/*        variant="filled"*/}
          {/*        InputLabelProps={{ shrink: true }}*/}
          {/*        InputProps={{*/}
          {/*          accept: "application/pdf/*",*/}
          {/*          multiple: false,*/}
          {/*          endAdornment: (*/}
          {/*            <InputAdornment position="end">*/}
          {/*              <IconButton*/}
          {/*                aria-label="toggle password visibility"*/}
          {/*                className="p-0"*/}
          {/*                target="_blank"*/}
          {/*                href={downloadDocxFirst}*/}
          {/*                disabled={*/}
          {/*                  userDetails.roleId === 8 ||*/}
          {/*                  userDetails.roleId === 9 ||*/}
          {/*                  userDetails.roleId === 10*/}
          {/*                    ? true*/}
          {/*                    : false*/}
          {/*                }*/}
          {/*              >*/}
          {/*                <CloudDownloadIcon />*/}
          {/*              </IconButton>*/}
          {/*            </InputAdornment>*/}
          {/*          ),*/}
          {/*        }}*/}
          {/*      ></TextField>*/}
          {/*    )}*/}
          {/*    */}
          {/* <span className="fname">{fileOne}</span> : " "} */}
          {/*    {downloadFileData.length >= 1 || getAttchRes.length > 0 ? (*/}
          {/*      <div*/}
          {/*        className="iIconClass"*/}
          {/*        style={{ display: "flex", width: "100%" }}*/}
          {/*      >*/}
          {/*        <span className="fname">{fileOne}</span>*/}
          {/*        {isDocumentMandatoryForRole("Drawings.pdf") && (*/}
          {/*        <span style={{ width: "20%", textAlign: "center" }}>*/}
          {/*          <InfoOutlined onClick={() => infoIconClick(1)} />*/}
          {/*        </span>*/}
          {/*        )}*/}
          {/*      </div>*/}
          {/*    ) : (*/}
          {/*      ""*/}
          {/*    )}*/}

          {/*    */}
          {/* <span className="fname">{fileOne}</span> : ""} */}
          {/*    */}
          {/* {getAttchRes.length > 0 ? (*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*      <div*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*        className="iIconClass"*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*        style={{ display: "flex", width: "100%" }}*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*      >*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*        <span className="fname">{fileOne}</span>*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*        {isDocumentMandatoryForRole("Drawings.pdf") && (*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*        <span style={{ width: "20%", textAlign: "center" }}>*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*          <InfoOutlined onClick={() => infoIconClick(1)} />*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*        </span>*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*        )}*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*      </div>*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*    ) : (*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*      ""*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*    )} */}
          {/*  </Grid>*/}
          {/*) : (developmentData == 2 || prevDataAdd.developmentTypeId == 2) &&*/}
          {/*  userDetails.roleId == 3 &&*/}
          {/*  uploadTypeValue1 &&*/}
          {/*  (groupData == 1 ||*/}
          {/*    groupData == 2 ||*/}
          {/*    groupData == 4 ||*/}
          {/*    groupData == 5 ||*/}
          {/*    prevDataAdd.groupId == 1 ||*/}
          {/*    prevDataAdd.groupId == 2 ||*/}
          {/*    prevDataAdd.groupId == 4 ||*/}
          {/*    prevDataAdd.groupId == 5) ? (*/}
          {/*  <Grid item xs={12} sm={6} md={4}>*/}
          {/*    {" "}*/}
          {/*    <button className="link-filed1" onClick={downloadBallon1}>*/}
          {/*      Download Drawing.pdf*/}
          {/*    </button>*/}
          {/*  </Grid>*/}
          {/*) : (developmentData == 1 || prevDataAdd.developmentTypeId == 1) &&*/}
          {/*  userDetails.roleId == 3 &&*/}
          {/*  (groupData == 1 ||*/}
          {/*    groupData == 2 ||*/}
          {/*    groupData == 4 ||*/}
          {/*    groupData == 5 ||*/}
          {/*    prevDataAdd.groupId == 1 ||*/}
          {/*    prevDataAdd.groupId == 2 ||*/}
          {/*    prevDataAdd.groupId == 4 ||*/}
          {/*    prevDataAdd.groupId == 5) ? (*/}
          {/*                            <Grid item xs={12} sm={6} md={4}>*/}
          {/*    {" "}*/}
          {/*    <button className="dis-filed1" disabled>*/}
          {/*      Download Drawing.pdf*/}
          {/*    </button>*/}
          {/*  </Grid>*/}
          {/*) : (developmentData == 1 ||*/}
          {/*    prevDataAdd.developmentTypeId == 1 ||*/}
          {/*    prevDataAdd.developmentTypeId == 2 ||*/}
          {/*    developmentData == 2) &&*/}
          {/*  userDetails.roleId == 3 &&*/}
          {/*  (groupData == 3 || prevDataAdd.groupId == 3) ? (*/}
          {/*  <Grid item xs={12} sm={6} md={4}>*/}
          {/*    {" "}*/}
          {/*    <button className="dis-filed1" disabled>*/}
          {/*      Download Drawing.pdf*/}
          {/*    </button>*/}
          {/*  </Grid>*/}
          {/*) : (*/}
          {/*  <Grid item xs={12} sm={6} md={4}>*/}
          {/*    {downloadDocxFirst ? (*/}
          {/*      <a target="_blank" href={downloadDocxFirst}>*/}
          {/*        <span className="link-filed">Download Drawings</span>*/}
          {/*      </a>*/}
          {/*    ) : (*/}
          {/*      <></>*/}
          {/*    )}*/}
          {/*  </Grid>*/}
          {/*)}*/}
          {/*        </Grid>*/}

          {/*        <Grid item xs={12} sm={6} md={4} className={threeDstpCheck ? "show" : "hidden"}>*/}
          {/*{userDetails.roleId === 1 ||*/}
          {/*userDetails.roleId === 6 ||*/}
          {/*userDetails.roleId === 2 ? (*/}
          {/*  <Grid item xs={12} sm={6} md={4}>*/}
          {/*     {isDocumentMandatoryForRole("3D.stp/.cdr/.igs (Zip file only!)") && (*/}
          {/*    <TextField*/}
          {/*      // label="3D.stp/.cdr/.igs (Zip file only!)"*/}
          {/*      label={*/}
          {/*        <>*/}
          {/*          3D.stp/.cdr/.igs (Zip file only!)*/}
          {/*          {(userDetails.roleId === 1 ||*/}
          {/*            userDetails.roleId === 2 ||*/}
          {/*            userDetails.roleId === 6) &&*/}
          {/*            documentList?.some(*/}
          {/*              (z) =>*/}
          {/*                z.documentName ===*/}
          {/*                  "3D.stp/.cdr/.igs (Zip file only!)" && z.isMandatory*/}
          {/*            ) &&*/}
          {/*            !selectedFileSecond && (*/}
          {/*              <span style={{ color: "red" }}>*</span>*/}
          {/*            )}*/}
          {/*        </>*/}
          {/*      }*/}
          {/*      type="file"*/}
          {/*      id="stpFile"*/}
          {/*      name="stpFile"*/}
          {/*      disabled={*/}
          {/*        groupData === 3 ||*/}
          {/*        developmentData == 1 ||*/}
          {/*        prevDataAdd.groupId === 3 ||*/}
          {/*        prevDataAdd.developmentTypeId == 1*/}
          {/*      }*/}
          {/*      className=""*/}
          {/*      fullWidth*/}
          {/*      key={secondFileKey}*/}
          {/*      onChange={handleSecondFileupload}*/}
          {/*      variant="filled"*/}
          {/*      InputLabelProps={{ shrink: true }}*/}
          {/*      InputProps={{*/}
          {/*        accept: "application/stp/cdr/igs/*",*/}
          {/*        multiple: false,*/}
          {/*        endAdornment: (*/}
          {/*          <InputAdornment position="end">*/}
          {/*            <IconButton*/}
          {/*              aria-label="toggle password visibility"*/}
          {/*              className="p-0"*/}
          {/*              target="_blank"*/}
          {/*              href={downloadDocxSecond}*/}
          {/*            >*/}
          {/*              <CloudDownloadIcon />*/}
          {/*            </IconButton>*/}
          {/*          </InputAdornment>*/}
          {/*        ),*/}
          {/*      }}*/}
          {/*    ></TextField>*/}
          {/*     )}*/}
          {/*    {downloadFileData.length >= 1 || getAttchRes.length > 0 ? (*/}
          {/*      <div*/}
          {/*        className="iIconClass"*/}
          {/*        style={{ display: "flex", width: "100%" }}*/}
          {/*      >*/}
          {/*        <span className="fname">{fileTwo}</span>*/}
          {/*        {isDocumentMandatoryForRole("3D.stp/.cdr/.igs (Zip file only!)") && (*/}
          {/*        <span style={{ width: "20%", textAlign: "center" }}>*/}
          {/*          <InfoOutlined onClick={() => infoIconClick(2)} />*/}
          {/*        </span>*/}
          {/*        )}*/}
          {/*      </div>*/}
          {/*    ) : (*/}
          {/*      ""*/}
          {/*    )}*/}
          {/*    */}
          {/* <span className="fname">{fileTwo}</span> : " "} */}
          {/*    */}
          {/* {getAttchRes.length > 0 ? (*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*      <div*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*        className="iIconClass"*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*        style={{ display: "flex", width: "100%" }}*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*      >*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*        <span className="fname">{fileTwo}</span>*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*        {isDocumentMandatoryForRole("3D.stp/.cdr/.igs (Zip file only!)") && (*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*        <span style={{ width: "20%", textAlign: "center" }}>*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*          <InfoOutlined onClick={() => infoIconClick(2)} />*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*        </span>*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*        )}*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*      </div>*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*    ) : (*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*      ""*/}
          {/**/}
          {/*
           */}
          {/**/}
          {/*    )} */}
          {/*    */}
          {/* <span className="fname">{fileTwo}</span> : ""} */}
          {/*  </Grid>*/}
          {/*) : (developmentData == 2 || prevDataAdd.developmentTypeId == 2) &&*/}
          {/*  userDetails.roleId == 3 &&*/}
          {/*  uploadTypeValue2 &&*/}
          {/*  (groupData == 1 ||*/}
          {/*    groupData == 2 ||*/}
          {/*    groupData == 4 ||*/}
          {/*    groupData == 5 ||*/}
          {/*    prevDataAdd.groupId == 1 ||*/}
          {/*    prevDataAdd.groupId == 2 ||*/}
          {/*    prevDataAdd.groupId == 4 ||*/}
          {/*    prevDataAdd.groupId == 5) ? (*/}
          {/*  <Grid item xs={12} sm={6} md={4}>*/}
          {/*    <button className="link-filed1" onClick={downloadBallontb1sec}>*/}
          {/*      Download 3D*/}
          {/*    </button>*/}
          {/*  </Grid>*/}
          {/*) : (developmentData == 1 || prevDataAdd.developmentTypeId == 1) &&*/}
          {/*  userDetails.roleId == 3 &&*/}
          {/*  (groupData == 1 ||*/}
          {/*    groupData == 2 ||*/}
          {/*    groupData == 4 ||*/}
          {/*    groupData == 5 ||*/}
          {/*    prevDataAdd.groupId == 1 ||*/}
          {/*    prevDataAdd.groupId == 2 ||*/}
          {/*    prevDataAdd.groupId == 4 ||*/}
          {/*    prevDataAdd.groupId == 5) ? (*/}
          {/*  <Grid item xs={12} sm={6} md={4}>*/}
          {/*    <button className="dis-filed1" disabled>*/}
          {/*      Download 3D*/}
          {/*    </button>*/}
          {/*  </Grid>*/}
          {/*) : (developmentData == 1 ||*/}
          {/*    prevDataAdd.developmentTypeId == 1 ||*/}
          {/*    developmentData == 2 ||*/}
          {/*    prevDataAdd.developmentTypeId == 2) &&*/}
          {/*  userDetails.roleId == 3 &&*/}
          {/*  (groupData == 3 || prevDataAdd.groupId == 3) ? (*/}
          {/*  <Grid item xs={12} sm={6} md={4}>*/}
          {/*    <button className="dis-filed1" disabled>*/}
          {/*      Download 3D*/}
          {/*    </button>*/}
          {/*  </Grid>*/}
          {/*) : (*/}
          {/*  <Grid item xs={12} sm={6} md={4}>*/}
          {/*    {downloadDocxSecond ? (*/}
          {/*      <a target="_blank" href={downloadDocxSecond}>*/}
          {/*        <span className="link-filed">Download 3D</span>*/}
          {/*      </a>*/}
          {/*    ) : (*/}
          {/*      <></>*/}
          {/*    )}*/}
          {/*  </Grid>*/}
          {/*            )}*/}
          {/*</Grid>*/}

          {/*   <Grid item xs={12} sm={2} md={4} className={toolSpecificationfileCheck ? "show" : "hidden"}>*/}
          {userDetails.roleId === 1 ||
          userDetails.roleId === 6 ||
          userDetails.roleId === 2 ? (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              className={toolSpecificationfileCheck ? "spaceremover" : "hidden"}
            >
              {isDocumentMandatoryForRole(
                "Tool Specification for Tool.docx"
              ) && (
                <TextField
                  label={
                    <>
                      Tool Specification for Tool.docx
                      {(userDetails.roleId === 1 ||
                        userDetails.roleId === 2 ||
                        userDetails.roleId === 6) &&
                        documentList?.some(
                          (z) =>
                            z.documentName ===
                              "Tool Specification for Tool.docx" &&
                            z.isMandatory &&
                            !selectedFileThird
                        ) && <span style={{ color: "red" }}>*</span>}
                    </>
                  }
                  type="file"
                  id="toolFile"
                  name="toolFile"
                  className=""
                  fullWidth
                  disabled={
                    groupData === 3 ||
                    developmentData == 1 ||
                    prevDataAdd.groupId === 3 ||
                    prevDataAdd.developmentTypeId == 1
                  }
                  key={thirdFileKey}
                  onChange={handleChangeFileThird}
                  variant="filled"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    accept: ".doc,.docx,application/.document/*",
                    multiple: false,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          className="p-0"
                          target="_blank"
                          href={downloadDocxThird}
                        >
                          <CloudDownloadIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                ></TextField>
              )}
              {/* <span className="fname">{fileThree}</span> : " "} */}
              {downloadFileData.length >= 1 || getAttchRes.length > 0 ? (
                <div
                  className="iIconClass"
                  style={{ display: "flex", width: "100%" }}
                >
                  <span className="fname">{fileThree}</span>
                  {isDocumentMandatoryForRole(
                    "Tool Specification for Tool.docx"
                  ) && (
                    <span style={{ width: "20%", textAlign: "center" }}>
                      <InfoOutlined onClick={() => infoIconClick(3)} />
                    </span>
                  )}
                </div>
              ) : (
                ""
              )}

              {/* {getAttchRes.length > 0 ? (
                <div
                  className="iIconClass"
                  style={{ display: "flex", width: "100%" }}
                >
                  <span className="fname">{fileThree}</span>
                  {isDocumentMandatoryForRole("Tool Specification for Tool.docx") && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(3)} />
                  </span>
                  )}
                </div>
              ) : (
                ""
              )} */}
              {/* <span className="fname">{fileThree}</span> : ""} */}
            </Grid>
          ) : (developmentData == 2 || prevDataAdd.developmentTypeId == 2) &&
            userDetails.roleId == 3 &&
            uploadTypeValue3 &&
            (groupData == 1 ||
              groupData == 2 ||
              groupData == 4 ||
              groupData == 5 ||
              prevDataAdd.groupId == 1 ||
              prevDataAdd.groupId == 2 ||
              prevDataAdd.groupId == 4 ||
              prevDataAdd.groupId == 5) ? (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              className={toolSpecificationfileCheck ? "spaceremover" : "hidden"}
            >
              {" "}
              <button className="link-filed1" onClick={downloadBallontb1third}>
                Download Tool Specification
              </button>
            </Grid>
          ) : (developmentData == 1 || prevDataAdd.developmentTypeId == 1) &&
            userDetails.roleId == 3 &&
            (groupData == 1 ||
              groupData == 2 ||
              groupData == 4 ||
              groupData == 5 ||
              prevDataAdd.groupId == 1 ||
              prevDataAdd.groupId == 2 ||
              prevDataAdd.groupId == 4 ||
              prevDataAdd.groupId == 5) ? (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              className={toolSpecificationfileCheck ? "spaceremover" : "hidden"}
            >
              {" "}
              <button className="dis-filed1" disabled>
                Download Tool Specification
              </button>
            </Grid>
          ) : (developmentData == 1 ||
              prevDataAdd.developmentTypeId == 1 ||
              developmentData == 2 ||
              prevDataAdd.developmentTypeId == 2) &&
            userDetails.roleId == 3 &&
            (groupData == 3 || prevDataAdd.groupId == 3) ? (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              className={toolSpecificationfileCheck ? "spaceremover" : "hidden"}
            >
              {" "}
              <button className="dis-filed1" disabled>
                Download Tool Specification
              </button>
            </Grid>
          ) : (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              className={toolSpecificationfileCheck ? "spaceremover" : "hidden"}
            >
              {downloadDocxThird ? (
                <a target="_blank" href={downloadDocxThird}>
                  <span className="link-filed">
                    Download Tool Specification
                  </span>
                </a>
              ) : (
                <></>
              )}
            </Grid>
          )}
        </Grid>
        {/* </Grid>*/}

        <Grid container spacing={2} className="supplier-fields">
          {userDetails.roleId === 1 ||
          userDetails.roleId === 6 ||
          userDetails.roleId === 2 ? (
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="ISIR Template"
                // label={ <>
                //   ISIR Template
                //   {
                //     isirDocumentList?.filter(z =>
                //       z.documentName == 'ISIR Template' &&
                //       z.isMandatory
                //     ).length > 0 &&
                //     // file uploaded nahi hui
                //     (<span style={{ color: "red" }}>*</span>)
                //   }
                // </>}
                type="file"
                id="desiredOPInKW"
                name="desiredOPInKW"
                className=""
                fullWidth
                // disabled={groupData === 3 || developmentData == 1 || prevDataAdd.groupId === 3 || prevDataAdd.developmentTypeId == 1}
                disabled
                key={fourthFileKey}
                onChange={handleChangeFileFourth}
                variant="filled"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className="p-0"
                        target="_blank"
                        href={downloadDocxFourth}
                        disabled={
                          groupData === 3 ||
                          developmentData == 1 ||
                          prevDataAdd.groupId === 3 ||
                          prevDataAdd.developmentTypeId == 1
                        }
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextField>
              {fileFour ? <span className="fname">{fileFour}</span> : " "}{" "}
              {/*//disabled={true}*/}
            </Grid>
          ) : (
            <Grid item xs={12} sm={6} md={4}>
              {/* {(groupData == 3 || prevDataAdd.groupId == 3 || developmentData == 1 || prevDataAdd.developmentTypeId == 1 ||  userDetails.roleId == 8 || userDetails.roleId == 9 || userDetails.roleId == 10) ? <a><span className="link-filed"><button className="disabled-link" disabled>Download ISIR template</button></span></a> : <a target="_blank" href={downloadDocxFourth}><span className="link-filed">Download ISIR template</span></a>}*/}
              {/* {downloadDocxFourth ? <a target="_blank"  href={downloadDocxFourth}><span className="link-filed">Download ISIR template</span></a> : <></>}*/}
              {(groupData == 3 || prevDataAdd.groupId == 3) &&
              (userDetails.roleId == 7 ||
                userDetails.roleId == 8 ||
                userDetails.roleId == 9 ||
                userDetails.roleId == 10) ? (
                <a>
                  <span className="link-filed">
                    <button className="disabled-link" disabled>
                      Download ISIR template
                    </button>
                  </span>
                </a>
              ) : userDetails.roleId === 3 ? (
                <button className="link-filed1" onClick={getMasterFileName5}>
                  Download ISIR
                </button>
              ) : (developmentData == 2 ||
                  prevDataAdd.developmentTypeId == 2) &&
                (userDetails.roleId == 3 || userDetails.roleId == 7) &&
                (groupData == 1 ||
                  groupData == 2 ||
                  groupData == 4 ||
                  groupData == 5 ||
                  prevDataAdd.groupId == 1 ||
                  prevDataAdd.groupId == 2 ||
                  prevDataAdd.groupId == 4 ||
                  prevDataAdd.groupId == 5) ? (
                <a target="_blank" href={downloadDocxFourth}>
                  <span className="link-filed">Download ISIR template</span>
                </a>
              ) : (
                <a>
                  <span className="link-filed">
                    <button className="disabled-link" disabled>
                      Download ISIR Template
                    </button>
                  </span>
                </a>
              )}
            </Grid>
          )}

          {userDetails.roleId === 1 ||
          userDetails.roleId === 6 ||
          userDetails.roleId === 2 ? (
            <Grid item xs={12} sm={6} md={4}>
              {" "}
              {/* className="check-box"*/}
              <Grid className="check-box">
                {" "}
                <TextField
                  label="TFC"
                  // label={ <>
                  //   TFC
                  //   {
                  //     isirDocumentList?.filter(z =>
                  //       z.documentName == 'TFC' &&
                  //       z.isMandatory
                  //     ).length > 0 &&
                  //     // file uploaded nahi hui
                  //     (<span style={{ color: "red" }}>*</span>)
                  //   }
                  // </>}
                  type="file"
                  id="desiredOPInKW"
                  name="desiredOPInKW"
                  // disabled={groupData === 3 || developmentData == 1 || prevDataAdd.groupId === 3 || prevDataAdd.developmentTypeId == 1}
                  disabled
                  className=""
                  fullWidth
                  key={fifthFileKey}
                  onChange={handleChangeFileFifth}
                  variant="filled"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          className="p-0"
                          target="_blank"
                          href={downloadDocxFifth}
                          disabled={
                            groupData === 3 ||
                            developmentData == 1 ||
                            prevDataAdd.groupId === 3 ||
                            prevDataAdd.developmentTypeId == 1
                          }
                        >
                          <CloudDownloadIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                ></TextField>
                <input
                  className="hide-hidden"
                  type="checkbox"
                  label="TFC"
                  checked={tfcChecked}
                  onChange={handleTfcChecked}
                />
              </Grid>
              <h6>
                {fileFive ? <span className="fname">{fileFive}</span> : " "}
              </h6>
            </Grid>
          ) : (
            <Grid item xs={12} sm={6} md={4}>
              {groupData == 3 ||
              prevDataAdd.groupId == 3 ||
              developmentData == 1 ||
              prevDataAdd.developmentTypeId == 1 ||
              userDetails.roleId == 8 ||
              userDetails.roleId == 9 ||
              userDetails.roleId == 10 ? (
                <a>
                  <span className="link-filed">
                    <button className="disabled-link" disabled>
                      Download TFC Template
                    </button>
                  </span>
                </a>
              ) : userDetails.roleId === 3 &&
                userDetails.locationName !== "Puducherry" ? (
                <button className="link-filed1" onClick={getMasterFileName1}>
                  Download TFC Template
                </button>
              ) : userDetails.roleId === 3 &&
                userDetails.locationName === "Puducherry" ? (
                // If roleId 3 and location is Puducherry, don't show the button
                <></>
              ) : (
                <a target="_blank" href={downloadDocxFifth}>
                  <span className="link-filed">Download TFC Template</span>
                </a>
              )}
              {/*  {downloadDocxFifth ? <a target="_blank"  href={downloadDocxFifth}><span className="link-filed">Download TFC</span></a> : <a href={" "}><span className="link-filed"><button className="disabled-link" disabled>Download TFC</button></span></a>}*/}
            </Grid>
          )}

          {userDetails.roleId === 1 ||
          userDetails.roleId === 6 ||
          userDetails.roleId === 2 ? (
            <Grid item xs={12} sm={6} md={4}>
              <Grid className="check-box">
                {" "}
                <TextField
                  label="DFM"
                  type="file"
                  id="dfmdesiredOPInKW"
                  name="dfmdesiredOPInKW"
                  disabled
                  // disabled={
                  //   groupData === 3 ||
                  //   developmentData == 1 ||
                  //   prevDataAdd.groupId === 3 ||
                  //   prevDataAdd.developmentTypeId == 1
                  // }
                  className=""
                  fullWidth
                  key={dfm22FileKey}
                  onChange={handleFile22Dfm}
                  variant="filled"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          className="p-0"
                          target="_blank"
                          href={downLoadDocx22dfm}
                          disabled={
                            groupData === 3 ||
                            developmentData == 1 ||
                            prevDataAdd.groupId === 3 ||
                            prevDataAdd.developmentTypeId == 1
                          }
                        >
                          <CloudDownloadIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                ></TextField>
                <input
                  className="hide-hidden"
                  type="checkbox"
                  label="DFM"
                  checked={dfmChecked}
                  onChange={handleDfmChecked}
                />
              </Grid>

              <h6>{file22 ? <span className="fname">{file22}</span> : " "}</h6>
            </Grid>
          ) : (
            <Grid item xs={12} sm={6} md={4}>
              {groupData == 3 ||
              prevDataAdd.groupId == 3 ||
              developmentData == 1 ||
              prevDataAdd.developmentTypeId == 1 ||
              userDetails.roleId == 8 ||
              userDetails.roleId == 9 ||
              userDetails.roleId == 10 ? (
                <a>
                  <span className="link-filed">
                    <button className="disabled-link" disabled>
                      Download DFM Template
                    </button>
                  </span>
                </a>
              ) : userDetails.roleId === 3 &&
                userDetails.locationName !== "Puducherry" ? (
                <button className="link-filed1" onClick={getMasterFileName2}>
                  Download DFM Template
                </button>
              ) : userDetails.roleId === 3 &&
                userDetails.locationName === "Puducherry" ? (
                // If roleId 3 and location is Puducherry, don't show the button
                <></>
              ) : (
                <a target="_blank" href={downLoadDocx22dfm}>
                  <span className="link-filed">Download DFM Template</span>
                </a>
              )}
              {/*{downLoadDocx22dfm ? <a target="_blank" href={downLoadDocx22dfm}><span className="link-filed">Download DFM template</span></a> : <a href={" "}><span className="link-filed"><button className="disabled-link" disabled>Download DFM template</button></span></a>}*/}
            </Grid>
          )}

          {userDetails.roleId === 1 ||
          userDetails.roleId === 6 ||
          userDetails.roleId === 2 ? (
            <Grid item xs={12} sm={6} md={4}>
              <Grid className="check-box">
                <TextField
                  label="TRM"
                  type="file"
                  id="desiredOPInKW"
                  name="desiredOPInKW"
                  className=""
                  fullWidth
                  disabled
                  // disabled={
                  //   groupData === 3 ||
                  //   developmentData == 1 ||
                  //   prevDataAdd.groupId === 3 ||
                  //   prevDataAdd.developmentTypeId == 1
                  // }
                  key={sixFileKey}
                  onChange={handleChangeFileSix}
                  variant="filled"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          className="p-0"
                          target="_blank"
                          href={downloadDocxSix}
                          disabled={
                            groupData === 3 ||
                            developmentData == 1 ||
                            prevDataAdd.groupId === 3 ||
                            prevDataAdd.developmentTypeId == 1
                          }
                        >
                          <CloudDownloadIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                ></TextField>

                <input
                  className="hide-hidden"
                  type="checkbox"
                  label="Trm"
                  checked={trmChecked}
                  onChange={handleTrmChecked}
                />
              </Grid>
              <h6>
                {fileSix ? <span className="fname">{fileSix}</span> : " "}
              </h6>
            </Grid>
          ) : (
            <Grid item xs={12} sm={6} md={4}>
              {groupData == 3 ||
              prevDataAdd.groupId == 3 ||
              developmentData == 1 ||
              prevDataAdd.developmentTypeId == 1 ||
              userDetails.roleId == 8 ||
              userDetails.roleId == 9 ||
              userDetails.roleId == 10 ? (
                <a>
                  <span className="link-filed">
                    <button className="disabled-link" disabled>
                      Download TRM Template
                    </button>
                  </span>
                </a>
              ) : userDetails.roleId === 3 &&
                userDetails.locationName !== "Puducherry" ? (
                <button className="link-filed1" onClick={getMasterFileName3}>
                  Download TRM Template
                </button>
              ) : userDetails.roleId === 3 &&
                userDetails.locationName === "Puducherry" ? (
                // If roleId 3 and location is Puducherry, don't show the button
                <></>
              ) : (
                <a target="_blank" href={downloadDocxSix}>
                  <span className="link-filed">Download TRM Template</span>
                </a>
              )}
              {/*{downloadDocxSix ? <a target="_blank" href={downloadDocxSix}><span className="link-filed">Download TRM template</span></a> : <a href={" "}><span className="link-filed"><button className="disabled-link" disabled>Download TRM template</button></span></a>}*/}
            </Grid>
          )}

          {userDetails.roleId === 1 ||
          userDetails.roleId === 6 ||
          userDetails.roleId === 2 ? (
            <Grid item xs={12} sm={6} md={4}>
              <Grid className="check-box">
                <TextField
                  label="PPAP"
                  type="file"
                  id="desiredOPInKW"
                  name="desiredOPInKW"
                  className=""
                  fullWidth
                  // disabled={
                  //   groupData === 3 ||
                  //   developmentData == 1 ||
                  //   prevDataAdd.groupId === 3 ||
                  //   prevDataAdd.developmentTypeId == 1
                  // }
                  disabled
                  key={sevenFileKey}
                  onChange={handleChangeFileSeven}
                  variant="filled"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          className="p-0"
                          target="_blank"
                          href={downloadDocxSeven}
                          disabled={
                            groupData === 3 ||
                            developmentData == 1 ||
                            prevDataAdd.groupId === 3 ||
                            prevDataAdd.developmentTypeId == 1
                          }
                        >
                          <CloudDownloadIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                ></TextField>

                <input
                  className="hide-hidden"
                  type="checkbox"
                  label="PPAP"
                  checked={ppapChecked}
                  onChange={handlePpapChecked}
                />
              </Grid>

              <h6>
                {fileSeven ? <span className="fname">{fileSeven}</span> : " "}
              </h6>
            </Grid>
          ) : (
            <Grid item xs={12} sm={6} md={4}>
              {/* {downloadDocxSeven ? <a target="_blank" href={downloadDocxSeven}><span className="link-filed">Download PPAP template</span></a> : <a href={" "}><span className="link-filed"><button className="disabled-link" disabled>Download PPAP template</button></span></a>}*/}
              {groupData == 3 ||
              prevDataAdd.groupId == 3 ||
              developmentData == 1 ||
              prevDataAdd.developmentTypeId == 1 ||
              userDetails.roleId == 8 ||
              userDetails.roleId == 9 ||
              userDetails.roleId == 10 ? (
                <a>
                  <span className="link-filed">
                    <button className="disabled-link" disabled>
                      Download PPAP Template
                    </button>
                  </span>
                </a>
              ) : userDetails.roleId === 3 ? (
                <button className="link-filed1" onClick={getMasterFileName4}>
                  Download PPAP Template
                </button>
              ) : (
                <a target="_blank" href={downloadDocxSeven}>
                  <span className="link-filed">Download PPAP Template</span>
                </a>
              )}
            </Grid>
          )}

          {userDetails.roleId === 1 ||
          userDetails.roleId === 6 ||
          userDetails.roleId === 2 ? (
            <Grid item xs={12} sm={6} md={4}>
              <Grid className="check-box">
                <TextField
                  label="SQM Check_APQP"
                  type="file"
                  id="desiredOPInKW"
                  name="desiredOPInKW"
                  className=""
                  fullWidth
                  // disabled={groupData === 3 || developmentData == 1 || prevDataAdd.groupId === 3 || prevDataAdd.developmentTypeId == 1}
                  disabled
                  key={sevenFileKey}
                  onChange={handleChangeFileSeven}
                  variant="filled"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          className="p-0"
                          target="_blank"
                          //  href={downloadDocxSeven}
                          href={downloadDocxFourthNew}
                          disabled={
                            groupData === 3 ||
                            developmentData == 1 ||
                            prevDataAdd.groupId === 3 ||
                            prevDataAdd.developmentTypeId == 1
                          }
                        >
                          <CloudDownloadIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                ></TextField>

                <input
                  className="hide-hidden"
                  type="checkbox"
                  label="SQM Check_APQP"
                  checked={apqpChecked}
                  onChange={handleAPQPChecked}
                />
              </Grid>

              <h6>
                {fileEight ? <span className="fname">{fileEight}</span> : " "}
              </h6>
            </Grid>
          ) : (
            <Grid item xs={12} sm={6} md={4}>
              {groupData == 3 ||
              prevDataAdd.groupId == 3 ||
              developmentData == 1 ||
              prevDataAdd.developmentTypeId == 1 ||
              userDetails.roleId == 8 ||
              userDetails.roleId == 9 ||
              userDetails.roleId == 10 ||
              userDetails.roleId == 3 ? (
                <a>
                  <span className="link-filed">
                    <button className="disabled-link" disabled>
                      Download APQP Template
                    </button>
                  </span>
                </a>
              ) : userDetails.roleId === 3 ? (
                <button className="link-filed1" onClick={getMasterFileName6}>
                  Download APQP Template
                </button>
              ) : userDetails.roleId === 3 &&
                userDetails.locationName === "Puducherry" ? (
                <></>
              ) : (
                <a target="_blank" href={downloadDocxSeven}>
                  <span className="link-filed">Download APQP Template</span>
                </a>
              )}
            </Grid>
          )}
          {/*    (closeBtnEnableDataStateFromTB2ChildType && prevDataAdd.typeId==2) ||*/}
          {userDetails.roleId == 6 ||
          userDetails.roleId == 1 ||
          userDetails.roleId === 2 ? (
            <Grid item xs={12} sm={6} md={4}>
              <Button
                className="pt-button--hero myid-login-btn-block"
                onClick={handleUploadFileData}
                disabled={
                  afterClosingIsirActionDataState ||
                  groupData == 3 ||
                  developmentData == 1 ||
                  prevDataAdd.groupId === 3 ||
                  prevDataAdd.developmentTypeId == 1 ||
                  (prevDataAdd.statusName == "ISIR Closed" &&
                    prevDataAdd.statusId == 7 &&
                    prevDataAdd.massReleasetoSQE !== null) ||
                  (prevDataAdd.statusName == "ISIR Closed" &&
                    prevDataAdd.statusId == 7 &&
                    prevDataAdd.massReleasetoSQE == null &&
                    prevDataAdd.typeId == 2)
                }
              >
                Upload
              </Button>
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
      </Grid>
      {isLoaderFeedback ? <Loading loaderText="Loading...." /> : <></>}
      {/* <FileDownloadHistoryDialog open={openFileHistoryDialog} onClose={handleCloseDialog} info={info} /> */}

      <Dialog
        className="test"
        open={openFileHistoryDialog}
        onClose={closeFileHistoryDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          className: classes.responsiveDialog,
        }}
      >
        <DialogTitle id="alert-dialog-title" onClose={closeFileHistoryDialog}>
          <h5>File History</h5>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Grid item xs={12}>
              {tableStringContent && tableStringContent !== null ? (
                <div style={{ textAlign: "center" }}>
                  <h4>{tableStringContent}</h4>
                </div>
              ) : (
                <MaterialTable
                  title="History of Files"
                  columns={columnsNew}
                  data={historyTableData}
                  icons={tableIconsInputScreen}
                  isLoading={isLoader}
                  options={tableOptionsUser}
                />
              )}
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className="pt-button--primary button-submit"
            variant="contained"
            onClick={closeFileHistoryDialog}
            color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
// End of Part One

const PartTwo = ({
  isirNumberPassed,
  prevDataAdd2,
  groupData,
  developmentData,
  documentList,
    onFileChange,
    onFileChangeCrer,
    tableData
}) => {
  const [loader, setIsLoader] = useState(false);
  const token = useSelector((state) => state.saveTokenReducer.token);
  const navigate = useNavigate();
  const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData
  );
  const fileUploadDetails = useSelector(
    (state) => state.uploadFileValidationReducer.files
  );
  const poTextActionDataState = useSelector(
    (state) => state.isPoTextReducer.poTextValue
  );
  console.log("poTextActionDataState", poTextActionDataState);
  const iipActionDataState = useSelector(
    (state) => state.isIipqpReducer.iipQpValue
  );
  console.log("iipActionDataState", iipActionDataState);
  /// closeEnableForChildTypeReducer--closeEnableForChildTypeValue
  const closeBtnEnableDataStateFromTB2ChildType = useSelector(
    (state) => state.closeEnableForChildTypeReducer.closeEnableForChildTypeValue
  );
  console.log(
    "closeBtnEnableDataStateFromTB2ChildType",
    closeBtnEnableDataStateFromTB2ChildType
  );
  const afterClosingIsirActionDataState = useSelector(
    (state) => state.afterClosingIsirReducer.afterClosingIsirValue
  );

  const sqmCheckApqpDataState = useSelector(
    (state) => state.sqmCheckApqpReducer.sqmCheckApqpValue
  );

  console.log("sqmCheckApqpDataState", sqmCheckApqpDataState);

  const [isUploading, setIsUploading] = useState(false);
  const siteToken = useSelector((state) => state.saveBearerTokenReducer);
  const azureToken = useSelector((state) => state.saveTokenReducer);
  const UID = useSelector((state) => state.saveUserIdReducer);
  const dispatch = useDispatch();
  const classes = useStyles();

  const [siemensTeam, setSiemensTeam] = useState(false);
  const handleDisabled = () => {
    setSiemensTeam(true);
  };
  const handleClose = (e) => {
    setOpen(false);
  };
  const hideTabData2ActionState = useSelector(
    (state) => state.hideTabPart2Reducer.hidetb2Value
  );

  const [balloningDrawing, setBalloningDrawing] = useState(null);
  const [balloningDrawingpdfKey, setBalloningDrawingpdfKey] = useState(
    Date.now
  );
  const [fileFilledandSignedtfc, setFileFilledandSignedtfc] = useState(null);
  const [fileFilledandSignedtfcKey, setfileFilledandSignedtfcKey] = useState(
    Date.now
  );
  const [fileFilledandSignedtrm, setFileFilledandSignedtrm] = useState(null);
  const [fileFilledandSignedtrmKey, setFileFilledandSignedtrmKey] = useState(
    Date.now
  );
  const [filedfm, setFiledfm] = useState(null);
  const [filedfmKey, setFiledfmKey] = useState(Date.now);
  const [fileToolDesignstp, setFileToolDesignstp] = useState(null);
  const [fileToolDesignStpKey, setFileToolDesignStpKey] = useState(Date.now);
  const [fileEAEM, setfileEAEM] = useState(null);
  const [fileEAEMKey, setFileEAEMKey] = useState(Date.now);
  const [fileEAEMPDF, setfileEAEMPDF] = useState(null);
  const [fileEAEMPDFKey, setFileEAEMPDFKey] = useState(Date.now);
  //new additional upload by supplier newly added
  const [fileAdditionalUploadKey, setFileAdditionalUploadKey] = useState(
    Date.now
  );
  const [fileAdditionalUpload, setFileAdditionalUpload] = useState(null);

  const [fileAdditionalUploadByCeKey, setFileAdditionalUploadByCeKey] =
    useState(Date.now);
  const [fileAdditionalUploadByCompCe, setFileAdditionalUploadByCompCe] =
    useState(null);

  const [fileUploadByCeForHebbrnKey, setFileUploadByCeForHebbrnKey] = useState(
    Date.now
  );
  const [fileUploadByCeForHebbrn, setFileUploadByCeForHebbrn] = useState(null);

  // fileUploadByCeForHebbrn

  const [fileEAEM_QualityPlan, setfileEAEM_QualityPlan] = useState(null);
  const [fileEAEM_QualityPlanKey, setfileEAEM_QualityPlanKey] = useState(
    Date.now
  );
  const [sqmApqpQuestionare, setSqmApqpQuestionare] = useState(null);
  const [sqmApqpQuestionareKey, setSqmApqpQuestionareKey] = useState(Date.now);

  //useEffect(() => {
  //  if (onFileChange) {
  //    onFileChange(sqmApqpQuestionare);
  //    }

  //    //if (downloadSQMAPQPDocx) {
  //    //    onFileChange(downloadSQMAPQPDocx);
  //    //}
  //}, [sqmApqpQuestionare]);

  //useEffect(() => {
  //    if (onFileChangeCrer) {
  //        onFileChangeCrer()
  //    }

  //})

  const [filePPAPReview1, setfilePPAPReview1] = useState(null);
  const [filePPAPReview1Key, setfilePPAPReview1Key] = useState(Date.now);
  const [filePPAPSnoff, setfilePPAPSnoff] = useState(null);
  const [filePPAPSnoffKey, setfilePPAPSnoffKey] = useState(Date.now);
  const [fileIncomingQreport, setfileIncomingQreport] = useState(null);
  const [fileIncomingQreportKey, setfileIncomingQreportKey] = useState(
    Date.now
  );
  const [fileCrer, setfileCrer] = useState(null);
  const [fileCrerKey, setfileCrerKey] = useState(Date.now);
  const [fileComponentAppr, setfileComponentAppr] = useState(null);
  const [fileComponentApprKey, setfileComponentApprKey] = useState(Date.now);
  const [attachmentRespOfTabTwo, setAttachmentRespenceOftabtwo] = useState([]);

  //download states
  const [download1Docx, setDownload1Docx] = useState("");
  const [download2Docx, setDownload2Docx] = useState("");
  const [download3Docx, setDownload3Docx] = useState("");
  const [download4Docx, setDownload4Docx] = useState("");
  const [download5Docx, setDownload5Docx] = useState("");
  const [download6Docx, setDownload6Docx] = useState("");
  const [download7Docx, setDownload7Docx] = useState("");
  const [download8Docx, setDownload8Docx] = useState("");
  const [download9Docx, setDownload9Docx] = useState("");
  const [download10Docx, setDownload10Docx] = useState("");
  const [download11Docx, setDownload11Docx] = useState("");
  const [download12Docx, setDownload12Docx] = useState("");
  const [download13Docx, setDownload13Docx] = useState("");
  const [download24Docx, setDownload24Docx] = useState("");
  const [download38Docx, setDownload38Docx] = useState("");
  const [download39Docx, setDownload39Docx] = useState("");
  const [downloadSQMAPQPDocx, setDownloadSQMAPQPDocx] = useState("");
  const [downloadTab2Data, setDownloadTab2Data] = useState([]);

  const handleballoning = (e) => {
    setBalloningDrawing(e.target.files[0]);
  };
  const handleHandlesignedtfc = (e) => {
    setFileFilledandSignedtfc(e.target.files[0]);
  };
  const handleTrm = (e) => {
    setFileFilledandSignedtrm(e.target.files[0]);
  };
  const handleFM = (e) => {
    setFiledfm(e.target.files[0]);
  };
  const handleToolDesign = (e) => {
    setFileToolDesignstp(e.target.files[0]);
  };
  const handleIsirxlsm = (e) => {
    setfileEAEM(e.target.files[0]);
  };
  const handleAdditionalUploads = (e) => {
    setFileAdditionalUpload(e.target.files[0]);
  };
  const handleAdditionalUploadsByComponentEngineer = (e) => {
    setFileAdditionalUploadByCompCe(e.target.files[0]);
  };
  const handleUploadByCeForHerren = (e) => {
    setFileUploadByCeForHebbrn(e.target.files[0]);
  };
  const handleIsirPdf = (e) => {
    setfileEAEMPDF(e.target.files[0]);
  };
  const handleQualityPlan = (e) => {
    setfileEAEM_QualityPlan(e.target.files[0]);
  };

  const handlePpapReview = (e) => {
    setfilePPAPReview1(e.target.files[0]);
  };
  const handlePPAPSnoff = (e) => {
    setfilePPAPSnoff(e.target.files[0]);
  };
  const handleIqualityReport = (e) => {
    setfileIncomingQreport(e.target.files[0]);
  };
  const handleCrer = (e) => {
    setfileCrer(e.target.files[0]);
  };
  const handleCompoAppr = (e) => {
    setfileComponentAppr(e.target.files[0]);
  };
  const [openSnackbarInternal, setOpenSnackbarInternal] = useState(false);

  const [snackMessageInternal, setSnackMessageInternal] = useState("");

  const [alertTypeInternal, setAlertTypeInternal] = useState("");

  const handleSnackOpenInternal = (text, type) => {
    setSnackMessageInternal(text);

    setAlertTypeInternal(type);

    setOpenSnackbarInternal(true);
  };
  const handleCloseSnackbarInternal = (e) => {
    setOpenSnackbarInternal(false);
  };

  const [openDialog, setOpenDialog] = React.useState(false);
  const [snapshotFile, setSnapshotFile] = useState(null);
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleClickOpen = () => {
    setOpenDialog(true);
  };
  //const [uploadImageData, setUploadImageData] = useState("");
  const [open, setOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const handleSnackOpen = (text, type) => {
    setSnackMessage(text);
    setAlertType(type);
    setOpen(true);
  };

  let [inputFileValue, setInputFileValue] = useState(Date.now);

  const updateSnapShotHandler = (e) => {
    let type = e.target.files[0].type.replace("image/", "");
    if (
      type.toLowerCase() !== "jpg" &&
      type.toLowerCase() !== "jpeg" &&
      type.toLowerCase() !== "png"
    ) {
      handleSnackOpen("Only jpg,jpeg and pdf format are supported", "info");
    } else {
      setSnapshotFile(e.target.files[0]);
    }
  };

  const handleSQMAPQPQuestionare = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    //  Only allow PDF
    if (file.type !== "application/pdf") {
      alert("Only PDF files are allowed");

      setSqmApqpQuestionare(null); // local state clear
      // onFileChange && onFileChange(null);
      setTimeout(() => {
        // parent state clear
        e.target.value = "";
      }, 0); // input field clear
      return;
    }

    //  Valid PDF
    setSqmApqpQuestionare(file);
    /// onFileChange && onFileChange(file);
  };

  ///let isirNum = isirNumberPassed;
  const [poRes, setPoRes] = useState("");
  function poText(isirNumberPassed) {
      getPOText(

          siteToken.token,
          azureToken.token,
          userDetails.userId,
          userDetails.userEmail,
          userDetails.gid,
          userDetails.role,
          userDetails.roleId,

           isirNumberPassed)
      .then((response) => {
        setPoRes(response.objResult);

        // setUploadImageData(response.objResult);
        if (response.objResult) {
          dispatch(poTextAction(true));
        }
        //dispatch(poTextAction(true));
      })
      .catch((error) => {
        handleSnackOpen("Error : " + error, "error");
        setIsLoader(false);
      });
  }
    //const [poImg, setPoImg] = useState("");


   
  const [poImgUrl, setPoImgUrl] = useState("");
  const [poImgName, setPoImgName] = useState();
  const handleUpload = (e) => {
      if (!snapshotFile) {
          handleSnackOpen("Please Select a File", "info");
          setIsLoader(false);
      }
      else {
      setIsLoader(true);
      const formData = new FormData();
      formData.append("file", snapshotFile);
      formData.append("UserId", userDetails.userId);
      formData.append("AutomatedIsirnumber", isirNumberPassed);
      addPOTextDetails(
        siteToken.token,
        azureToken.token,
        UID.id,
        userDetails.userEmail,
        userDetails.gid,
        userDetails.role,
        userDetails.roleId,
        formData
      )
        .then((response) => {
          if (response.response) {
            // setIsLoader(true);

            localStorage.setItem("ApplicationId", 1);
            dispatch(poTextAction(true));
            setPoImgUrl(response.responseimage);
            setPoImgName(response.imagename);
            //setUploadImageData(response.objResult);
            setIsLoader(false);
            handleSnackOpen(response.responseMsg, "success");
          } else {
            handleSnackOpen(response.responseMsg, "error");
            setIsLoader(false);
          }
        })
        .catch((error) => {
          setIsLoader(false);
          setSnapshotFile(null);
          setInputFileValue(Date.now);
          handleSnackOpen("Exception : " + error, "error");
        });
    }
  };

  const [keepItClose, setKeepItClose] = useState(false);
  const [tab1FilesData, setTab1FilesData] = useState();
  function handleDownloadTb1Data(isirNumberPassed) {
    getuploadedDatainDownLoadFile(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      isirNumberPassed
    )
      .then((response) => {
        setTab1FilesData(response);
        if (
          response.uploadfiletype == 1 &&
          response.uploadfiletype == 2 &&
          response.uploadfiletype == 4
        ) {
          setKeepItClose(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  //getallisirdetailsgetapi call
  const [tfcdres2, setTCFdres2] = useState("");
  const [trmdres2, setTRMdres2] = useState("");
  const [ppapdres2, setPPAPdres2] = useState("");
  const [dfmdres2, setDFMdres2] = useState("");
  const [isPoUplodaded, setIsPouploaded] = useState();
  const [getAllisirDatat2, setGetAllisirDatat2] = useState([]);

  function getDetailsForIsir() {
    setIsLoader(true);

    getAllIsirDetails(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        setGetAllisirDatat2(response);
        let particularUserDraft2 = response;
        let getRes2 = particularUserDraft2?.filter(
          (item) => item.automatedIsirnumber == prevDataAdd2.automatedIsirnumber
        );

        if (getRes2.length === 1) {
          let tfcDraftgetRes2 = getRes2.map((x) => x.tfmcheckbox);

          setTCFdres2(tfcDraftgetRes2[0]);
          let ppapDraftgetRes2 = getRes2.map((x) => x.ppapcheckbox);

          setPPAPdres2(ppapDraftgetRes2[0]);
          let trmDraftgetRes2 = getRes2.map((x) => x.trmcheckbox);

          setTRMdres2(trmDraftgetRes2[0]);
          let dfmDraftgetRes2 = getRes2.map((x) => x.dfmcheckbox);

          setDFMdres2(dfmDraftgetRes2[0]);

          let poDraftgetRes2 = getRes2.map((x) => x.isPotextUploaded[0]);

          setIsPouploaded(poDraftgetRes2[0]);
        }

        setIsLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }

  useEffect(() => {
    getDetailsForIsir();
  }, []);

    //useEffect(() => {

    //})

  const [snackMsg, setSnackMsg] = useState("");
  const [isLoaderFeedback, setIsLoaderFeedback] = useState(false);
  //const handleUploadFileDataTabtwo = (e) => {
  //    handleSnackOpenInternal("Data Uploaded Successfully.", "success");
  //}
  const [openSnack, setOpenSnack] = useState(false);
  const handleOpenSnack = () => {
    setOpenSnack(true);
  };
  const handleCloseSnack = () => {
    setOpenSnack(false);
  };
  const [openSnackRed, setOpenSnackRed] = useState(false);
  const handleOpenSnackRed = () => {
    setOpenSnackRed(true);
  };
  const handleCloseSnackRed = () => {
    setOpenSnackRed(false);
  };
  const [uploadTypeValue, setUploadTypeValue] = useState();
  const [uploadTypeValue9, setUploadTypeValue9] = useState();
  const [uploadTypeValue10, setUploadTypeValue10] = useState();
  const [uploadTypeValue11, setUploadTypeValue11] = useState();
  const [uploadTypeValue12, setUploadTypeValue12] = useState();
  const [uploadTypeValue13, setUploadTypeValue13] = useState();
  const [uploadTypeValue14, setUploadTypeValue14] = useState();
  const [uploadTypeValue15, setUploadTypeValue15] = useState(); //isir.pdf
  const [uploadTypeValue16, setUploadTypeValue16] = useState(); //quality plan
  const [uploadTypeValue17, setUploadTypeValue17] = useState(); ///ppap review
  const [uploadTypeValue18, setUploadTypeValue18] = useState(); //ppap sigoff
  const [uploadTypeValue19, setUploadTypeValue19] = useState(); //incoming quality report
  const [uploadTypeValue20, setUploadTypeValue20] = useState(); //crer
  const [uploadTypeValue21, setUploadTypeValue21] = useState(); //component approver
  const [uploadTypeValue39, setUploadTypeValue39] = useState(); //heburn
  const [uploadTypeValue38, setUploadTypeValue38] = useState(); //Additional upload by ce
  const [
    uploadTypeValueSQMApqpQuestinare,
    setUploadTypeValueSQMApqpQuestinare,
  ] = useState(); //SQM Apqp
  const [closeBtnEnable, setCloseBtnEnable] = useState(false);
  const [closeBtnEnableResponse, setCloseBtnEnableResponse] = useState();
  function closeBtnEnabledConditionData(isirNo) {
    setIsLoader(true);

    getCloseEnableDataCondition(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      isirNo
    )
      .then((response) => {
        console.log("closeDataconditioncheck", response);
        if (response) {
          //setCloseBtnEnable(true);
          setCloseBtnEnableResponse(response);
          if (response) {
            dispatch(closeEnableForChildTypeAction(true));
          }
          //  dispatch(closeEnableForChildTypeAction(true));
        }
        setIsLoader(false);
      })
      .catch((error) => {
        handleSnackOpen("Error : " + error, "error");
        setIsLoader(false);
      });
  }

  const clearAllFiles = () => {
    setBalloningDrawing(null);
    setFileFilledandSignedtfc(null);
    setFileFilledandSignedtrm(null);
    setFiledfm(null);
    setFileToolDesignstp(null);
    setfileEAEM(null);
    setfileEAEMPDF(null);
    setfileEAEM_QualityPlan(null);
    setfilePPAPReview1(null);
    setfilePPAPSnoff(null);
    setfileIncomingQreport(null);
    setfileCrer(null);
    setfileComponentAppr(null);
    setFileAdditionalUpload(null);
    setFileUploadByCeForHebbrn(null);

    const ids = [
      "BallooningFile",
      "033_TFC",
      "046_TRM",
      "DFM.ppt",
      "toolDesignSTP",
      "056_ISIR_xlsm",
      "056_ISIR_pdf",
      "060_Quality",
      "PPAP_XLSX",
      "PPAP_PDF",
      "incomingQualityReport_PDF",
      "crerPdf",
      "componentApprovalPdf",
      "additionalUploadBySupplier",
      "AppFromSPDLHebburn",
      "SQM_Check_APQP",
    ];

    ids.forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.value = "";
    });
  };

  const handleUploadFileDataTabtwo = (e) => {
    e.preventDefault();

    let tabData2 = new FormData();

    tabData2.append("userId", userDetails.userId);
    tabData2.append("AutomatedISIRNumber", isirNumberPassed);
    tabData2.append("fileBallonningDrawing", balloningDrawing);

    tabData2.append("fileFilledandSignedTFC", fileFilledandSignedtfc);
    tabData2.append("fileFilledandSignedTRM", fileFilledandSignedtrm);
    tabData2.append("fileDFMppt", filedfm);
    tabData2.append("fileToolDesignStp", fileToolDesignstp);
    tabData2.append("fileEAEM_ISIR_XLSM", fileEAEM);
    tabData2.append("additionalUploadsBySupplier", fileAdditionalUpload);
    tabData2.append(
      "AdditionalFileUploadByCompCe",
      fileAdditionalUploadByCompCe
    );
    tabData2.append("Uploadfileforheburn", fileUploadByCeForHebbrn);

    tabData2.append("fileEAEM_ISIR_PDF", fileEAEMPDF);
    tabData2.append("fileEAEM_QualityPlan_PDF", fileEAEM_QualityPlan);
    tabData2.append("fileSQM_APQP", sqmApqpQuestionare);

    tabData2.append("filePPAPReview", filePPAPReview1);
    tabData2.append("filePPAPSignOff", filePPAPSnoff);
    tabData2.append("fileIncomingQualityReport", fileIncomingQreport);
    tabData2.append("fileCRER", fileCrer);
    tabData2.append("fileComponentApproval", fileComponentAppr);
    handleCloseDialog();

    if (userDetails.roleId == 3) {
      if (
        fileEAEM == null &&
        download6Docx == null &&
        prevDataAdd2.developmentTypeId !== 1 &&
        prevDataAdd2.groupId !== 3
      ) {
        setIsLoaderFeedback(false);
        alert("please upload isir.xlsm");
        return;
      }
    } else if (userDetails.roleId == 6 || userDetails.roleId === 2) {
      if (fileEAEM_QualityPlan == null && download8Docx == null) {
        setIsLoaderFeedback(false);
        alert("please upload Quality Plan(IIP)");
        return;
      }
    } else if (userDetails.roleId == 7) {
      if (fileEAEMPDF == null && download7Docx == null) {
        setIsLoaderFeedback(false);
        alert("please upload ISIR.Pdf");
        return;
      }
    } else if (
      (userDetails.roleId == 6 || userDetails.roleId === 2) &&
      (fileEAEM_QualityPlan || download8Docx) &&
      prevDataAdd2.developmentTypeId !== 1 &&
      prevDataAdd2.groupId !== 3
    ) {
      if (fileCrer == null && download12Docx == null) {
        setIsLoaderFeedback(false);
        alert("please upload ISIR.Pdf");
        return;
      }
    }

    setIsLoader(true);
    setIsUploading(true);
    uploadTemplateFileDataTab2(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      tabData2
    )
      .then((response) => {
        if (response?.response) {
          console.log("tab2attachments", response);
          setAttachmentRespenceOftabtwo(response?.responseAttachments);
          const uploadedAttchments = response?.responseAttachments;
          for (let item of uploadedAttchments) {
            if (item.uploadfiletype == 15) {
              dispatch(iipAction(true));
              break;
            }
            if (item.uploadfiletype == 16) {
              dispatch(ppapxlsmAction(true));
              break;
            }
            if (item.uploadfiletype == 18) {
              dispatch(incomingQualityReportAction(true));
              break;
            }
            if (item.uploadfiletype == 20) {
              dispatch(componentApprovalFormAction(true));
              break;
            }
            if (item.uploadfiletype == 40) {
              dispatch(sqmCheckApqpAction(true));
              break;
            }
          }

          setIsLoader(false);
          //handleSnackOpen(response.responseMsg, "success");
          // handleSnackOpenInternal(response.responseMsg, "success");
          handleSnackOpenInternal("Data Uploaded Successfully.", "success");
          clearAllFiles();
          ///  closeBtnEnabledConditionData(isirNumberPassed || prevDataAdd2.automatedIsirnumber);
          if (prevDataAdd2 && prevDataAdd2.automatedIsirnumber) {
            closeBtnEnabledConditionData(prevDataAdd2.automatedIsirnumber);
          }
          setIsUploading(false);

          ///  getCloseEnableDataCondition
          setSnackMsg(response?.responseMsg);
          handleOpenSnack();
        } else {
          setIsLoaderFeedback(false);
          handleSnackOpen(response?.responseMsg, "error");
          setIsUploading(false);
          handleOpenSnackRed();
          clearAllFiles();
        }

        setAttachmentRespenceOftabtwo(response?.responseAttachments);
        let attachmentRespt2 = response?.responseAttachments;
        if (attachmentRespt2 != undefined && attachmentRespt2.length > 0) {
          attachmentRespt2.map((item) => {
            switch (item.uploadfiletype) {
              case 8:
                setUploadTypeValue(item.uploadfiletype);
                setDownload1Docx(item.fileUrl);
                setBalloningDrawing(null);
                document.getElementById("BallooningFile").value = "";
                break;
              case 9:
                setUploadTypeValue9(item.uploadfiletype);
                setDownload2Docx(item.fileUrl);
                setFileFilledandSignedtfc(null);
                document.getElementById("033_TFC").value = "";

                break;
              case 10:
                setUploadTypeValue10(item.uploadfiletype);
                setDownload3Docx(item.fileUrl);
                setFileFilledandSignedtrm(null);
                document.getElementById("046_TRM").value = "";
                break;
              case 11:
                setUploadTypeValue11(item.uploadfiletype);
                setDownload4Docx(item.fileUrl);
                setFiledfm(null);
                document.getElementById("DFM.ppt").value = "";
                break;
              case 12:
                setUploadTypeValue12(item.uploadfiletype);
                setDownload5Docx(item.fileUrl);
                setFileToolDesignstp(null);
                document.getElementById("toolDesignSTP").value = "";
                break;
              case 13:
                setUploadTypeValue13(item.uploadfiletype);
                setDownload6Docx(item.fileUrl);
                setfileEAEM(null);
                document.getElementById("056_ISIR_xlsm").value = "";

                break;
              case 14:
                //setUploadTypeValue14(item.uploadfiletype)

                setUploadTypeValue15(item.uploadfiletype); //isir.pdf
                setDownload7Docx(item.fileUrl);
                setfileEAEMPDF(null);
                document.getElementById("056_ISIR_pdf").value = "";
                break;
              case 15:
                setDownload8Docx(item.fileUrl);
                setUploadTypeValue16(item.uploadfiletype); //quality plan
                setfileEAEM_QualityPlan(null);
                document.getElementById("060_Quality").value = "";
                break;
              case 16:
                setUploadTypeValue17(item.uploadfiletype);
                setDownload9Docx(item.fileUrl);
                setfilePPAPReview1(null);
                document.getElementById("PPAP_XLSX").value = "";
                break;
              case 17:
                setUploadTypeValue18(item.uploadfiletype);
                setDownload10Docx(item.fileUrl);
                setfilePPAPSnoff(null);
                document.getElementById("PPAP_PDF").value = "";
                break;
              case 18:
                setUploadTypeValue19(item.uploadfiletype);
                setDownload11Docx(item.fileUrl);
                setfileIncomingQreport(null);
                document.getElementById("incomingQualityReport_PDF").value = "";
                break;
              case 19:
                setUploadTypeValue20(item.uploadfiletype);
                setDownload12Docx(item.fileUrl);
                setfileCrer(null);
                document.getElementById("crerPdf").value = "";
                break;
              case 20:
                setUploadTypeValue21(item.uploadfiletype);
                setDownload13Docx(item.fileUrl);
                setfileComponentAppr(null);
                document.getElementById("componentApprovalPdf").value = "";

                break;
              case 24:
                setDownload24Docx(item.fileUrl);
                setFileAdditionalUpload(null);
                document.getElementById("additionalUploadBySupplier").value =
                  "";
                break;
              case 38:
                setDownload38Docx(item.fileUrl);
                setUploadTypeValue38(item.uploadfiletype);
                break;
              case 39:
                setDownload39Docx(item.fileUrl);
                setUploadTypeValue39(item.uploadfiletype);
                setFileUploadByCeForHebbrn(null);
                document.getElementById("AppFromSPDLHebburn").value = "";
                break;
              case 40:
                setUploadTypeValueSQMApqpQuestinare(item.uploadfiletype);
                setFileT2SqmAPQP(item.fileName);
                setDownloadSQMAPQPDocx(item.fileUrl);
                document.getElementById("SQM_Check_APQP").value = "";
              /// onFileChange(item.fileUrl);
              default:
            }
          });
        }
      })
      .finally(() => {
        setIsLoader(false);
      });
  };

  const [showModal, setShowModal] = useState(false);
  const createRemark = (e) => {
    setShowModal(true);
  };

  //get API call for Download //to get all uploaded attachement data
  function handleDownloadTb2Data(isirNumberPassed) {
    getuploadedDatainDownLoadFile(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      isirNumberPassed
    )
      .then((response) => {
        console.log("getuploadedfilesindownload", response);
        setDownloadTab2Data(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  function handleDownloadTb1Data(isirNumberPassed) {
    getuploadedDatainDownLoadFile(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      isirNumberPassed
    )
      .then((response) => {
        setDownloadTab2Data(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  //const [uploadImageData, setUploadImageData] = useState();
  //const [poImg, setPoImg] = useState("");
  useEffect(() => {
    poText(isirNumberPassed);
    if (prevDataAdd2) {
      handleDownloadTb2Data(prevDataAdd2.automatedIsirnumber); //item.automatedIsirnumber === isirWorkFlowNumber
      //let sakshi = downloadTab2Data.filter((x) => x.automatedIsirnumber === prevDataAdd2.automatedIsirnumber);
      poText(prevDataAdd2.automatedIsirnumber);
      //console.log("sakshi", sakshi);
      //sakshi.map((y) => {
      //    if (y.uploadfiletype == 21) {
      //        console.log("filename", y.fileName);
      //        console.log("pourl", y.fileUrl);
      //        setPoImg(y.fileUrl)
      //    }
      //})
    } else {
      handleDownloadTb2Data(isirNumberPassed);
    }
  }, [
    attachmentRespOfTabTwo,
    isirNumberPassed,
    prevDataAdd2.automatedIsirnumber,
  ]);
  //attachmentRespOfTabTwo, isirNumberPassed, prevDataAdd2.automatedIsirnumber
  const [fileT2Data1, setFileT2Data1] = useState();
  const [fileT2Data2, setFileT2Data2] = useState();
  const [fileT2Data3, setFileT2Data3] = useState();
  const [fileT2Data4, setFileT2Data4] = useState();
  const [fileT2Data5, setFileT2Data5] = useState();
  const [fileT2Data6, setFileT2Data6] = useState();
  const [fileT2Data7, setFileT2Data7] = useState();
  const [fileT2Data8, setFileT2Data8] = useState();
  const [fileT2Data9, setFileT2Data9] = useState();
  const [fileT2Data10, setFileT2Data10] = useState();
  const [fileT2Data11, setFileT2Data11] = useState();
  const [fileT2Data12, setFileT2Data12] = useState();
  const [fileT2Data13, setFileT2Data13] = useState();
  const [fileT2Data24, setFileT2Data24] = useState();
  const [fileT2Databyce38, setFileT2Databyce38] = useState();
  const [fileT2Databyce39, setFileT2Databyce39] = useState();
  const [fileT2SqmAPQP, setFileT2SqmAPQP] = useState();

  const [isBalloning, setisBalloning] = useState();

  useEffect(() => {
    dispatch(iipAction(false));
    dispatch(ppapxlsmAction(false));
    dispatch(incomingQualityReportAction(false));
    dispatch(componentApprovalFormAction(false));
    dispatch(sqmCheckApqpAction(false));

    downloadTab2Data.map((item) => {
      switch (item.uploadfiletype) {
        case 8:
          setUploadTypeValue(item.uploadfiletype);
          setFileT2Data1(item.fileName.trim());
          setDownload1Docx(item.fileUrl);

          break;
        case 9:
          setUploadTypeValue9(item.uploadfiletype);
          setFileT2Data2(item.fileName);
          setDownload2Docx(item.fileUrl);
          break;
        case 10:
          setUploadTypeValue10(item.uploadfiletype);
          setFileT2Data3(item.fileName);
          setDownload3Docx(item.fileUrl);
          break;
        case 11:
          setUploadTypeValue11(item.uploadfiletype);
          setFileT2Data4(item.fileName);
          setDownload4Docx(item.fileUrl);
          break;
        case 12:
          setUploadTypeValue12(item.uploadfiletype);
          setFileT2Data5(item.fileName);
          setDownload5Docx(item.fileUrl);
          break;
        case 13:
          setUploadTypeValue13(item.uploadfiletype);
          setFileT2Data6(item.fileName);
          setDownload6Docx(item.fileUrl);
          break;
        case 14:
          setUploadTypeValue15(item.uploadfiletype);
          setFileT2Data7(item.fileName);
          setDownload7Docx(item.fileUrl);
          break;
        case 15:
          setUploadTypeValue16(item.uploadfiletype);
          setFileT2Data8(item.fileName);
          setDownload8Docx(item.fileUrl);

          dispatch(iipAction(true));
          break;
        case 16:
          setUploadTypeValue17(item.uploadfiletype);
          setFileT2Data9(item.fileName);
          setDownload9Docx(item.fileUrl);
          dispatch(ppapxlsmAction(true));
          break;
        case 17:
          setUploadTypeValue18(item.uploadfiletype);
          setFileT2Data10(item.fileName);
          setDownload10Docx(item.fileUrl);
          break;
        case 18:
          setUploadTypeValue19(item.uploadfiletype);
          setFileT2Data11(item.fileName);
          setDownload11Docx(item.fileUrl);
          dispatch(incomingQualityReportAction(true));
          break;
        case 19:
          setUploadTypeValue20(item.uploadfiletype);
          setFileT2Data12(item.fileName);
          setDownload12Docx(item.fileUrl);
          break;
        case 20:
          setUploadTypeValue21(item.uploadfiletype);
          setFileT2Data13(item.fileName);
          setDownload13Docx(item.fileUrl);
          dispatch(componentApprovalFormAction(true));
          break;
        case 24:
          setUploadTypeValue14(item.uploadfiletype);
          setFileT2Data24(item.fileName);
          setDownload24Docx(item.fileUrl);
          break;
        case 38:
          setFileT2Databyce38(item.fileName);
          setDownload38Docx(item.fileUrl);
          setUploadTypeValue38(item.uploadfiletype);
          break;
        case 39:
          setUploadTypeValue39(item.uploadfiletype);
          setDownload39Docx(item.fileUrl);
          setFileT2Databyce39(item.fileName);
          break;
        case 21:
          setPoImgUrl(item.fileUrl);
          setPoImgName(item.fileName);
          dispatch(poTextAction(true));
          break;
        case 40:
          setUploadTypeValueSQMApqpQuestinare(item.uploadfiletype);
          setFileT2SqmAPQP(item.fileName);
          setDownloadSQMAPQPDocx(item.fileUrl);
          dispatch(sqmCheckApqpAction(true));
          break;

        default:
      }
    });
  }, [downloadTab2Data]);

  const [getDinAddisirTab2, setGetDinAddisirTab2] = useState([]);
  const [hebburnRndLoc, setHebburnRndLoc] = useState(false);
  function getDinAddInTab2() {
    setIsLoader(true);

    getAllIsirDetails(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        console.log("filteredDatatb2", response);
        setGetDinAddisirTab2(response);

        setIsLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }
  useEffect(() => {
    getDinAddInTab2();
  }, []);

  useEffect(() => {
    let datainTab2 = getDinAddisirTab2.filter(
      (item) => item.automatedIsirnumber == prevDataAdd2.automatedIsirnumber
    );
    console.log("datainTab2", datainTab2);
    if (datainTab2) {
      let iipText = datainTab2.map((x) => x.isIipuploaded);
      console.log("iipText", iipText);
    }
    if (datainTab2) {
      let poImgText = datainTab2.map((x) => x.isPotextUploaded);
      console.log("iipText", poImgText);
    }
    datainTab2.map((x) => {
      if (x.rdLocationId == 4) {
        setHebburnRndLoc(true);
      }
    });

    //  closeBtnEnabledConditionData(prevDataAdd2.automatedIsirnumber);
    // getIsirDocumentListData()
  }, [getDinAddisirTab2]);

  useEffect(() => {
    if (prevDataAdd2 && prevDataAdd2.automatedIsirnumber && !isUploading) {
      closeBtnEnabledConditionData(prevDataAdd2.automatedIsirnumber);
    }
  }, [prevDataAdd2.automatedIsirnumber, isUploading]);

  //useEffect(() => {
  //   // closeBtnEnabledConditionData(prevDataAdd2.automatedIsirnumber);
  //    if (closeBtnEnableResponse) {
  //        dispatch(closeEnableForChildTypeAction(true));
  //    }
  //}, [prevDataAdd2.automatedIsirnumber])
  //function downloadBallon() {
  //    //let x = downloadtab2data.filter((x) => x.uploadfiletype === 8);
  //    //console.log("x", x);
  //    let attachmentdata = {

  //        AutomatedIsirnumber: isirNumberPassed,
  //        Uploadfiletype: uploadTypeValue,
  //    }

  //    const fetchpromise = fetch(baseApiURL + "/Admin/ISIRdownloadfile",
  //        {
  //            method: "post",
  //            headers: {
  //                "content-type": "application/json; charset=utf-8",
  //                "authorization": "bearer " + token,
  //            },
  //            body: JSON.stringify(attachmentdata),
  //        });
  //    fetchpromise.then(response => {
  //      console.log("file",response)
  //        response.blob().then(blob => {
  //            const link = document.createelement('a');
  //            const url = url.createobjecturl(blob);
  //            link.href = url;
  //            link.download = "download.pdf"
  //            //link.click();

  //            document.body.appendChild(link);
  //            link.click();
  //            document.body.removeChild(link);
  //            window.URL.revokeObjectURL(url);
  //        })
  //    })
  //}

  function downloadBallon() {
    //let x = downloadTab2Data.filter((x) => x.uploadfiletype === 8);
    //console.log("x", x);
    let attachmentData = {
      AutomatedIsirnumber: isirNumberPassed,
      Uploadfiletype: uploadTypeValue,
    };

    window.open(
      baseURL +
        "/ISIRdownloadfile?AutomatedIsirnumber=" +
        isirNumberPassed +
        "& Uploadfiletype=" +
        uploadTypeValue,
      "_blank"
    );
  }
  function downloadBallon2() {
    //let x = downloadTab2Data.filter((x) => x.uploadfiletype === 8);
    //console.log("x", x);
    let attachmentData = {
      AutomatedIsirnumber: isirNumberPassed,
      Uploadfiletype: uploadTypeValue,
    };

    window.open(
      baseURL +
        "/ISIRdownloadfile?AutomatedIsirnumber=" +
        isirNumberPassed +
        "& Uploadfiletype=" +
        uploadTypeValue9,
      "_blank"
    );
  }
  function downloadBallon3() {
    //let x = downloadTab2Data.filter((x) => x.uploadfiletype === 8);
    //console.log("x", x);
    let attachmentData = {
      AutomatedIsirnumber: isirNumberPassed,
      Uploadfiletype: uploadTypeValue10,
    };

    window.open(
      baseURL +
        "/ISIRdownloadfile?AutomatedIsirnumber=" +
        isirNumberPassed +
        "& Uploadfiletype=" +
        uploadTypeValue10,
      "_blank"
    );
  }
  function downloadBallon4() {
    //let x = downloadTab2Data.filter((x) => x.uploadfiletype === 8);
    //console.log("x", x);
    let attachmentData = {
      AutomatedIsirnumber: isirNumberPassed,
      Uploadfiletype: uploadTypeValue11,
    };

    window.open(
      baseURL +
        "/ISIRdownloadfile?AutomatedIsirnumber=" +
        isirNumberPassed +
        "& Uploadfiletype=" +
        uploadTypeValue11,
      "_blank"
    );
  }

  function downloadBallon5() {
    //let x = downloadTab2Data.filter((x) => x.uploadfiletype === 8);
    //console.log("x", x);
    let attachmentData = {
      AutomatedIsirnumber: isirNumberPassed,
      Uploadfiletype: uploadTypeValue12,
    };

    window.open(
      baseURL +
        "/ISIRdownloadfile?AutomatedIsirnumber=" +
        isirNumberPassed +
        "& Uploadfiletype=" +
        uploadTypeValue12,
      "_blank"
    );
  }

  function downloadBallon6() {
    //let x = downloadTab2Data.filter((x) => x.uploadfiletype === 8);
    //console.log("x", x);
    let attachmentData = {
      AutomatedIsirnumber: isirNumberPassed,
      Uploadfiletype: uploadTypeValue13,
    };

    window.open(
      baseURL +
        "/ISIRdownloadfile?AutomatedIsirnumber=" +
        isirNumberPassed +
        "& Uploadfiletype=" +
        uploadTypeValue13,
      "_blank"
    );
  }

  function downloadBallon7() {
    //let x = downloadTab2Data.filter((x) => x.uploadfiletype === 8);
    //console.log("x", x);
    let attachmentData = {
      AutomatedIsirnumber: isirNumberPassed,
      Uploadfiletype: uploadTypeValue14,
    };

    window.open(
      baseURL +
        "/ISIRdownloadfile?AutomatedIsirnumber=" +
        isirNumberPassed +
        "& Uploadfiletype=" +
        uploadTypeValue14,
      "_blank"
    );
  }
  function downloadBallon8isirPdf() {
    //let x = downloadTab2Data.filter((x) => x.uploadfiletype === 8);
    //console.log("x", x);
    let attachmentData = {
      AutomatedIsirnumber: isirNumberPassed,
      Uploadfiletype: uploadTypeValue15,
    };

    window.open(
      baseURL +
        "/ISIRdownloadfile?AutomatedIsirnumber=" +
        isirNumberPassed +
        "& Uploadfiletype=" +
        uploadTypeValue15,
      "_blank"
    );
  }

  function downloadBallon9qualityPlan() {
    //let x = downloadTab2Data.filter((x) => x.uploadfiletype === 8);
    //console.log("x", x);
    let attachmentData = {
      AutomatedIsirnumber: isirNumberPassed,
      Uploadfiletype: uploadTypeValue16,
    };

    window.open(
      baseURL +
        "/ISIRdownloadfile?AutomatedIsirnumber=" +
        isirNumberPassed +
        "& Uploadfiletype=" +
        uploadTypeValue16,
      "_blank"
    );
  }

  function downloadBallonSQMAPQPQuestinare() {
    //let x = downloadTab2Data.filter((x) => x.uploadfiletype === 8);
    //console.log("x", x);
    let attachmentData = {
      AutomatedIsirnumber: isirNumberPassed,
      Uploadfiletype: uploadTypeValueSQMApqpQuestinare,
    };

    window.open(
      baseURL +
        "/ISIRdownloadfile?AutomatedIsirnumber=" +
        isirNumberPassed +
        "& Uploadfiletype=" +
        uploadTypeValueSQMApqpQuestinare,
      "_blank"
    );
  }

  function downloadBallon10PpapReview() {
    //let x = downloadTab2Data.filter((x) => x.uploadfiletype === 8);
    //console.log("x", x);
    let attachmentData = {
      AutomatedIsirnumber: isirNumberPassed,
      Uploadfiletype: uploadTypeValue17,
    };

    window.open(
      baseURL +
        "/ISIRdownloadfile?AutomatedIsirnumber=" +
        isirNumberPassed +
        "& Uploadfiletype=" +
        uploadTypeValue17,
      "_blank"
    );
  }
  function downloadBallon11PpapSignoff() {
    //let x = downloadTab2Data.filter((x) => x.uploadfiletype === 8);
    //console.log("x", x);
    let attachmentData = {
      AutomatedIsirnumber: isirNumberPassed,
      Uploadfiletype: uploadTypeValue18,
    };

    window.open(
      baseURL +
        "/ISIRdownloadfile?AutomatedIsirnumber=" +
        isirNumberPassed +
        "& Uploadfiletype=" +
        uploadTypeValue18,
      "_blank"
    );
  }
  function downloadBallon12IncomingQualityReport() {
    //let x = downloadTab2Data.filter((x) => x.uploadfiletype === 8);
    //console.log("x", x);
    let attachmentData = {
      AutomatedIsirnumber: isirNumberPassed,
      Uploadfiletype: uploadTypeValue19,
    };

    window.open(
      baseURL +
        "/ISIRdownloadfile?AutomatedIsirnumber=" +
        isirNumberPassed +
        "& Uploadfiletype=" +
        uploadTypeValue19,
      "_blank"
    );
  }
  //downloadBallon8isircrer
  function downloadBallon13isircrer() {
    //let x = downloadTab2Data.filter((x) => x.uploadfiletype === 8);
    //console.log("x", x);
    let attachmentData = {
      AutomatedIsirnumber: isirNumberPassed,
      Uploadfiletype: uploadTypeValue20,
    };

    window.open(
      baseURL +
        "/ISIRdownloadfile?AutomatedIsirnumber=" +
        isirNumberPassed +
        "& Uploadfiletype=" +
        uploadTypeValue20,
      "_blank"
    );
  }

  function downloadBallon14ComponentApprover() {
    //let x = downloadTab2Data.filter((x) => x.uploadfiletype === 8);
    //console.log("x", x);
    let attachmentData = {
      AutomatedIsirnumber: isirNumberPassed,
      Uploadfiletype: uploadTypeValue21,
    };

    window.open(
      baseURL +
        "/ISIRdownloadfile?AutomatedIsirnumber=" +
        isirNumberPassed +
        "& Uploadfiletype=" +
        uploadTypeValue21,
      "_blank"
    );
  }
  //uploadTypeValue39
  function downloadBallon15Heburn() {
    //let x = downloadTab2Data.filter((x) => x.uploadfiletype === 8);
    //console.log("x", x);
    let attachmentData = {
      AutomatedIsirnumber: isirNumberPassed,
      Uploadfiletype: uploadTypeValue39,
    };

    window.open(
      baseURL +
        "/ISIRdownloadfile?AutomatedIsirnumber=" +
        isirNumberPassed +
        "& Uploadfiletype=" +
        uploadTypeValue39,
      "_blank"
    );
  }
  //uploadTypeValue38
  function downloadBallon16AddituionalUploadByce() {
    //let x = downloadTab2Data.filter((x) => x.uploadfiletype === 8);
    //console.log("x", x);
    let attachmentData = {
      AutomatedIsirnumber: isirNumberPassed,
      Uploadfiletype: uploadTypeValue38,
    };

    window.open(
      baseURL +
        "/ISIRdownloadfile?AutomatedIsirnumber=" +
        isirNumberPassed +
        "& Uploadfiletype=" +
        uploadTypeValue38,
      "_blank"
    );
  }

  const [openDialogPo, setOpenDialogPo] = React.useState(false);

  const handleClickOpenPo = () => {
    setOpenDialogPo(true);
  };

  const handleCloseDialogPo = () => {
    setOpenDialogPo(false);
  };

  // History of Files
  const [openFileHistoryDialog, setOpenFileHistoryDialog] = useState(false);
  const [historyTableData, setHistoryTableData] = useState(null);
  const [tableStringContent, setTableStringContent] = useState(null);
  const [loaderNew, isLoaderNew] = useState(false);
  async function fetchFileHistory(uploadFileType) {
    isLoaderNew(true);
    const response = await getFileHistory(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      isirNumberPassed,
      uploadFileType
    );
    if (response) {
      console.log("TYPE SENT:", uploadFileType);
      console.log("API RESPONSE:", response);
      if (response !== null && typeof response === "string") {
        setTableStringContent(response);
      } else if (response !== null && typeof response === "object") {
        // setHistoryTableData(response);
        const filteredData = response.filter(
          (item) => item.uploadfiletype === uploadFileType
        );
        setHistoryTableData(filteredData);
      } else {
        setTableStringContent("Error in fetching data.");
      }
      isLoaderNew(false);
      setOpenFileHistoryDialog(true);
      return response;
    } else {
      setTableStringContent("Error in fetching data.");
      isLoaderNew(false);
      setOpenFileHistoryDialog(true);
    }
  }

  const infoIconClick = (uploadType) => {
    const resp = fetchFileHistory(uploadType);
  };
  function closeFileHistoryDialog(event, reason) {
    if (reason === "backdropClick") {
      return;
    }
    setOpenFileHistoryDialog(false);
  }

  function downloadIcon(rowData) {
    let rData = rowData;
    const fileNameLoc = rowData?.fileName?.trim();
    const fileType = rowData?.filetype?.split(".")[1].trim();
    let mimeType;
    switch (fileType.toLowerCase().trim()) {
      case "pdf":
        mimeType = "application/pdf";
        break;
      case "xlsx":
        mimeType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        break;
      case "xls":
        mimeType = "application/vnd.ms-excel";
        break;
      case "csv":
        mimeType = "text/csv";
        break;
      default:
        mimeType = "application/octet-stream";
    }
    function downloadFilesSelected() {
      isLoaderNew(true);
      const options = {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: "Bearer " + siteToken.token,
          AzureToken: azureToken.token,
          UserEmail: userDetails.userEmail,
          RoleName: userDetails.role,
          Gid: userDetails.gid,
          Roleid: userDetails.roleId,
          userId: UID.id,
        },
        responseType: "arraybuffer",
      };
      axios
        .get(
          baseApiURLS +
            "/api/Admin/ISIRHistoryDownloadfile?IsirAttachmentId=" +
            rData.isirattachmentId,
          options
        )
        .then((response) => {
          isLoaderNew(false);
          if (response.status === 200) {
            if (response.data) {
              var fileBlob = new Blob([response.data], { type: mimeType });
              FileSaver.saveAs(fileBlob, fileNameLoc);
              isLoaderNew(false);
              handleSnackOpen("File downloaded.", "success");
            } else {
              isLoaderNew(false);
              handleSnackOpen("No Records are Found.", "warning");
            }
          } else {
            isLoaderNew(false);
            handleSnackOpen("File Not Found !!", "warning");
          }
        })
        .catch((err) => {
          isLoaderNew(false);
          handleSnackOpen("Error !!", "error");
        });
    }
    return (
      <IconButton
        className="p-0"
        target="_blank"
        onClick={downloadFilesSelected}
      >
        <GetAppOutlinedIcon />
      </IconButton>
    );
  }

  const columnsNew = [
    {
      title: "Download",
      render: (rowData) => downloadIcon(rowData),
    },
    {
      title: "File Name",
      field: "fileName",
    },
  ];
  const tableHeaderStyle = {
    backgroundColor: "var(--light-sand--type-1)",
    color: "var(--dark-blue)",
  };
  const tableOptionsUser = {
    headerStyle: tableHeaderStyle,
    showTitle: false,
    draggable: false,
    pageSize: 5,
    export: false,
    pageSizeOptions: [5, 10, 25, 50],
    paginationPosition: "bottom",
    maxBodyHeight: "600px",
  };
  // const isirDocumentList = useSelector((state) => state.saveIsirDocumentList.isir);
  // function getIsirDocumentListData() {
  //   setIsLoader(true);
  //   const isirNo = prevDataAdd2.automatedIsirnumber
  //   getIsirDocumentList(
  //     siteToken.token,
  //     azureToken.token,
  //     UID.id,
  //     userDetails.userEmail,
  //     userDetails.gid,
  //     userDetails.role,
  //     userDetails.roleId,
  //     isirNo,

  //   )
  //     .then((response) => {
  //       //setIsirDocumentList(response);
  //        dispatch(storeIsirDocumentList(response));

  //       //console.log('isirDocumentList',isirDocumentList);
  //       setIsLoader(false);
  //     })
  //     .catch((error) => {
  //       handleSnackOpen("Error : " + error, "error");
  //       setIsLoader(false);
  //     });
  // }

  const isDocumentMandatoryForRole = (docName) => {
    return (
      (userDetails.roleId === 3 ||
        userDetails.roleId === 6 ||
        userDetails.roleId === 1 ||
        userDetails.roleId === 2 ||
        userDetails.roleId === 7) &&
      documentList?.some(
        (doc) => doc.documentName === docName && doc.isMandatory
      )
    );
  };

  let sqmCheckApqpFileCheck =
    documentList &&
    documentList.some(
      (item) =>
        item.documentId == 28 &&
        item.documentName == "SQM Check_APQP Questionnaire.pdf" &&
        item.isMandatory == true
    );
  console.log("sqmCheckApqpFileCheck", sqmCheckApqpFileCheck);

  let balloningDrawingFileCheck =
    documentList &&
    documentList.some(
      (item) =>
        item.documentId == 10 &&
        item.documentName == "Ballooning Drawing.pdf" &&
        item.isMandatory == true
    );
  console.log("balloningDrawingFileCheck", balloningDrawingFileCheck);

  let tfcFileCheck =
    documentList &&
    documentList.some(
      (item) =>
        item.documentId == 11 &&
        item.documentName == "Filled and Signed EM EA GF QM FR 033_TFC.pdf" &&
        item.isMandatory == true
    );
  console.log("tfcFileCheck", tfcFileCheck);

  let trmFileCheck =
    documentList &&
    documentList.some(
      (item) =>
        item.documentId == 12 &&
        item.documentName == "Filled and Signed EM EA GF QM FR 046_TRM.pdf" &&
        item.isMandatory == true
    );
  console.log("trmFileCheck", trmFileCheck);

  let dfmFileCheck =
    documentList &&
    documentList.some(
      (item) =>
        item.documentId == 13 &&
        item.documentName == "DFM.ppt" &&
        item.isMandatory == true
    );
  console.log("dfmFileCheck", dfmFileCheck);

  let toolDesignFileCheck =
    documentList &&
    documentList.some(
      (item) =>
        item.documentId == 14 &&
        item.documentName == "Tool Design.stp / .igs (Zip file only!)" &&
        item.isMandatory == true
    );
  console.log("toolDesignFileCheck", toolDesignFileCheck);

  let isirXlsmFileCheck =
    documentList &&
    documentList.some(
      (item) =>
        item.documentId == 15 &&
        item.documentName == "EM EA GF QM FR 056_ISIR.xlsm" &&
        item.isMandatory == true
    );
  console.log("isirXlsmFileCheck", isirXlsmFileCheck);
  ////16 number missing-->later found  upload for supplier

  let AdditionalUploadBySupplierFileCheck =
    documentList &&
    documentList.some(
      (item) =>
        item.documentId == 16 &&
        item.documentName ==
          "Additional Uploads By Supplier (Zip file only!)" &&
        item.isMandatory == true
    );
  console.log(
    "AdditionalUploadBySupplierFileCheck",
    AdditionalUploadBySupplierFileCheck
  );

  let isirPdfFileCheck =
    documentList &&
    documentList.some(
      (item) =>
        item.documentId == 17 &&
        item.documentName == "EM EA GF QM FR 056_ISIR.pdf" &&
        item.isMandatory == true
    );
  console.log("isirPdfFileCheck", isirPdfFileCheck);

  let qualityPlanFileCheck =
    documentList &&
    documentList.some(
      (item) =>
        item.documentId == 18 &&
        item.documentName == "EM EA GF QM FR 060_Quality Plan.pdf (IIP)" &&
        item.isMandatory == true
    );
  console.log("qualityPlanFileCheck", qualityPlanFileCheck);

  let ppaeXlsxReviewFileCheck =
    documentList &&
    documentList.some(
      (item) =>
        item.documentId == 19 &&
        item.documentName == "PPAP.xlsx for review" &&
        item.isMandatory == true
    );
  console.log("ppaeXlsxReviewFileCheck", ppaeXlsxReviewFileCheck);

  let ppapSignoffFileCheck =
    documentList &&
    documentList.some(
      (item) =>
        item.documentId == 20 &&
        item.documentName == "PPAP.pdf for signoff" &&
        item.isMandatory == true
    );
  console.log("ppapSignoffFileCheck", ppapSignoffFileCheck);

  let incomingQulaityReportFileCheck =
    documentList &&
    documentList.some(
      (item) =>
        item.documentId == 21 &&
        item.documentName == "Incoming Quality Report.pdf (Pilot Batch)" &&
        item.isMandatory == true
    );
  console.log("incomingQulaityReportFileCheck", incomingQulaityReportFileCheck);

  let HebburnApprovalFileCheck =
    documentList &&
    documentList.some(
      (item) =>
        item.documentId == 22 &&
        item.documentName == "Approval from SPDL,Hebburn" &&
        item.isMandatory == true
    );
  console.log("HebburnApprovalFileCheck", HebburnApprovalFileCheck);

  let crerPdfFileCheck =
    documentList &&
    documentList.some(
      (item) =>
        item.documentId == 23 &&
        item.documentName == "CRER.pdf" &&
        item.isMandatory == true
    );
  console.log("crerPdfFileCheck", crerPdfFileCheck);

  let componentApprovalFileCheck =
    documentList &&
    documentList.some(
      (item) =>
        item.documentId == 24 &&
        item.documentName == "Component Approval form.pdf" &&
        item.isMandatory == true
    );
  console.log("componentApprovalFileCheck", componentApprovalFileCheck);

  let AdditionalUploadByCEFileCheck =
    documentList &&
    documentList.some(
      (item) =>
        item.documentId == 25 &&
        item.documentName == "Additional upload By CE (Zip file only!)" &&
        item.isMandatory == true
    );
  console.log("AdditionalUploadByCEFileCheck", AdditionalUploadByCEFileCheck);

  return (
    <div>
      <Grid container spacing={2} className="part-two">
        {/*  <Grid className={balloningDrawingFileCheck ? "spaceremover" :"hidden"}>*/}
        {userDetails.roleId === 1 ||
        userDetails.roleId == 2 ||
        userDetails.roleId === 6 ? (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={balloningDrawingFileCheck ? "spaceremover" : "hidden"}
          >
            {isDocumentMandatoryForRole("Ballooning Drawing.pdf") && (
              <TextField
                label="Ballooning Drawing.pdf"
                // label={ <>
                //   Ballooning Drawing.pdf
                //   {(userDetails.roleId === 3) &&
                //     isirDocumentList?.filter(z =>
                //       z.documentName == 'Ballooning Drawing.pdf' &&
                //       z.isMandatory
                //     ).length > 0 &&
                //     // file uploaded nahi hui
                //     (<span style={{ color: "red" }}>*</span>)
                //   }
                //</>}
                type="file"
                id="BallooningFile"
                name="BallooningFile"
                fullWidth
                disabled={groupData === 3 || prevDataAdd2.groupId === 3}
                key={balloningDrawingpdfKey}
                onChange={handleballoning}
                variant="filled"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className="p-0"
                        target="_blank"
                        href={download1Docx}
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            )}
            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Data1}</span> : " "} */}
            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Data1}</span>
                {isDocumentMandatoryForRole("Ballooning Drawing.pdf") && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(8)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : userDetails.roleId === 3 ? (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={balloningDrawingFileCheck ? "spaceremover" : "hidden"}
          >
            {isDocumentMandatoryForRole("Ballooning Drawing.pdf") && (
              <TextField
                label={
                  <>
                    Ballooning Drawing.pdf
                    {userDetails.roleId === 3 &&
                      documentList?.filter(
                        (z) =>
                          z.documentName === "Ballooning Drawing.pdf" &&
                          z.isMandatory
                      ) &&
                      !balloningDrawing && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                  </>
                }
                type="file"
                id="BallooningFile"
                name="BallooningFile"
                fullWidth
                disabled={groupData === 3 || prevDataAdd2.groupId === 3}
                key={balloningDrawingpdfKey}
                onChange={handleballoning}
                variant="filled"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className="p-0"
                        target="_blank"
                        onClick={downloadBallon}
                        //href={download1Docx}
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            )}
            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Data1}</span> : " "} */}
            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Data1}</span>
                {isDocumentMandatoryForRole("Ballooning Drawing.pdf") && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(8)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={4}>
            {download1Docx ? (
              <a target="_blank" href={download1Docx}>
                <span className="link-filed">
                  Download Ballooning Drawing template
                </span>
              </a>
            ) : (
              <a>
                <span className="link-filed">
                  <button className="disabled-link" disabled>
                    Download Ballooning Drawing template
                  </button>
                </span>
              </a>
            )}
          </Grid>
        )}
        {/*  </Grid>*/}
        {/* <Grid className={tfcFileCheck ? "spaceremover" : "hidden"}>*/}
        {userDetails.roleId == 3 ? (
          <Grid
            item
            xs={12}
            sm={8}
            md={4}
            className={tfcFileCheck ? "spaceremover" : "hidden"}
          >
            {isDocumentMandatoryForRole(
              "Filled and Signed EM EA GF QM FR 033_TFC.pdf"
            ) && (
              <TextField
                // label="Filled and Signed EM EA GF QM FR 033_TFC.pdf"
                label={
                  <>
                    Filled and Signed EM EA GF QM FR 033_TFC.pdf
                    {userDetails.roleId === 3 &&
                      documentList?.filter(
                        (z) =>
                          z.documentName ==
                            "Filled and Signed EM EA GF QM FR 033_TFC.pdf" &&
                          z.isMandatory
                      ).length > 0 &&
                      !fileFilledandSignedtfc && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                  </>
                }
                type="file"
                id="033_TFC"
                name="033_TFC"
                className=""
                fullWidth
                disabled={
                  groupData === 3 ||
                  developmentData == 1 ||
                  prevDataAdd2.groupId == 3 ||
                  prevDataAdd2.developmentTypeId == 1
                }
                key={fileFilledandSignedtfcKey}
                onChange={handleHandlesignedtfc}
                variant="filled"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className="p-0"
                        target="_blank"
                        onClick={downloadBallon2}
                        //href={download2Docx}
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            )}
            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Data2}</span> : " "} */}
            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Data2}</span>
                {isDocumentMandatoryForRole(
                  "Filled and Signed EM EA GF QM FR 033_TFC.pdf"
                ) && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(9)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : userDetails.roleId == 1 ||
          userDetails.roleId === 2 ||
          userDetails.roleId === 6 ? (
          <Grid
            item
            xs={12}
            sm={8}
            md={4}
            className={tfcFileCheck ? "spaceremover" : "hidden"}
          >
            {isDocumentMandatoryForRole(
              "Filled and Signed EM EA GF QM FR 033_TFC.pdf"
            ) && (
              <TextField
                label="Filled and Signed EM EA GF QM FR 033_TFC.pdf"
                type="file"
                id="033_TFC"
                name="033_TFC"
                className=""
                fullWidth
                disabled={
                  groupData === 3 ||
                  developmentData == 1 ||
                  prevDataAdd2.groupId == 3 ||
                  prevDataAdd2.developmentTypeId == 1
                }
                key={fileFilledandSignedtfcKey}
                onChange={handleHandlesignedtfc}
                variant="filled"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className="p-0"
                        target="_blank"
                        //onClick={downloadBallon2}
                        href={download2Docx}
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            )}
            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Data2}</span> : " "} */}
            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Data2}</span>
                {isDocumentMandatoryForRole(
                  "Filled and Signed EM EA GF QM FR 033_TFC.pdf"
                ) && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(9)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={4}>
            {download2Docx ? (
              <a target="_blank" href={download2Docx}>
                <span className="link-filed">Download TFC.pdf</span>
              </a>
            ) : (
              <a>
                <span className="link-filed">
                  <button className="disabled-link" disabled>
                    Download TFC.pdf
                  </button>
                </span>
              </a>
            )}
          </Grid>
        )}
        {/* </Grid>*/}

        {/*  <Grid className={trmFileCheck ? "spaceremover" : "hidden"}>*/}
        {userDetails.roleId == 6 ||
        userDetails.roleId === 1 ||
        userDetails.roleId === 2 ? (
          <Grid
            item
            xs={12}
            sm={8}
            md={4}
            className={trmFileCheck ? "spaceremover" : "hidden"}
          >
            {isDocumentMandatoryForRole(
              "Filled and Signed EM EA GF QM FR 046_TRM.pdf"
            ) && (
              <TextField
                label="Filled and Signed EM EA GF QM FR 046_TRM.pdf"
                // label={ <>
                //   Filled and Signed EM EA GF QM FR 046_TRM.pdf
                //   {
                //     isirDocumentList?.filter(z =>
                //       z.documentName == 'Filled and Signed EM EA GF QM FR 046_TRM.pdf' &&
                //       z.isMandatory
                //     ).length > 0 &&
                //     // file uploaded nahi hui
                //     (<span style={{ color: "red" }}>*</span>)
                //   }
                // </>}
                type="file"
                id="046_TRM"
                name="046_TRM"
                className=""
                fullWidth
                //disabled={((((groupData == 1 ||groupData == 2|| groupData == 4||groupData == 5)||(prevDataAdd2.groupId == 1 ||prevDataAdd2.groupId == 2||prevDataAdd2.groupId == 4 ||prevDataAdd2.groupId == 5) && (prevDataAdd2.developmentTypeId==2 || developmentData == 2))&& (!prevDataAdd2.purchaseorderNumber && !prevDataAdd2.purchaseorderDate))||((groupData == 3 || prevDataAdd2.groupId == 3)|| (prevDataAdd2.developmentTypeId == 1 || developmentData == 1)))}
                disabled={
                  groupData === 3 ||
                  developmentData == 1 ||
                  prevDataAdd2.groupId == 3 ||
                  prevDataAdd2.developmentTypeId == 1
                }
                key={fileFilledandSignedtrmKey}
                onChange={handleTrm}
                variant="filled"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className="p-0"
                        target="_blank"
                        // onClick={downloadBallon3}
                        href={download3Docx}
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            )}
            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Data3}</span> : " "} */}
            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Data3}</span>
                {isDocumentMandatoryForRole(
                  "Filled and Signed EM EA GF QM FR 046_TRM.pdf"
                ) && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(10)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : userDetails.roleId === 3 ? (
          <Grid
            item
            xs={12}
            sm={8}
            md={4}
            className={trmFileCheck ? "spaceremover" : "hidden"}
          >
            {isDocumentMandatoryForRole(
              "Filled and Signed EM EA GF QM FR 046_TRM.pdf"
            ) && (
              <TextField
                //label="Filled and Signed EM EA GF QM FR 046_TRM.pdf"
                label={
                  <>
                    Filled and Signed EM EA GF QM FR 046_TRM.pdf
                    {userDetails.roleId === 3 &&
                      documentList?.filter(
                        (z) =>
                          z.documentName ==
                            "Filled and Signed EM EA GF QM FR 046_TRM.pdf" &&
                          z.isMandatory
                      ).length > 0 &&
                      !fileFilledandSignedtrm && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                  </>
                }
                type="file"
                id="046_TRM"
                name="046_TRM"
                className=""
                fullWidth
                //disabled={((((groupData == 1 ||groupData == 2|| groupData == 4||groupData == 5)||(prevDataAdd2.groupId == 1 ||prevDataAdd2.groupId == 2||prevDataAdd2.groupId == 4 ||prevDataAdd2.groupId == 5) && (prevDataAdd2.developmentTypeId==2 || developmentData == 2))&& (!prevDataAdd2.purchaseorderNumber && !prevDataAdd2.purchaseorderDate))||((groupData == 3 || prevDataAdd2.groupId == 3)|| (prevDataAdd2.developmentTypeId == 1 || developmentData == 1)))}
                disabled={
                  groupData === 3 ||
                  developmentData == 1 ||
                  prevDataAdd2.groupId == 3 ||
                  prevDataAdd2.developmentTypeId == 1
                }
                key={fileFilledandSignedtrmKey}
                onChange={handleTrm}
                variant="filled"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className="p-0"
                        target="_blank"
                        onClick={downloadBallon3}
                        //href={download3Docx}
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            )}
            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Data3}</span> : " "} */}
            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Data3}</span>
                {isDocumentMandatoryForRole(
                  "Filled and Signed EM EA GF QM FR 046_TRM.pdf"
                ) && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(10)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={4}>
            {download3Docx ? (
              <a target="_blank" href={download3Docx}>
                <span className="link-filed">Download TRM.pdf</span>
              </a>
            ) : (
              <a>
                <span className="link-filed">
                  <button className="disabled-link" disabled>
                    Download TRM.pdf{" "}
                  </button>
                </span>
              </a>
            )}
          </Grid>
        )}

        {/*  </Grid>*/}
        {/*  <Grid className={dfmFileCheck ? "spaceremover" : "hidden"}>*/}
        {userDetails.roleId == 6 ||
        userDetails.roleId === 1 ||
        userDetails.roleId === 2 ? (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={dfmFileCheck ? "spaceremover" : "hidden"}
          >
            {isDocumentMandatoryForRole("DFM.ppt") && (
              <TextField
                label="DFM.ppt"
                type="file"
                id="DFM.ppt"
                name="DFM.ppt"
                className=""
                fullWidth
                //disabled={((((groupData == 1 ||groupData == 2|| groupData == 4||groupData == 5)||(prevDataAdd2.groupId == 1 ||prevDataAdd2.groupId == 2||prevDataAdd2.groupId == 4 ||prevDataAdd2.groupId == 5) && (prevDataAdd2.developmentTypeId==2 || developmentData == 2))&& (!prevDataAdd2.purchaseorderNumber && !prevDataAdd2.purchaseorderDate))||((groupData == 3 || prevDataAdd2.groupId == 3)|| (prevDataAdd2.developmentTypeId == 1 || developmentData == 1)))}
                disabled={
                  groupData === 3 ||
                  developmentData == 1 ||
                  prevDataAdd2.groupId == 3 ||
                  prevDataAdd2.developmentTypeId == 1
                }
                key={filedfmKey}
                onChange={handleFM}
                variant="filled"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className="p-0"
                        target="_blank"
                        // onClick={downloadBallon4}
                        href={download4Docx}
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            )}
            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Data4}</span> : " "} */}
            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Data4}</span>
                {isDocumentMandatoryForRole("DFM.ppt") && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(11)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : userDetails.roleId === 3 ? (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={dfmFileCheck ? "spaceremover" : "hidden"}
          >
            {isDocumentMandatoryForRole("DFM.ppt") && (
              <TextField
                // label="DFM.ppt"
                label={
                  <>
                    DFM.ppt
                    {userDetails.roleId === 3 &&
                      documentList?.filter(
                        (z) => z.documentName == "DFM.ppt" && z.isMandatory
                      ).length > 0 &&
                      !filedfm && <span style={{ color: "red" }}>*</span>}
                  </>
                }
                type="file"
                id="DFM.ppt"
                name="DFM.ppt"
                className=""
                fullWidth
                //disabled={((((groupData == 1 ||groupData == 2|| groupData == 4||groupData == 5)||(prevDataAdd2.groupId == 1 ||prevDataAdd2.groupId == 2||prevDataAdd2.groupId == 4 ||prevDataAdd2.groupId == 5) && (prevDataAdd2.developmentTypeId==2 || developmentData == 2))&& (!prevDataAdd2.purchaseorderNumber && !prevDataAdd2.purchaseorderDate))||((groupData == 3 || prevDataAdd2.groupId == 3)|| (prevDataAdd2.developmentTypeId == 1 || developmentData == 1)))}
                disabled={
                  groupData === 3 ||
                  developmentData == 1 ||
                  prevDataAdd2.groupId == 3 ||
                  prevDataAdd2.developmentTypeId == 1
                }
                key={filedfmKey}
                onChange={handleFM}
                variant="filled"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className="p-0"
                        target="_blank"
                        onClick={downloadBallon4}
                        //href={download4Docx}
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            )}
            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Data4}</span> : " "} */}
            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Data4}</span>
                {isDocumentMandatoryForRole("DFM.ppt") && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(11)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={4}>
            {download4Docx ? (
              <a target="_blank" href={download4Docx}>
                <span className="link-filed">Download DFM ppt</span>
              </a>
            ) : (
              <a>
                <span className="link-filed">
                  <button className="disabled-link" disabled>
                    Download DFM ppt{" "}
                  </button>
                </span>
              </a>
            )}
          </Grid>
        )}

        {userDetails.roleId == 6 ||
        userDetails.roleId === 1 ||
        userDetails.roleId === 2 ? (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={toolDesignFileCheck ? "spaceremover" : "hidden"}
          >
            {isDocumentMandatoryForRole(
              "Tool Design.stp / .igs (Zip file only!)"
            ) && (
              <TextField
                label="Tool Design.stp / .igs (Zip file only!)"
                type="file"
                id="toolDesignSTP"
                name="toolDesignSTP"
                className=""
                fullWidth
                //disabled={((((groupData == 1 ||groupData == 2|| groupData == 4||groupData == 5)||(prevDataAdd2.groupId == 1 ||prevDataAdd2.groupId == 2||prevDataAdd2.groupId == 4 ||prevDataAdd2.groupId == 5) && (prevDataAdd2.developmentTypeId==2 || developmentData == 2))&& (!prevDataAdd2.purchaseorderNumber && !prevDataAdd2.purchaseorderDate))||((groupData == 3 || prevDataAdd2.groupId == 3)|| (prevDataAdd2.developmentTypeId == 1 || developmentData == 1)))}
                disabled={
                  groupData === 3 ||
                  developmentData == 1 ||
                  prevDataAdd2.groupId == 3 ||
                  prevDataAdd2.developmentTypeId == 1
                }
                key={fileToolDesignStpKey}
                onChange={handleToolDesign}
                variant="filled"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className="p-0"
                        target="_blank"
                        // onClick={downloadBallon5}
                        href={download5Docx}
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            )}
            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Data4}</span> : " "} */}
            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Data5}</span>
                {isDocumentMandatoryForRole(
                  "Tool Design.stp / .igs (Zip file only!)"
                ) && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(12)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : userDetails.roleId === 3 ? (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={toolDesignFileCheck ? "spaceremover" : "hidden"}
          >
            {isDocumentMandatoryForRole(
              "Tool Design.stp / .igs (Zip file only!)"
            ) && (
              <TextField
                // label="Tool Design.stp / .igs (Zip file only!)"
                label={
                  <>
                    Tool Design.stp / .igs (Zip file only!)
                    {userDetails.roleId === 3 &&
                      documentList?.filter(
                        (z) =>
                          z.documentName ==
                            "Tool Design.stp / .igs (Zip file only!)" &&
                          z.isMandatory
                      ).length > 0 &&
                      !fileToolDesignstp && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                  </>
                }
                type="file"
                id="toolDesignSTP"
                name="toolDesignSTP"
                className=""
                fullWidth
                disabled={
                  groupData === 3 ||
                  developmentData == 1 ||
                  prevDataAdd2.groupId == 3 ||
                  prevDataAdd2.developmentTypeId == 1
                }
                key={fileToolDesignStpKey}
                onChange={handleToolDesign}
                variant="filled"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className="p-0"
                        target="_blank"
                        onClick={downloadBallon5}
                        //href={download5Docx}
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            )}
            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Data5}</span> : " "} */}
            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Data5}</span>
                {isDocumentMandatoryForRole(
                  "Tool Design.stp / .igs (Zip file only!)"
                ) && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(12)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={4}>
            {download5Docx ? (
              <a target="_blank" href={download5Docx}>
                <span className="link-filed">Download Tool Design </span>
              </a>
            ) : (
              <a>
                <span className="link-filed">
                  <button className="disabled-link" disabled>
                    Download Tool Design{" "}
                  </button>
                </span>
              </a>
            )}
          </Grid>
        )}
        {/*</Grid>*/}
        {/*  <Grid className={isirXlsmFileCheck ? "spaceremover" :"hidden"}>*/}
        {userDetails.roleId === 6 ||
        userDetails.roleId === 1 ||
        userDetails.roleId === 2 ? (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={isirXlsmFileCheck ? "spaceremover" : "hidden"}
          >
            {isDocumentMandatoryForRole("EM EA GF QM FR 056_ISIR.xlsm") && (
              <TextField
                label="EM EA GF QM FR 056_ISIR.xlsm"
                // label={ <>
                //   EM EA GF QM FR 056_ISIR.xlsm
                //   {
                //     (userDetails.roleId === 3) &&
                //     isirDocumentList?.filter(z =>
                //       z.documentName == 'EM EA GF QM FR 056_ISIR.xlsm' &&
                //       z.isMandatory
                //     ).length > 0 &&
                //     // file uploaded nahi hui
                //     (<span style={{ color: "red" }}>*</span>)
                //   }
                // </>}
                type="file"
                id="056_ISIR_xlsm"
                name="056_ISIR_xlsm"
                className=""
                fullWidth
                disabled={groupData === 3 || prevDataAdd2.groupId == 3}
                key={fileEAEMKey}
                onChange={handleIsirxlsm}
                variant="filled"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className="p-0"
                        target="_blank"
                        //onClick={downloadBallon6 }
                        href={download6Docx}
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            )}
            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Data6}</span> : " "} */}
            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Data6}</span>
                {isDocumentMandatoryForRole("EM EA GF QM FR 056_ISIR.xlsm") && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(13)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : userDetails.roleId == 3 ? (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={isirXlsmFileCheck ? "spaceremover" : "hidden"}
          >
            {isDocumentMandatoryForRole("EM EA GF QM FR 056_ISIR.xlsm") && (
              <TextField
                // label="EM EA GF QM FR 056_ISIR.xlsm*"
                label={
                  <>
                    EM EA GF QM FR 056_ISIR.xlsm
                    {userDetails.roleId === 3 &&
                      documentList?.filter(
                        (z) =>
                          z.documentName == "EM EA GF QM FR 056_ISIR.xlsm" &&
                          z.isMandatory
                      ).length > 0 &&
                      !fileEAEM && <span style={{ color: "red" }}>*</span>}
                  </>
                }
                type="file"
                id="056_ISIR_xlsm"
                name="056_ISIR_xlsm"
                className=""
                fullWidth
                disabled={groupData === 3 || prevDataAdd2.groupId == 3}
                key={fileEAEMKey}
                onChange={handleIsirxlsm}
                variant="filled"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className="p-0"
                        target="_blank"
                        onClick={downloadBallon6}
                        //href={download6Docx}
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            )}
            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Data6}</span> : " "} */}
            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Data6}</span>
                {isDocumentMandatoryForRole("EM EA GF QM FR 056_ISIR.xlsm") && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(13)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={4}>
            {download6Docx ? (
              <a target="_blank" href={download6Docx}>
                <span className="link-filed">Download ISIR.xlsm </span>
              </a>
            ) : (
              <a>
                <span className="link-filed">
                  <button className="disabled-link" disabled>
                    Download Tool Design{" "}
                  </button>
                </span>
              </a>
            )}
          </Grid>
        )}
        {/*</Grid>*/}
        {/*  <Grid className={AdditionalUploadBySupplierFileCheck ? "spaceremover" : "hidden"}>*/}
        {userDetails.roleId === 6 ||
        userDetails.roleId === 1 ||
        userDetails.roleId === 2 ? (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={
              AdditionalUploadBySupplierFileCheck ? "spaceremover" : "hidden"
            }
          >
            {isDocumentMandatoryForRole(
              "Additional Uploads By Supplier (Zip file only!)"
            ) && (
              <TextField
                label="Additional Uploads By Supplier (Zip file only!)"
                // label={ <>
                //   Additional Uploads By Supplier (Zip file only!)
                //   {
                //     (userDetails.roleId === 3) &&
                //     isirDocumentList?.filter(z =>
                //       z.documentName == 'Additional Uploads By Supplier (Zip file only!)' &&
                //       z.isMandatory
                //     ).length > 0 &&
                //     // file uploaded nahi hui
                //     (<span style={{ color: "red" }}>*</span>)
                //   }
                // </>}
                type="file"
                id="additionalUploadBySupplier"
                name="additionalUploadBySupplier"
                className=""
                fullWidth
                disabled={groupData === 3 || prevDataAdd2.groupId == 3}
                key={fileAdditionalUploadKey}
                onChange={handleAdditionalUploads}
                variant="filled"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className="p-0"
                        target="_blank"
                        href={download24Docx}
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            )}
            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Data24}</span> : " "} */}

            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Data24}</span>
                {isDocumentMandatoryForRole(
                  "Additional Uploads By Supplier (Zip file only!)"
                ) && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(24)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : userDetails.roleId == 3 ? (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={
              AdditionalUploadBySupplierFileCheck ? "spaceremover" : "hidden"
            }
          >
            {isDocumentMandatoryForRole(
              "Additional Uploads By Supplier (Zip file only!)"
            ) && (
              <TextField
                //label="Additional Uploads By Supplier (Zip file only!)"
                label={
                  <>
                    Additional Uploads By Supplier (Zip file only!)
                    {userDetails.roleId === 3 &&
                      documentList?.filter(
                        (z) =>
                          z.documentName ==
                            "Additional Uploads By Supplier (Zip file only!)" &&
                          z.isMandatory
                      ).length > 0 &&
                      !fileAdditionalUpload && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                  </>
                }
                type="file"
                id="additionalUploadBySupplier"
                name="additionalUploadBySupplier"
                className=""
                fullWidth
                disabled={groupData === 3 || prevDataAdd2.groupId == 3}
                key={fileAdditionalUploadKey}
                onChange={handleAdditionalUploads}
                variant="filled"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className="p-0"
                        target="_blank"
                        onClick={downloadBallon7}
                        //href={download24Docx}
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            )}
            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Data24}</span> : " "} */}

            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Data24}</span>
                {isDocumentMandatoryForRole(
                  "Additional Uploads By Supplier (Zip file only!)"
                ) && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(24)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={4}>
            {download24Docx ? (
              <a target="_blank" href={download24Docx}>
                <span className="link-filed">
                  Download Additional upload By Supplier
                </span>
              </a>
            ) : (
              <a>
                <span className="link-filed">
                  <button className="disabled-link" disabled>
                    Download Additional upload by Supplier
                  </button>
                </span>
              </a>
            )}
          </Grid>
        )}
        {/*  </Grid>*/}

        {/* other than seso*/}
        {/*  <Grid className={AdditionalUploadByCEFileCheck ? "spaceremover" : "hidden"}>*/}
        {(userDetails.roleId === 6 ||
          userDetails.roleId === 1 ||
          userDetails.roleId === 2) &&
        AdditionalUploadByCEFileCheck &&
        (groupData !== 3 || prevDataAdd2.groupId !== 3) &&
        (groupData == 1 ||
          groupData == 2 ||
          groupData == 4 ||
          groupData == 5 ||
          prevDataAdd2.groupId == 1 ||
          prevDataAdd2.groupId == 2 ||
          prevDataAdd2.groupId == 4 ||
          prevDataAdd2.groupId == 5) ? (
                      <Grid item xs={12} sm={6} md={4} className={AdditionalUploadByCEFileCheck && (groupData !== 3 || prevDataAdd2.groupId !== 3 )  ? "spaceremover" : "hidden"}>
          {isDocumentMandatoryForRole("Additional upload By CE (Zip file only!)") && (
            <TextField
              label="Additional upload By CE (Zip file only!)"
              type="file" 
              id="desiredOPInKW"
              name="desiredOPInKW"
              className=""
              fullWidth
            
                                  // disabled={(groupData === 3 || prevDataAdd2.groupId == 3)  && (!prevDataAdd2.purchaseorderNumber && !prevDataAdd2.purchaseorderDate)}
                                  disabled={
                                      ((groupData == 1 ||
                                          groupData == 2 ||
                                          groupData == 4 ||
                                          groupData == 5 ||
                                          ((prevDataAdd2.groupId == 1 ||
                                              prevDataAdd2.groupId == 2 ||
                                              prevDataAdd2.groupId == 4 ||
                                              prevDataAdd2.groupId == 5) &&
                                              (prevDataAdd2.developmentTypeId == 2 ||
                                                  developmentData == 2))) &&
                                          !prevDataAdd2.purchaseorderNumber &&
                                          !prevDataAdd2.purchaseorderDate && prevDataAdd2.typeId == 1) ||
                                      groupData == 3 ||
                                      prevDataAdd2.groupId == 3 ||
                                     

                                      ((!iipActionDataState || !poTextActionDataState) && prevDataAdd2.typeId == 2)
                                  } 

              key={fileAdditionalUploadByCeKey}
              onChange={handleAdditionalUploadsByComponentEngineer}
              variant="filled"
              InputLabelProps={{ shrink: true }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      className="p-0"
                      target="_blank"
                      href={download38Docx}
                    >
                      <CloudDownloadIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            ></TextField>
              )}
            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Databyce38}</span> : " "} */}

            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Databyce38}</span>
                {isDocumentMandatoryForRole(
                  "Additional upload By CE (Zip file only!)"
                ) && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(38)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : userDetails.roleId === 3 &&
          uploadTypeValue38 &&
          (groupData == 1 ||
            groupData == 2 ||
            groupData == 4 ||
            groupData == 5 ||
            prevDataAdd2.groupId == 1 ||
            prevDataAdd2.groupId == 2 ||
            prevDataAdd2.groupId == 4 ||
            prevDataAdd2.groupId == 5) ? (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={
              uploadTypeValue38 &&
              (groupData !== 3 || prevDataAdd2.groupId !== 3)
                ? "spaceremover"
                : "hidden"
            }
          >
            <button
              className="link-filed1"
              onClick={downloadBallon16AddituionalUploadByce}
            >
              Additional upload by CE
            </button>
          </Grid>
        ) : (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={
              uploadTypeValue38 &&
              (groupData !== 3 || prevDataAdd2.groupId !== 3)
                ? "spaceremover"
                : "hidden"
            }
          >
            {download38Docx &&
            (userDetails.roleId == 8 ||
              userDetails.roleId == 9 ||
              userDetails.roleId == 10) &&
            (groupData == 1 ||
              groupData == 2 ||
              groupData == 4 ||
              groupData == 5 ||
              prevDataAdd2.groupId == 1 ||
              prevDataAdd2.groupId == 2 ||
              prevDataAdd2.groupId == 4 ||
              prevDataAdd2.groupId == 5) ? (
              <a target="_blank" href={download38Docx}>
                <span className="link-filed">
                  Download Additional upload by CE
                </span>
              </a>
            ) : (
              <></>
            )}
          </Grid>
        )}
        {/*for seso*/}
        {(userDetails.roleId === 6 ||
          userDetails.roleId === 1 ||
          userDetails.roleId === 2) &&
        AdditionalUploadByCEFileCheck &&
        (groupData == 3 || prevDataAdd2.groupId == 3) &&
        (groupData == 3 || prevDataAdd2.groupId == 3) ? (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={
              AdditionalUploadByCEFileCheck &&
              (groupData == 3 || prevDataAdd2.groupId == 3)
                ? "spaceremover"
                : "hidden"
            }
          >
            {isDocumentMandatoryForRole(
              "Additional upload By CE (Zip file only!)"
            ) && (
              <TextField
                label="Additional upload By CE(Zip file only!)"
                type="file"
                id="desiredOPInKW"
                name="desiredOPInKW"
                className=""
                fullWidth
                // disabled={((((groupData == 1 || groupData == 2 || groupData == 4 || groupData == 5) || (prevDataAdd2.groupId == 1 || prevDataAdd2.groupId == 2 || prevDataAdd2.groupId == 4 || prevDataAdd2.groupId == 5)) && (!prevDataAdd2.purchaseorderNumber && !prevDataAdd2.purchaseorderDate)))}
                // disabled={(groupData === 3 || prevDataAdd2.groupId == 3)  && (!prevDataAdd2.purchaseorderNumber && !prevDataAdd2.purchaseorderDate)}
                key={fileAdditionalUploadByCeKey}
                onChange={handleAdditionalUploadsByComponentEngineer}
                variant="filled"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className="p-0"
                        target="_blank"
                        href={download38Docx}
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            )}
            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Databyce38}</span> : " "} */}

            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Databyce38}</span>
                {isDocumentMandatoryForRole(
                  "Additional upload By CE (Zip file only!)"
                ) && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(38)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : userDetails.roleId === 3 &&
          uploadTypeValue38 &&
          (groupData == 3 || prevDataAdd2.groupId == 3) ? (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={
              uploadTypeValue38 && (groupData == 3 || prevDataAdd2.groupId == 3)
                ? "spaceremover"
                : "hidden"
            }
          >
            {" "}
            <button
              className="link-filed1"
              onClick={downloadBallon16AddituionalUploadByce}
            >
              Additional upload by CE
            </button>
          </Grid>
        ) : (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={
              download38Docx && (groupData == 3 || prevDataAdd2.groupId == 3)
                ? "spaceremover"
                : "hidden"
            }
          >
            {download38Docx &&
            (userDetails.roleId == 8 ||
              userDetails.roleId == 9 ||
              userDetails.roleId == 10) &&
            (groupData == 3 || prevDataAdd2.groupId == 3) ? (
              <a target="_blank" href={download38Docx}>
                <span className="link-filed">
                  Download Additional upload by CE
                </span>
              </a>
            ) : (
              <></>
            )}
          </Grid>
        )}

        {/*  <Grid className={isirPdfFileCheck ? "spaceremover" :"hidden"}>*/}
        {userDetails.roleId == 7 ||
        userDetails.roleId == 6 ||
        userDetails.roleId === 1 ||
        userDetails.roleId === 2 ? (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={isirPdfFileCheck ? "spaceremover" : "hidden"}
          >
            {isDocumentMandatoryForRole("EM EA GF QM FR 056_ISIR.pdf") && (
              <TextField
                // label="EM EA GF QM FR 056_ISIR.pdf*"
                label={
                  <>
                    EM EA GF QM FR 056_ISIR.pdf
                    {userDetails.roleId === 7 &&
                      documentList?.filter(
                        (z) =>
                          z.documentName == "EM EA GF QM FR 056_ISIR.pdf" &&
                          z.isMandatory
                      ).length > 0 &&
                      !fileEAEMPDF && <span style={{ color: "red" }}>*</span>}
                  </>
                }
                type="file"
                id="056_ISIR_pdf"
                name="056_ISIR_pdf"
                className=""
                fullWidth
                disabled={groupData === 3 || prevDataAdd2.groupId == 3}
                key={fileEAEMPDFKey}
                onChange={handleIsirPdf}
                variant="filled"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className="p-0"
                        target="_blank"
                        href={download7Docx}
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            )}
            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Data7}</span> : " "} */}
            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Data7}</span>
                {isDocumentMandatoryForRole("EM EA GF QM FR 056_ISIR.pdf") && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(14)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : userDetails.roleId === 3 && uploadTypeValue15 ? (
          <Grid item xs={12} sm={6} md={4}>
            {" "}
            <button className="link-filed1" onClick={downloadBallon8isirPdf}>
              Download ISIR.pdf
            </button>
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={4}>
            {download7Docx ? (
              <a target="_blank" href={download7Docx}>
                <span className="link-filed">Download ISIR.pdf </span>
              </a>
            ) : (
              <a>
                <span className="link-filed">
                  <button className="disabled-link" disabled>
                    Download ISIR.pdf{" "}
                  </button>
                </span>
              </a>
            )}
          </Grid>
        )}
        {/*  </Grid>*/}

        {/* <Grid className={qualityPlanFileCheck ? "spaceremover" :"hidden"}>*/}
        {userDetails.roleId === 6 ||
        userDetails.roleId === 1 ||
        userDetails.roleId === 2 ? (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={qualityPlanFileCheck ? "spaceremover" : "hidden"}
          >
            {isDocumentMandatoryForRole(
              "EM EA GF QM FR 060_Quality Plan.pdf (IIP)"
            ) && (
              <TextField
                label="EM EA GF QM FR 060_Quality Plan.pdf (IIP)"
                // label={ <>
                //   EM EA GF QM FR 060_Quality Plan.pdf (IIP)
                //   {
                //     isirDocumentList?.filter(z =>
                //       z.documentName == 'EM EA GF QM FR 060_Quality Plan.pdf (IIP)' &&
                //       z.isMandatory
                //     ).length > 0 &&
                //     // file uploaded nahi hui
                //     (<span style={{ color: "red" }}>*</span>)
                //   }
                // </>}
                type="file"
                id="060_Quality"
                name="060_Quality"
                className=""
                fullWidth
                disabled={groupData === 3 || prevDataAdd2.groupId == 3}
                key={fileEAEM_QualityPlanKey}
                onChange={handleQualityPlan}
                variant="filled"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className="p-0"
                        target="_blank"
                        href={download8Docx}
                        disabled={
                          userDetails.roleId === 3 ||
                          userDetails.roleId === 4 ||
                          userDetails.roleId === 5 ||
                          userDetails.roleId === 7 ||
                          userDetails.roleId === 8 ||
                          userDetails.roleId === 9 ||
                          userDetails.roleId === 10
                            ? true
                            : false
                        }
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            )}
            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Data8}</span> : " "} */}

            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Data8}</span>
                {isDocumentMandatoryForRole(
                  "EM EA GF QM FR 060_Quality Plan.pdf (IIP)"
                ) && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(15)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : userDetails.roleId === 3 && uploadTypeValue16 ? (
          <Grid item xs={12} sm={6} md={4}>
            {" "}
            <button
              className="link-filed1"
              onClick={downloadBallon9qualityPlan}
            >
              Download Quality Plan
            </button>
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={4}>
            {download8Docx ? (
              <a target="_blank" href={download8Docx}>
                <span className="link-filed">Download Quality Plan(IIP)</span>
              </a>
            ) : (
              <a>
                <span className="link-filed">
                  <button className="disabled-link" disabled>
                    Download Quality Plan(IIP)
                  </button>
                </span>
              </a>
            )}
          </Grid>
        )}
        {/*  </Grid>*/}
        {/*  <Grid className={sqmCheckApqpFileCheck ?'spaceremover' :'hidden'}>*/}
        {userDetails.roleId === 6 ||
        userDetails.roleId === 1 ||
        userDetails.roleId === 2 ? (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={sqmCheckApqpFileCheck ? "spaceremover" : "hidden"}
          >
            {isDocumentMandatoryForRole("SQM Check_APQP Questionnaire.pdf") && (
              <TextField
                label={
                  <>
                    SQM Check_APQP Questionnaire.pdf
                    {(userDetails.roleId === 1 ||
                      userDetails.roleId === 2 ||
                      userDetails.roleId === 6) &&
                      documentList?.some(
                        (z) =>
                          z.documentName ===
                            "SQM Check_APQP Questionnaire.pdf" && z.isMandatory
                      ) &&
                      !sqmApqpQuestionare && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                  </>
                }
                type="file"
                id="SQM_Check_APQP"
                name="SQM_Check_APQP"
                className=""
                fullWidth
                disabled={groupData === 3 || prevDataAdd2.groupId == 3}
                key={sqmApqpQuestionareKey}
                onChange={handleSQMAPQPQuestionare}
                variant="filled"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className="p-0"
                        target="_blank"
                        href={downloadSQMAPQPDocx}
                        disabled={
                          userDetails.roleId === 3 ||
                          userDetails.roleId === 4 ||
                          userDetails.roleId === 5 ||
                          userDetails.roleId === 7 ||
                          userDetails.roleId === 8 ||
                          userDetails.roleId === 9 ||
                          userDetails.roleId === 10
                            ? true
                            : false
                        }
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            )}

            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2SqmAPQP}</span>
                {isDocumentMandatoryForRole(
                  "SQM Check_APQP Questionnaire.pdf"
                ) && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(40)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : userDetails.roleId === 3 && uploadTypeValueSQMApqpQuestinare ? (
          <Grid item xs={12} sm={6} md={4}>
            {" "}
            <button
              className="disabled-link"
              disabled
              onClick={downloadBallonSQMAPQPQuestinare}
            >
              Download SQM APQP Questionnaire
            </button>
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={4}>
            {downloadSQMAPQPDocx ? (
              <a target="_blank" href={downloadSQMAPQPDocx}>
                <span className="link-filed">
                  Download SQM APQP Questionnaire
                </span>
              </a>
            ) : (
              <a>
                <span className="link-filed">
                  <button className="disabled-link" disabled>
                    Download SQM APQP Questionnaire
                  </button>
                </span>
              </a>
            )}
          </Grid>
        )}
        {/* </Grid>*/}
        {/* <Grid className={ppaeXlsxReviewFileCheck ? 'spaceremover' : 'hidden'}>*/}
        {userDetails.roleId === 6 ||
        userDetails.roleId === 1 ||
        userDetails.roleId === 2 ? (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={ppaeXlsxReviewFileCheck ? "spaceremover" : "hidden"}
          >
            {isDocumentMandatoryForRole("PPAP.xlsx for review") && (
              <TextField
                label="PPAP.xlsx for review"
                // label={ <>
                //   PPAP.xlsx for review
                //   {
                //     isirDocumentList?.filter(z =>
                //       z.documentName == 'PPAP.xlsx for review' &&
                //       z.isMandatory
                //     ).length > 0 &&
                //     // file uploaded nahi hui
                //     (<span style={{ color: "red" }}>*</span>)
                //   }
                // </>}
                type="file"
                id="PPAP_XLSX"
                name="PPAP_XLSX"
                className=""
                fullWidth
                disabled={
                  groupData == 1 ||
                  groupData == 2 ||
                  groupData == 4 ||
                  groupData == 5 ||
                  ((prevDataAdd2.groupId == 1 ||
                    prevDataAdd2.groupId == 2 ||
                    prevDataAdd2.groupId == 4 ||
                    prevDataAdd2.groupId == 5) &&
                    (prevDataAdd2.developmentTypeId == 2 ||
                      developmentData == 2) &&
                    !prevDataAdd2.purchaseorderNumber &&
                    !prevDataAdd2.purchaseorderDate &&
                    prevDataAdd2.typeId == 1) ||
                  groupData == 3 ||
                  prevDataAdd2.groupId == 3 ||
                  prevDataAdd2.developmentTypeId == 1 ||
                  developmentData == 1

                  //(
                  //    iipActionDataState == false &&
                  //    poTextActionDataState == false &&
                  //    prevDataAdd2.typeId == 2
                  //)
                }
                // disabled={groupData === 3 || prevDataAdd2.groupId == 3 || developmentData == 1 || prevDataAdd2.developmentTypeId == 1|| (!prevDataAdd2.purchaseorderNumber && !prevDataAdd2.purchaseorderDate)}
                key={filePPAPReview1Key}
                onChange={handlePpapReview}
                variant="filled"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className="p-0"
                        target="_blank"
                        href={download9Docx}
                        //onClick={downloadBallon10PpapReview}
                        disabled={
                          userDetails.roleId === 4 ||
                          userDetails.roleId === 5 ||
                          userDetails.roleId === 7 ||
                          userDetails.roleId === 8 ||
                          userDetails.roleId === 9 ||
                          userDetails.roleId === 10
                            ? true
                            : false
                        }
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            )}

            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Data9}</span> : " "} */}

            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Data9}</span>
                {isDocumentMandatoryForRole("PPAP.xlsx for review") && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(16)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : userDetails.roleId == 3 ? (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={ppaeXlsxReviewFileCheck ? "spaceremover" : "hidden"}
          >
            {isDocumentMandatoryForRole("PPAP.xlsx for review") && (
              <TextField
                //label="PPAP.xlsx for review"
                label={
                  <>
                    PPAP.xlsx for review
                    {userDetails.roleId === 3 &&
                      documentList?.filter(
                        (z) =>
                          z.documentName == "PPAP.xlsx for review" &&
                          z.isMandatory
                      ).length > 0 &&
                      !filePPAPReview1 && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                  </>
                }
                type="file"
                id="PPAP_XLSX"
                name="PPAP_XLSX"
                className=""
                fullWidth
                disabled={
                  ((groupData == 1 ||
                    groupData == 2 ||
                    groupData == 4 ||
                    groupData == 5 ||
                    ((prevDataAdd2.groupId == 1 ||
                      prevDataAdd2.groupId == 2 ||
                      prevDataAdd2.groupId == 4 ||
                      prevDataAdd2.groupId == 5) &&
                      (prevDataAdd2.developmentTypeId == 2 ||
                        developmentData == 2))) &&
                    !prevDataAdd2.purchaseorderNumber &&
                    !prevDataAdd2.purchaseorderDate &&
                    prevDataAdd2.typeId == 1) ||
                  groupData == 3 ||
                  prevDataAdd2.groupId == 3 ||
                  prevDataAdd2.developmentTypeId == 1 ||
                  developmentData == 1 ||
                  ((!iipActionDataState || !poTextActionDataState) &&
                    prevDataAdd2.typeId == 2)
                }
                // disabled={groupData === 3 || prevDataAdd2.groupId == 3 || developmentData == 1 || prevDataAdd2.developmentTypeId == 1|| (!prevDataAdd2.purchaseorderNumber && !prevDataAdd2.purchaseorderDate)}
                key={filePPAPReview1Key}
                onChange={handlePpapReview}
                variant="filled"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className="p-0"
                        target="_blank"
                        //href={download9Docx}
                        onClick={downloadBallon10PpapReview}
                        disabled={
                          userDetails.roleId === 1 ||
                          userDetails.roleId === 4 ||
                          userDetails.roleId === 5 ||
                          userDetails.roleId === 7 ||
                          userDetails.roleId === 8 ||
                          userDetails.roleId === 9 ||
                          userDetails.roleId === 10
                            ? true
                            : false
                        }
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            )}

            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Data9}</span> : " "} */}

            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Data9}</span>
                {isDocumentMandatoryForRole("PPAP.xlsx for review") && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(16)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={4}>
            {download9Docx ? (
              <a target="_blank" href={download9Docx}>
                <span className="link-filed">Download PPAP xlsx</span>
              </a>
            ) : (
              <a>
                <span className="link-filed">
                  <button className="disabled-link" disabled>
                    Download PPAP xlsx
                  </button>
                </span>
              </a>
            )}
          </Grid>
        )}
        {/*  </Grid>*/}
        {/*  <Grid className={ppapSignoffFileCheck ? 'spaceremover' : 'hidden'}>*/}
        {userDetails.roleId === 6 ||
        userDetails.roleId === 1 ||
        userDetails.roleId === 2 ? (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={ppapSignoffFileCheck ? "spaceremover" : "hidden"}
          >
            {isDocumentMandatoryForRole("PPAP.pdf for signoff") && (
              <TextField
                label="PPAP.pdf for signoff"
                type="file"
                id="PPAP_PDF"
                name="PPAP_PDF"
                className=""
                fullWidth
                disabled={
                  groupData == 1 ||
                  groupData == 2 ||
                  groupData == 4 ||
                  groupData == 5 ||
                  ((prevDataAdd2.groupId == 1 ||
                    prevDataAdd2.groupId == 2 ||
                    prevDataAdd2.groupId == 4 ||
                    prevDataAdd2.groupId == 5) &&
                    (prevDataAdd2.developmentTypeId == 2 ||
                      developmentData == 2) &&
                    !prevDataAdd2.purchaseorderNumber &&
                    !prevDataAdd2.purchaseorderDate &&
                    prevDataAdd2.typeId == 1) ||
                  groupData == 3 ||
                  prevDataAdd2.groupId == 3 ||
                  prevDataAdd2.developmentTypeId == 1 ||
                  developmentData == 1
                  //||
                  //(
                  //    iipActionDataState == false &&
                  //    poTextActionDataState == false &&
                  //    prevDataAdd2.typeId == 2
                  //)
                }
                key={filePPAPSnoffKey}
                onChange={handlePPAPSnoff}
                variant="filled"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className="p-0"
                        target="_blank"
                        href={download10Docx}
                        disabled={
                          userDetails.roleId === 4 ||
                          userDetails.roleId === 5 ||
                          userDetails.roleId === 7 ||
                          userDetails.roleId === 8 ||
                          userDetails.roleId === 9 ||
                          userDetails.roleId === 10
                            ? true
                            : false
                        }
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            )}
            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Data10}</span> : " "} */}

            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Data10}</span>
                {isDocumentMandatoryForRole("PPAP.pdf for signoff") && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(17)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : userDetails.roleId == 3 ? (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={ppapSignoffFileCheck ? "spaceremover" : "hidden"}
          >
            {isDocumentMandatoryForRole("PPAP.pdf for signoff") && (
              <TextField
                // label="PPAP.pdf for signoff"
                label={
                  <>
                    PPAP.pdf for signoff
                    {userDetails.roleId === 3 &&
                      documentList?.filter(
                        (z) =>
                          z.documentName == "PPAP.pdf for signoff" &&
                          z.isMandatory
                      ).length > 0 &&
                      !filePPAPSnoff && <span style={{ color: "red" }}>*</span>}
                  </>
                }
                type="file"
                id="PPAP_PDF"
                name="PPAP_PDF"
                className=""
                fullWidth
                disabled={
                  ((groupData == 1 ||
                    groupData == 2 ||
                    groupData == 4 ||
                    groupData == 5 ||
                    ((prevDataAdd2.groupId == 1 ||
                      prevDataAdd2.groupId == 2 ||
                      prevDataAdd2.groupId == 4 ||
                      prevDataAdd2.groupId == 5) &&
                      (prevDataAdd2.developmentTypeId == 2 ||
                        developmentData == 2))) &&
                    !prevDataAdd2.purchaseorderNumber &&
                    !prevDataAdd2.purchaseorderDate &&
                    prevDataAdd2.typeId == 1) ||
                  groupData == 3 ||
                  prevDataAdd2.groupId == 3 ||
                  prevDataAdd2.developmentTypeId == 1 ||
                  developmentData == 1 ||
                  ((!iipActionDataState || !poTextActionDataState) &&
                    prevDataAdd2.typeId == 2)
                }
                //disabled={groupData === 3 || prevDataAdd2.groupId == 3|| prevDataAdd2.developmentTypeId==1 ||  developmentData == 1|| (!prevDataAdd2.purchaseorderNumber && !prevDataAdd2.purchaseorderDate)}
                key={filePPAPSnoffKey}
                onChange={handlePPAPSnoff}
                variant="filled"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className="p-0"
                        target="_blank"
                        //href={download10Docx}
                        onClick={downloadBallon11PpapSignoff}
                        disabled={
                          userDetails.roleId === 1 ||
                          userDetails.roleId === 4 ||
                          userDetails.roleId === 5 ||
                          userDetails.roleId === 7 ||
                          userDetails.roleId === 8 ||
                          userDetails.roleId === 9 ||
                          userDetails.roleId === 10
                            ? true
                            : false
                        }
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            )}
            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Data10}</span> : " "} */}

            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Data10}</span>
                {isDocumentMandatoryForRole("PPAP.pdf for signoff") && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(17)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={4}>
            {download10Docx ? (
              <a target="_blank" href={download10Docx}>
                <span className="link-filed">Download PPAP signoff pdf</span>
              </a>
            ) : (
              <a>
                <span className="link-filed">
                  <button className="disabled-link" disabled>
                    Download PPAP signoff pdf
                  </button>
                </span>
              </a>
            )}
          </Grid>
        )}
        {/* </Grid>*/}

        {/* <Grid className={incomingQulaityReportFileCheck ? 'spaceremover' : 'hidden'}>*/}
        {userDetails.roleId === 6 ||
        userDetails.roleId === 1 ||
        userDetails.roleId === 2 ? (
          <Grid item xs={12} sm={6} md={4} className={incomingQulaityReportFileCheck ? 'spaceremover' : 'hidden'}>
             {isDocumentMandatoryForRole("Incoming Quality Report.pdf (Pilot Batch)") && (
            <TextField
              label="Incoming Quality Report.pdf (Pilot Batch)"
              type="file"
              id="incomingQualityReport_PDF"
              name="incomingQualityReport_PDF"
              className=""
              fullWidth
            
                                  //disabled={groupData === 3 || prevDataAdd2.groupId == 3  || (!prevDataAdd2.purchaseorderNumber && !prevDataAdd2.purchaseorderDate)}
                                  disabled=
                                  {
                                      (
                                          (groupData == 1 ||
                                              groupData == 2 ||
                                              groupData == 4 ||
                                              groupData == 5 ||
                                              (
                                                  (prevDataAdd2.groupId == 1 ||
                                                      prevDataAdd2.groupId == 2 ||
                                                      prevDataAdd2.groupId == 4 ||
                                                      prevDataAdd2.groupId == 5)
                                                  &&
                                                  (prevDataAdd2.developmentTypeId == 2 ||
                                                      developmentData == 2)
                                                  &&
                                                  (
                                                      !prevDataAdd2.purchaseorderNumber &&
                                                      !prevDataAdd2.purchaseorderDate &&
                                                      prevDataAdd2.typeId == 1
                                                  )
                                              )
                                          )
                                          ||
                                          (
                                              groupData == 3 ||
                                              prevDataAdd2.groupId == 3 
                                             
                                          )
                                          //||
                                          //(
                                          //    iipActionDataState == false &&
                                          //    poTextActionDataState == false &&
                                          //    prevDataAdd2.typeId == 2
                                          //)
                                      )
                                  }

              key={fileIncomingQreportKey}
              onChange={handleIqualityReport}
              variant="filled"
              InputLabelProps={{ shrink: true }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      className="p-0"
                      target="_blank"
                      href={download11Docx}
                      disabled={
                        userDetails.roleId === 4 ||
                        userDetails.roleId === 5 ||
                        userDetails.roleId === 7 ||
                        userDetails.roleId === 8 ||
                        userDetails.roleId === 9 ||
                        userDetails.roleId === 10
                          ? true
                          : false
                      }
                    >
                      <CloudDownloadIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            ></TextField>
             )}
            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Data11}</span> : " "} */}

            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Data11}</span>
                {isDocumentMandatoryForRole(
                  "Incoming Quality Report.pdf (Pilot Batch)"
                ) && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(15)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : userDetails.roleId == 3 ? (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={
              incomingQulaityReportFileCheck ? "spaceremover" : "hidden"
            }
          >
            {isDocumentMandatoryForRole(
              "Incoming Quality Report.pdf (Pilot Batch)"
            ) && (
              <TextField
                //label="Incoming Quality Report.pdf (Pilot Batch)"
                label={
                  <>
                    Incoming Quality Report.pdf (Pilot Batch)
                    {userDetails.roleId === 3 &&
                      documentList?.filter(
                        (z) =>
                          z.documentName ==
                            "Incoming Quality Report.pdf (Pilot Batch)" &&
                          z.isMandatory
                      ).length > 0 &&
                      !fileIncomingQreport && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                  </>
                }
                type="file"
                id="incomingQualityReport_PDF"
                name="incomingQualityReport_PDF"
                className=""
                fullWidth
                disabled={
                  ((groupData == 1 ||
                    groupData == 2 ||
                    groupData == 4 ||
                    groupData == 5 ||
                    prevDataAdd2.groupId == 1 ||
                    prevDataAdd2.groupId == 2 ||
                    prevDataAdd2.groupId == 4 ||
                    prevDataAdd2.groupId == 5) &&
                    !prevDataAdd2.purchaseorderNumber &&
                    !prevDataAdd2.purchaseorderDate &&
                    prevDataAdd2.typeId == 1) ||
                  groupData == 3 ||
                  prevDataAdd2.groupId == 3 ||
                  ((!iipActionDataState || !poTextActionDataState) &&
                    prevDataAdd2.typeId == 2)
                }
                //disabled={groupData === 3 || prevDataAdd2.groupId == 3  || (!prevDataAdd2.purchaseorderNumber && !prevDataAdd2.purchaseorderDate)}
                key={fileIncomingQreportKey}
                onChange={handleIqualityReport}
                variant="filled"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className="p-0"
                        target="_blank"
                        //href={download11Docx}
                        onClick={downloadBallon12IncomingQualityReport}
                        disabled={
                          userDetails.roleId === 4 ||
                          userDetails.roleId === 5 ||
                          userDetails.roleId === 7 ||
                          userDetails.roleId === 8 ||
                          userDetails.roleId === 9 ||
                          userDetails.roleId === 10
                            ? true
                            : false
                        }
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            )}
            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Data11}</span> : " "} */}

            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Data11}</span>
                {isDocumentMandatoryForRole(
                  "Incoming Quality Report.pdf (Pilot Batch)"
                ) && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(15)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={4}>
            {download11Docx ? (
              <a target="_blank" href={download11Docx}>
                <span className="link-filed">
                  {" "}
                  Download Quality Report(Pilot Batch)
                </span>
              </a>
            ) : (
              <a>
                <span className="link-filed">
                  <button className="disabled-link" disabled>
                    Download Quality Report(Pilot Batch)
                  </button>
                </span>
              </a>
            )}
          </Grid>
        )}
        {/*  </Grid>*/}
        {/*  <Grid className={HebburnApprovalFileCheck ? "spaceremover" : "hidden"}>*/}
        {(hebburnRndLoc && userDetails.roleId == 6) ||
        userDetails.roleId === 1 ||
        userDetails.roleId === 2 ? (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={HebburnApprovalFileCheck ? "spaceremover" : "hidden"}
          >
            {isDocumentMandatoryForRole("Approval from SPDL,Hebburn") && (
              <TextField
                label="Approval from SPDL,Hebburn"
                type="file"
                id="AppFromSPDLHebburn"
                name="AppFromSPDLHebburn"
                className=""
                                  fullWidth
                                  disabled=
                                  {
                                      (
                                          (groupData == 1 ||
                                              groupData == 2 ||
                                              groupData == 4 ||
                                              groupData == 5 ||
                                              (
                                                  (prevDataAdd2.groupId == 1 ||
                                                      prevDataAdd2.groupId == 2 ||
                                                      prevDataAdd2.groupId == 4 ||
                                                      prevDataAdd2.groupId == 5)
                                                  &&
                                                  (prevDataAdd2.developmentTypeId == 2 ||
                                                      developmentData == 2)
                                                  &&
                                                  (
                                                      !prevDataAdd2.purchaseorderNumber &&
                                                      !prevDataAdd2.purchaseorderDate &&
                                                      prevDataAdd2.typeId == 1
                                                  )
                                              )
                                          )
                                          ||
                                          (
                                              groupData == 3 ||
                                              prevDataAdd2.groupId == 3
                                          )
                                          ||
                                          (
                                              !iipActionDataState &&
                                              !poTextActionDataState &&
                                              prevDataAdd2.typeId == 2
                                          )
                                      )
                                  }
                key={fileUploadByCeForHebbrnKey}
                onChange={handleUploadByCeForHerren}
                variant="filled"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className="p-0"
                        target="_blank"
                        href={download39Docx}
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            )}
            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Databyce39}</span> : " "} */}

            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Databyce39}</span>
                {isDocumentMandatoryForRole("Approval from SPDL,Hebburn") && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(20)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : (
          <></>
        )}

        {
          hebburnRndLoc && userDetails.roleId === 3 && uploadTypeValue39 ? (
            <Grid item xs={12} sm={6} md={4}>
              {" "}
              <button
               
                              disabled=
                              {
                                  (
                                      (groupData == 1 ||
                                          groupData == 2 ||
                                          groupData == 4 ||
                                          groupData == 5 ||
                                          (
                                              (prevDataAdd2.groupId == 1 ||
                                                  prevDataAdd2.groupId == 2 ||
                                                  prevDataAdd2.groupId == 4 ||
                                                  prevDataAdd2.groupId == 5)
                                              &&
                                              (prevDataAdd2.developmentTypeId == 2 ||
                                                  developmentData == 2)
                                              &&
                                              (
                                                  !prevDataAdd2.purchaseorderNumber &&
                                                  !prevDataAdd2.purchaseorderDate &&
                                                  prevDataAdd2.typeId == 1
                                              )
                                          )
                                      )
                                      ||
                                      (
                                          groupData == 3 ||
                                          prevDataAdd2.groupId == 3
                                      )
                                      ||
                                      (
                                          !iipActionDataState &&
                                          !poTextActionDataState &&
                                          prevDataAdd2.typeId == 2
                                      )
                                  )
                              }

                className="link-filed1"
                onClick={downloadBallon15Heburn}
              >
                Download Hebburn
              </button>
            </Grid>
          ) : hebburnRndLoc &&
            download39Docx &&
            (userDetails.roleId == 1 ||
              userDetails.roleId == 4 ||
              userDetails.roleId == 5 ||
              userDetails.roleId == 7 ||
              userDetails.roleId == 8 ||
              userDetails.roleId == 9 ||
              userDetails.roleId == 10) ? (
            <a target="_blank" href={download39Docx}>
              <span className="link-filed">Download Hebburn </span>
            </a>
          ) : (
            <></>
          )
          //<a><span className="link-filed"><button className="disabled-link" disabled>Download Hebburn template</button></span></a>
        }
        {/* </Grid>*/}
        {/*  <Grid className={crerPdfFileCheck ? "spaceremover" : "hidden"}>*/}
        {userDetails.roleId === 6 ||
        userDetails.roleId === 1 ||
        userDetails.roleId === 2 ? (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={crerPdfFileCheck ? "spaceremover" : "hidden"}
          >
            {isDocumentMandatoryForRole("CRER.pdf") && (
              <TextField
                //label="CRER.pdf"
                label={
                  <>
                    CRER.pdf
                    {(userDetails.roleId === 1 ||
                      userDetails.roleId === 2 ||
                      userDetails.roleId === 6) &&
                      documentList?.some(
                        (z) => z.documentName === "CRER.pdf" && z.isMandatory
                      ) &&
                      !fileCrer && <span style={{ color: "red" }}>*</span>}
                  </>
                }
                type="file"
                id="crerPdf"
                name="crerPdf"
                className=""
                fullWidth
                disabled={
                  ((groupData == 1 ||
                    groupData == 3 ||
                    groupData == 4 ||
                    groupData == 5 ||
                    prevDataAdd2.groupId == 1 ||
                    prevDataAdd2.groupId == 3 ||
                    prevDataAdd2.groupId == 4 ||
                    prevDataAdd2.groupId == 5) &&
                    !prevDataAdd2.purchaseorderNumber &&
                    !prevDataAdd2.purchaseorderDate &&
                    prevDataAdd2.typeId == 1) ||
                  groupData == 2 ||
                  prevDataAdd2.groupId == 2
                }
                // disabled={(prevDataAdd2.groupId == 2 || groupData === 2) && (!prevDataAdd2.purchaseorderNumber && !prevDataAdd2.purchaseorderDate)}  //disable for npi is selected in group
                key={fileCrerKey}
                onChange={handleCrer}
                variant="filled"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className="p-0"
                        target="_blank"
                        href={download12Docx}
                        disabled={
                          userDetails.roleId === 3 ||
                          userDetails.roleId === 4 ||
                          userDetails.roleId === 5 ||
                          userDetails.roleId === 7 ||
                          userDetails.roleId === 8 ||
                          userDetails.roleId === 9 ||
                          userDetails.roleId === 10
                            ? true
                            : false
                        }
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            )}
            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Data12}</span> : " "} */}

            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Data12}</span>
                {isDocumentMandatoryForRole("CRER.pdf") && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(19)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : userDetails.roleId === 3 &&
          uploadTypeValue20 &&
          (groupData == 1 ||
            groupData == 3 ||
            groupData == 4 ||
            groupData == 5 ||
            prevDataAdd2.groupId == 1 ||
            prevDataAdd2.groupId == 3 ||
            prevDataAdd2.groupId == 4 ||
            prevDataAdd2.groupId == 5) ? (
          <Grid item xs={12} sm={6} md={4}>
            {" "}
            <button className="link-filed1" onClick={downloadBallon13isircrer}>
              Download CRER
            </button>
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={4}>
            {download12Docx ? (
              <a target="_blank" href={download12Docx}>
                <span className="link-filed">Download CRER</span>
              </a>
            ) : (
              <a>
                <span className="link-filed">
                  <button className="disabled-link" disabled>
                    Download CRER
                  </button>
                </span>
              </a>
            )}
          </Grid>
        )}
        {/* </Grid>*/}
        {/* <Grid className={componentApprovalFileCheck ? "spaceremover" : "hidden"}>*/}
        {userDetails.roleId === 6 ||
        userDetails.roleId === 1 ||
        userDetails.roleId === 2 ? (
          <Grid item xs={12} sm={6} md={4} className={componentApprovalFileCheck ? "spaceremover" : "hidden"}>
             {isDocumentMandatoryForRole("Component Approval form.pdf") && (
            <TextField
              label="Component Approval form.pdf"
              type="file"
              id="componentApprovalPdf"
              name="componentApprovalPdf"
              className=""
              fullWidth
             
                                  disabled=
                                  {
                                      (
                                          (groupData == 1 ||
                                              groupData == 2 ||
                                              groupData == 4 ||
                                              groupData == 5 ||
                                              (
                                                  (prevDataAdd2.groupId == 1 ||
                                                      prevDataAdd2.groupId == 2 ||
                                                      prevDataAdd2.groupId == 4 ||
                                                      prevDataAdd2.groupId == 5)
                                                  &&
                                                  (prevDataAdd2.developmentTypeId == 2 ||
                                                      developmentData == 2)
                                                  &&
                                                  (
                                                      !prevDataAdd2.purchaseorderNumber &&
                                                      !prevDataAdd2.purchaseorderDate &&
                                                      prevDataAdd2.typeId == 1
                                                  )
                                              )
                                          )
                                          ||
                                         
                                          (
                                              !iipActionDataState &&
                                             !poTextActionDataState  &&
                                              prevDataAdd2.typeId == 2
                                          )
                                      )
                                  }

              key={fileComponentApprKey}
              onChange={handleCompoAppr}
              variant="filled"
              InputLabelProps={{ shrink: true }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      className="p-0"
                      target="_blank"
                      href={download13Docx}
                      disabled={
                        userDetails.roleId === 4 ||
                        userDetails.roleId === 5 ||
                        userDetails.roleId === 7 ||
                        userDetails.roleId === 8 ||
                        userDetails.roleId === 9 ||
                        userDetails.roleId === 10
                          ? true
                          : false
                      }
                    >
                      <CloudDownloadIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            ></TextField>
             )}
            {/* {downloadTab2Data.length >= 1 ? <span className="fname">{fileT2Data13}</span> : " "} */}

            {downloadTab2Data.length >= 1 ? (
              <div
                className="iIconClass"
                style={{ display: "flex", width: "100%" }}
              >
                <span className="fname">{fileT2Data13}</span>
                {isDocumentMandatoryForRole("Component Approval form.pdf") && (
                  <span style={{ width: "20%", textAlign: "center" }}>
                    <InfoOutlined onClick={() => infoIconClick(20)} />
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
          </Grid>
        ) : userDetails.roleId === 3 && uploadTypeValue21 ? (
          <Grid item xs={12} sm={6} md={4}>
            {" "}
            <button
              className="link-filed1"
              onClick={downloadBallon14ComponentApprover}
            >
              {" "}
              Component Approval form
            </button>
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={4}>
            {download13Docx ? (
              <a target="_blank" href={download13Docx}>
                <span className="link-filed"> Component Approval form</span>
              </a>
            ) : (
              <a>
                <span className="link-filed">
                  <button className="disabled-link" disabled>
                    {" "}
                    Component Approval form
                  </button>
                </span>
              </a>
            )}
          </Grid>
        )}
        {/* </Grid>*/}
        {/*  || (closeBtnEnableDataStateFromTB2ChildType && prevDataAdd2.typeId == 2)*/}
        {(userDetails.roleId == 1 ||
          userDetails.roleId == 6 ||
          userDetails.roleId == 3 ||
          userDetails.roleId == 7 ||
          userDetails.roleId === 2) &&
        documentList?.length > 0 ? (
          <Grid item xs={12} sm={6} md={4}>
            <Button
              className="pt-button--hero myid-login-btn-block"
              onClick={handleUploadFileDataTabtwo}
              disabled={
                afterClosingIsirActionDataState ||
                (prevDataAdd2.statusName == "ISIR Closed" &&
                  prevDataAdd2.statusId == 7 &&
                  prevDataAdd2.massReleasetoSQE == null &&
                  prevDataAdd2.typeId == 2) ||
                (prevDataAdd2.statusName == "ISIR Closed" &&
                  prevDataAdd2.statusId == 7 &&
                  prevDataAdd2.massReleasetoSQE !== null)
              }
            >
              Upload
            </Button>
          </Grid>
        ) : (
          <></>
        )}

        <SnackbarCustom
          open={open}
          message={snackMessage}
          alertType={alertType}
          handleClose={handleClose}
        />
      </Grid>

      <Remark
        isirNumberPassed={isirNumberPassed}
        prevDataAdd2={prevDataAdd2}
        afterClosingIsirActionDataStateInRemark={
          afterClosingIsirActionDataState
        }
        closeBtnEnableDataStateFromTB2ChildTypeRemark={
          closeBtnEnableDataStateFromTB2ChildType
        }
        documentList={documentList}
      />

      <div className="po-upload">
        <Grid item xs={12}>
          <h3 className="title-heading">PO Text</h3>
        </Grid>

        <Grid container spacing={3} md={12}>
          <Grid item xs={12} sm={6} md={3}>
            <form className="upload-form">
              <TextField
                id="snapshotUpload"
                variant="filled"
                disabled={
                  userDetails.roleId === 3 ||
                  userDetails.roleId === 4 ||
                  userDetails.roleId === 5 ||
                  userDetails.roleId === 7 ||
                  userDetails.roleId == 8 ||
                  userDetails.roleId === 9 ||
                  userDetails.roleId === 10
                }
                label="SnapShot Upload"
                inputProps={{ accept: "image/*", multiple: false }}
                fullWidth
                onChange={updateSnapShotHandler}
                key={inputFileValue}
                type="file"
                InputLabelProps={{ shrink: true }}
              />
            </form>
            <span>*formats allowed are .jpeg, .png, .jpg</span>
          </Grid>

          <Grid item xs={12} sm={2} md={1}>
            <Button
              onClick={handleUpload}
              className="pt-button--primary button-submit"
              variant="contained"
            >
              SAVE
            </Button>
          </Grid>

         

          {userDetails.roleId === 3 ? (
            <Grid item xs={12} sm={2} md={1}>
              {" "}
              <button
                onClick={handleClickOpenPo}
                className="pt-button--primary button-submit"
                variant="contained"
                disabled={!poRes}
              >
                VIEW
              </button>
            </Grid>
          ) : poImgUrl &&
            (userDetails.roleId == 1 ||
              userDetails.roleId == 2 ||
              userDetails.roleId == 6 ||
              userDetails.roleId == 7 ||
              userDetails.roleId == 8 ||
              userDetails.roleId == 9 ||
              userDetails.roleId == 10) ? (
            <Grid item xs={12} sm={2} md={1}>
              {" "}
              <a
                className="pt-button--primary button-submit bord"
                variant="contained"
                target="_blank"
                href={poImgUrl}
              >
                VIEW
              </a>
            </Grid>
          ) : (
            <></>
          )}

          <Grid item xs={12} sm={2} md={1}>
            {" "}
            <h4 style={{ margin: "7px" }}>{poImgUrl ? poImgName : ""}</h4>
          </Grid>

          {/*<Grid item xs={12} md={3}>*/}
          {/*    <Grid className="view-flex">*/}
          {/*        <Button*/}
          {/*            onClick={handleClickOpen} */}
          {/*            disabled={!uploadImageData}*/}
          {/*            className="pt-button--secondary button-submit" variant="contained">*/}
          {/*            View*/}
          {/*        </Button>*/}
          {/*         <h4 style={{ margin: "7px" }}>{uploadImageData ? prevDataAdd2?.automatedIsirnumber + "_PO Text" : ""}</h4>*/}
          {/*    </Grid>*/}

          {/*</Grid>*/}
        </Grid>

        {loader ? <Loading loaderText="Loading...." /> : <></>}

        {/*<Dialog fullWidth className="dialog-image" open={openDialog} onClose={handleCloseDialog} aria-labelledby="form-dialog-title">*/}
        {/*    <DialogTitle id="form-dialog-title">Image Preview</DialogTitle>*/}
        {/*    <DialogContent>*/}
        {/*        {poImgUrl?.toString()?.length > 0 ? <img className="img-content" src={poImgUrl} alt="no test" /> : "Please Select a File"}*/}
        {/*    </DialogContent>*/}
        {/*    <DialogActions>*/}
        {/*        <Button className="pt-button--primary button-submit" variant="contained" onClick={handleCloseDialog} color="primary">*/}
        {/*            Close*/}
        {/*        </Button>*/}
        {/*    </DialogActions>*/}
        {/*</Dialog>*/}
        <Dialog
          className="test"
          open={openSnack}
          onClose={handleCloseSnack}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            onClose={handleCloseSnack}
          ></DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              "Data Upload Successfully"
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              className="pt-button--primary button-submit"
              variant="contained"
              onClick={handleCloseSnack}
              color="primary"
            >
              Close
            </Button>
            {/*<Button onClick={handleClose} color="primary" autoFocus>*/}
            {/*    Agree*/}
            {/*</Button>*/}
          </DialogActions>
        </Dialog>
        <Dialog
          className="snackgreen"
          open={openSnackRed}
          onClose={handleCloseSnackRed}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title"></DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              "Data Upload Failed"
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              className="pt-button--primary button-submit"
              variant="contained"
              onClick={handleCloseSnackRed}
              color="primary"
            >
              Close
            </Button>
            {/*<Button onClick={handleClose} color="primary" autoFocus>*/}
            {/*    Agree*/}
            {/*</Button>*/}
          </DialogActions>
        </Dialog>
        <Dialog
          fullWidth
          className="dialog-image"
          open={openDialogPo}
          onClose={handleCloseDialogPo}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Image Preview</DialogTitle>
          <DialogContent>
            {poRes?.toString()?.length > 0 ? (
              <img className="img-content" src={poRes} alt="no test" />
            ) : (
              "Please Select a File"
            )}
          </DialogContent>
          <DialogActions>
            <Button
              className="pt-button--primary button-submit"
              variant="contained"
              onClick={handleCloseDialogPo}
              color="primary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      <>
        <SnackbarCustom
          open={openSnackbarInternal}
          message={snackMessageInternal}
          alertType={alertTypeInternal}
          handleClose={handleCloseSnackbarInternal}
        />
      </>

      <Dialog
        className="test"
        open={openFileHistoryDialog}
        onClose={closeFileHistoryDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          className: classes.responsiveDialog,
        }}
      >
        <DialogTitle id="alert-dialog-title" onClose={closeFileHistoryDialog}>
          <h5>File History</h5>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Grid item xs={12}>
              {tableStringContent && tableStringContent !== null ? (
                <div style={{ textAlign: "center" }}>
                  <h4>{tableStringContent}</h4>
                </div>
              ) : (
                <MaterialTable
                  title="History of Files"
                  columns={columnsNew}
                  data={historyTableData}
                  icons={tableIconsInputScreen}
                  isLoading={loaderNew}
                  options={tableOptionsUser}
                />
              )}
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className="pt-button--primary button-submit"
            variant="contained"
            onClick={closeFileHistoryDialog}
            color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const AddIsir = () => {
  //azure ad

  const [test, setTest] = useState("");
  const [documentList, setDocumentList] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [parentSQMAPQPQuestionare, setParentSQMAPQPQuestionare] =
    useState(null);
  const [parentCrerFile, setParentCrerFile] = useState(null);

  const navigate = useNavigate();
  const siteToken = useSelector((state) => state.saveBearerTokenReducer);
  const azureToken = useSelector((state) => state.saveTokenReducer);
  const UID = useSelector((state) => state.saveUserIdReducer);

  const token = useSelector((state) => state.saveTokenReducer.token);
  const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData
  );
  const fileUploadDetailss = useSelector(
    (state) => state.uploadFileValidationReducer.isDrawingsUploaded
  );
  const is3DUploaded = useSelector(
    (state) => state.is3DUploadedReducer.is3DUploaded
  );

  const isToolSpecification = useSelector(
    (state) => state.toolSpecificationnReducer.isToolSpecification
  );

  const isIsirPdfuploaded = useSelector(
    (state) => state.isIsirPdfuploadedReducer.isIsirPdfuploaded
  );
  const tfcActiondataState = useSelector(
    (state) => state.istfcCheckedorNotReducer.tfcCheckedValue
  );

  const dfmActionDataState = useSelector(
    (state) => state.isDfmCheckedorNotReducer.dfmCheckedValue
  );

  const trmActionDataState = useSelector(
    (state) => state.istrmCheckedorNotReducer.trmCheckedValue
  );

  const ppapActionDataState = useSelector(
    (state) => state.isppapCheckedorNotReducer.ppapCheckedValue
  );

  const iipActionDataState = useSelector(
    (state) => state.isIipqpReducer.iipQpValue
  );
  //sqmCheckApqpReducer.sqmCheckApqpValue
  const sqmCheckApqpDataState = useSelector(
    (state) => state.sqmCheckApqpReducer.sqmCheckApqpValue
  );

  console.log("sqmCheckApqpDataState", sqmCheckApqpDataState);

  const ppapXlsmActionDataState = useSelector(
    (state) => state.ppapxlsmReducer.ppapxlsmValue
  );

  const incomingQualityReportValue = useSelector(
    (state) => state.incomingQualityReportReducer.incomingQualityReportValue
  );

  const componentApprovalActionDataState = useSelector(
    (state) => state.componentApprovalFormReducer.componentApprovalFormValue
  );

  const poTextActionDataState = useSelector(
    (state) => state.isPoTextReducer.poTextValue
  );

  const uploadDrawingActionState = useSelector(
    (state) => state.drawingUploadReducer.drawingUploadVlaue
  );

  const upload3DActionState = useSelector(
    (state) => state.threeDUploadReducer.threeDUploadValue
  );

  const uploadIsirActionState = useSelector(
    (state) => state.isirUploadReducer.isirUploadValue
  );

  const closeBtnActionDataState = useSelector(
    (state) => state.closeBtnValueReducer.closeBtnValue
  );

  const afterClosingIsirActionDataState = useSelector(
    (state) => state.afterClosingIsirReducer.afterClosingIsirValue
  );
  //const justCloseBtnPressActionDataState = useSelector((state) => state.justClosebtnPressReducer.justClosebtnPressValue);
  //console.log("justCloseBtnPressActionDataState", justCloseBtnPressActionDataState);

  const closeBtnEnableDataStateFromTB2ChildType = useSelector(
    (state) => state.closeEnableForChildTypeReducer.closeEnableForChildTypeValue
  );
  console.log(
    "closeBtnEnableDataStateFromTB2ChildType",
    closeBtnEnableDataStateFromTB2ChildType
  );

  const location = useLocation();
  const prevRowData = location?.state?.rowData ? location.state.rowData : "";
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = useState(0);
  const [data, setData] = useState();
  const [submitedData, setsubmittedData] = useState();

  const [status, setStatus] = useState([]);
  const [groupState, setGroupState] = useState([]);
  const [isirWorkFlowNumber, setIsirWorkFlowNumber] = useState("");
  const [isirnoId, setIsirnoId] = useState("");
  const [created, setCreated] = useState("");
  const [modifies, setModified] = useState("");
  const [isirActive, setIsirActive] = useState("");
  const [groupData, setGroupData] = useState();
  const [spiridonNumber, setSpiridonNumber] = useState("");
  const [drawingNumber, setDrawingNumber] = useState("");
  const [workFlowNumber, setWorkFlowNumber] = useState("");

  const [vendorCodeName, setVendorCodeName] = useState(
    prevRowData ? prevRowData.supplierCode : ""
  );
  const [emailId, setEmailId] = useState([]);
  const [supplierId, setSupplierId] = useState(
    prevRowData ? prevRowData.supplierId : 0
  );
  const [supplierEmailIds, setSupplierEmailIds] = useState([]);
  const [dPemail, setDPemail] = useState("");
  const [newPrevEmail, setNewPrevEmail] = useState();

  const [getPreFe, setGetPreFe] = useState("");
  const [formattedDate, setFormattedDate] = useState("");

  const [weightPart, setWeightPart] = useState("");
  const handleWeightPart = (e) => {
    console.log("weightofPart", e.target.value);
    setWeightPart(e.target.value);
  };

  const [prevWeightOfpart, setPrevWeightOfpart] = useState(prevRowData.weightOfPart);
    const handlePrevWeightOfpart = (e) => {
        console.log("prevweight", e.target.value);
    setPrevWeightOfpart(e.target.value);
  };

  const [type, setType] = useState(prevRowData ? prevRowData.typeId : null);
  const handleType = (e) => {
    console.log("type", e.target.value);
    setType(e.target.value);
  };

  useEffect(() => {
    setGetPreFe(prevRowData.suppliercontactpersonemailIdanother);
    const rawDate = location?.state?.rowData?.requestopenedon;

    if (rawDate) {
      const date = new Date(rawDate);
      const dd = String(date.getDate()).padStart(2, "0");
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const yyyy = date.getFullYear();

      const finalDate = `${mm}/${dd}/${yyyy}`;
      setFormattedDate(finalDate);
    }
  }, [location]);

  const [firstsEmailId, setfirstsEmailId] = useState(
    prevRowData ? prevRowData.suppliercontactpersonemailIdanother : ""
  );
  const [secondsEmailId, setSecondsEmailId] = useState("");
  const [otherccEmails, setOtherccEmails] = useState();
  const [ssiCCemails, setssiCCemails] = useState(
    prevRowData ? prevRowData.cehod : []
  );
  const [rndEmailId, setRndEmailId] = useState(
    prevRowData ? prevRowData.rdcontactPersonId : null
  );
  const [rndLocation, setRndLocation] = useState([]);
  const [rndLocationData, setRndLocationData] = useState(
    prevRowData ? prevRowData.rdLocationId : null
  );
  const [developmentType, setDevelopmentType] = useState([]);
  const [typeFlow, setTypeFlow] = useState([]);
  const [developmentData, setDevelopementData] = useState();
  const [dateInputs, setDateInputs] = useState(null); //new Date()
  const [description, setDescription] = useState();
  const [drawingRevisionNumber, setDrawingRevisionNumber] = useState("");
  const [sesoNo, setSesoNo] = useState(prevRowData ? prevRowData.sesoNo : "");
  const [product, setProduct] = useState("");
  const [supplierName, setSupplierName] = useState(
    prevRowData ? prevRowData.supplierName : ""
  );
  const [supplier, setSupplier] = useState([]);
  const [ssEmail, setSsEmail] = useState("");
  const [cc, setCc] = useState(prevRowData ? prevRowData.cehodSeso : "");
  const [openDate, setOpenDate] = useState("");
  const [closedDate, setClosedDate] = useState("");

  const [questNumber, setQuestNumber] = useState();
  const [requestRaised, setRequestRaised] = useState(
    prevRowData ? renderDateY(prevRowData.massReleasetoSQE) : null
  );
  const [dataTwo, setDataTwo] = useState(false);
  const [qInfo, setqInfo] = useState(
    prevRowData ? prevRowData.qinfoRequest : ""
  );
  const [sqePerson, setSqePerson] = useState("");
  const [sprPerson, setSPRPerson] = useState("");
  const [oprPerson, setOPRPerson] = useState("");
  const [pilotQuantity, setPilotQunatity] = useState(
    prevRowData ? prevRowData.pilotQuantity : ""
  );
  const [pilotRelease, setPilotRelease] = useState(
    prevRowData ? renderDateY(prevRowData.pilotlotrealeasetoSqe) : null
  );
  const [establishmentDone, setEstablishmentDone] = useState(
    prevRowData ? prevRowData.supplyChainEstablishmentDone : "false"
  );
  const [qinfoDone, setQinfoDone] = useState(
    prevRowData ? prevRowData.qinfoRequest : "false"
  );
  const [supplyChainEstDate, setSupplyChainEstDate] = useState(
    prevRowData ? renderDateY(prevRowData.supplyChainEstablishmentDate) : null
  );
  const [purchaseOrderNumber, setPurchaseOrderNumber] = useState(
    prevRowData ? prevRowData.purchaseorderNumber : null
  );
  const [purchaseOrderDate, setPurchaseOrderDate] = useState(
    prevRowData ? renderDateY(prevRowData.purchaseorderDate) : null
  );
  const [tabOne, setTabOne] = useState(false);
  const [tabTwo, setTabTwo] = useState(false);
  const [tab1, setTab1] = useState(false);
  const [tab2, setTab2] = useState(false);
  const [active, setActive] = useState(0);

  const [disable, setDisable] = useState(true);
  const handleChange = (e) => {
    setGroupData(e.target.value);

    //if (e.target.value == 3) {
    //    setDisable(false);

    //}
  };
  const [clearQst, setClearQst] = useState(
    prevRowData ? prevRowData.clearQuestNo : ""
  );
  const handleClearQst = (e) => {
    //console.log("clearquest",e.target.value);
    setClearQst(e.target.value);
  };
  const [prevClearQuest, setprevClearQuest] = useState(
    prevRowData ? prevRowData.clearQuestNo : ""
  );
  const handlePrevClearq = (e) => {
    setprevClearQuest(e.target.value);
  };
  const handleSpiridonNumber = (e) => {
    setSpiridonNumber(e.target.value);
  };
  const handleDrawingNumber = (e) => {
    setDrawingNumber(e.target.value);
  };
  const handlewflowNumber = (e) => {
    setWorkFlowNumber(e.target.value);
  };

  const handleEmailId = (e) => {};
  const handlerndEmail = (e) => {
    setRndEmailId(e.target.value);
  };

  const handleRndLocation = (e) => {
    setRndLocationData(e.target.value);
    getRdUsersData(e.target.value);
  };

  const handleDateChange = (e) => {
    setDateInputs(e.target.value);
  };
  const handleOpenDate = (e) => {
    setOpenDate(e.target.value);
  };
  const handleClosedDate = (e) => {
    setClosedDate(e.target.value);
  };
  const handleDescription = (e) => {
    setDescription(e.target.value);
  };

  const handleDrawingRebisionNumber = (e) => {
    setDrawingRevisionNumber(e.target.value);
  };
  const handleProduct = (e) => {
    setProduct(e.target.value);
  };
  const handleSESONo = (e) => {
    setSesoNo(e.target.value);
    if (groupData === 3 && e.target.value === null) {
      alert("SESO Number is required");
    }
  };

  if (prevRowData.supplierNameId) {
  }
  const [selectedSupplierCode, setSelectedSupplierCode] = useState(
    prevRowData.supplierNameId
  );
  function newHandleSupplierName(e) {
    const enteredVal = e.target.value;
    setSelectedSupplierCode(e.target.value);

      const suppCodeVal = supplier.find((x) => x.id == enteredVal);
      console.log("suppCodeVal", suppCodeVal);
    setSupplierName(suppCodeVal.name);

      setVendorCodeName(suppCodeVal != undefined ? suppCodeVal.code : "");
      //if (suppCodeVal) {
      //    setVendorCodeName(suppCodeVal);
      //}

    let allEmails = emailId.filter((y) => {
      return y.code === suppCodeVal.code;
    });
    setSupplierEmailIds(allEmails);
  }
  const [newVcode, setNewVcode] = useState();

  const handleFirstsEmailId = (e) => {
    setfirstsEmailId(e.target.value);
    let ssi = supplierEmailIds.find((item) => item.email === e.target.value);

    setSupplierId(ssi.supplierId);
    let cnt = ssi.ccEmails.length;
    setssiCCemails(ssi.ccEmails.slice(0, cnt));
    let duplicateEmail = supplierEmailIds.filter(
      (item) => item.email === e.target.value
    );

    setDPemail(duplicateEmail);
  };

  useEffect(() => {
    if (prevRowData.supplierCode) {
      setSupplierEmailIds(
        emailId.filter((x) => x.code === prevRowData.supplierCode)
      );
    }
  }, [supplier, emailId]);

  const handleSecondsEmailId = (e) => {
    let ssi = supplierEmailIds.find((item) => item.email === e.target.value);

    if (e.target.value === firstsEmailId) {
      setSecondsEmailId(null);
    } else {
      setSecondsEmailId(e.target.value);
    }
  };
  const handleSsemail = (e) => {
    setSsEmail(e.target.value);
  };
  const handleCc = (e) => {
    setCc(e.target.value);
  };

  const handleRequestRaisedBy = (e) => {
    setRequestRaised(e.target.value);
  };

  const appId = localStorage.getItem("ApplicationId");

  const openDataTwo = () => {
    setDataTwo(true);
  };

  const openTabOne = () => {
    setTabOne(true);
    setTabTwo(false);
  };
  const openTabTwo = () => {
    setTabTwo(true);
    setTabOne(false);
  };

  const handleQinfo = (e) => {
    setqInfo(e.target.value);
  };
  const handleEQEPerson = (e) => {
    setSqePerson(e.target.value);
  };
  const handleOPRPerson = (e) => {
    setOPRPerson(e.target.value);
  };
  const handleSPRPerson = (e) => {
    setSPRPerson(e.target.value);
  };

  const handlePilotQunatity = (e) => {
    setPilotQunatity(e.target.value);
  };

  const handlePilotRelease = (e) => {
    setPilotRelease(e.target.value);
  };
  const handleQInfoReq = (e) => {
    setQinfoDone(e.target.value);
  };
  const handleEstablishment = (e) => {
    setEstablishmentDone(e.target.value);
  };
  const handleSupplyChainEstDate = (e) => {
    setSupplyChainEstDate(e.target.value);
  };
  const handlePurchaseOrderNumber = (e) => {
    setPurchaseOrderNumber(e.target.value);
  };
  const handlePurchaseOrderDate = (e) => {
    setPurchaseOrderDate(e.target.value);
  };
  const handleDevelopmentType = (e) => {
    setDevelopementData(e.target.value);
  };
  const [sqepValue, setSqepValue] = useState();
  const handleCsQE = (e) => {
    setSqepValue(e.target.value);
  };

  const [sprpValue, setSprpValue] = useState(prevRowData.sprPersonAssigned);

  const handleChangeSpr = (e) => {
    setSprpValue(e.target.value);
  };
  const [oprpValue, setOprpValue] = useState();
  const handleChangeOpr = (e) => {
    setOprpValue(e.target.value);
  };
  const toggleTab = (id) => {
    setActive(id);
    if (id === 1) {
      openTab1();
    } else {
      openTab2();
    }
  };
  const openTab1 = (e) => {
    setTab1(true);
    setTab2(false);
  };

  const handleClose = (e) => {
    setOpen(false);
  };
  const openTab2 = (e) => {
    setTab2(true);
    setTab1(false);
  };

  const [prevSppn, setPrevSPPN] = useState("");

  const [prevsetSNid, setPrevsetSNid] = useState();

  const [prevSupp, setPrevSupp] = useState(prevsetSNid);
  const [realPrevSname, setRealPrevSname] = useState(prevRowData.supplierName);
  const [prevVCode, setPrevVCode] = useState(prevRowData.supplierCode);
  const [prevAllEmailIds, setPrevAllEmailIds] = useState([]);
  const [prevSupId, setPrevSupId] = useState(prevRowData.supplierId);

  const handlePrevSupp = (e) => {
    setPrevSupp(e.target.value);

    const prevSupVal = supplier.find((x) => x.id == e.target.value);

    setRealPrevSname(prevSupVal.name);

    setPrevVCode(prevSupVal != undefined ? prevSupVal.code : "");
    let prevAllEmails = emailId.filter((item) => {
      return item.code === prevSupVal.code;
    });
    setPrevAllEmailIds(prevAllEmails);
  };
  const [getPrevSupFemailId, setPrevSupFemailId] = useState(
    prevRowData.suppliercontactpersonemailIdanother
  );
  const prevSupFemailId = (e) => {
    setPrevSupFemailId(e.target.value);
    let prevSsi = prevAllEmailIds.find((item) => item.email === e.target.value);

    setPrevSupId(prevSsi.supplierId);
  };
  const [prevSSecondEmailId, setPrevSSecondEmailId] = useState(
    prevRowData ? prevRowData.supplierContactpersonEmailIDnotanother : ""
  );
  const handleSSecondEmail = (e) => {
    setPrevSSecondEmailId(e.target.value);
  };

  const [prevNoId, setPrevNoid] = useState(prevRowData.automatedIsirnoId);
  const [prevModifiedBy, setPrevModifiedBy] = useState(prevRowData.modifiedBy);
  const [prevIsActive, setPrevIsActive] = useState(prevRowData.isActive);

  const [prevGrp, setPrveGrp] = useState(prevRowData.groupId);
  const handleChangeGroup = (e) => {
    setPrveGrp(e.target.value);
  };
  const [prevspirisonNumber, setPrevspirisonNumber] = useState(
    prevRowData.spiridonNumber
  );
  const handlePrevSpiri = (e) => {
    setPrevspirisonNumber(e.target.value);
  };
  const [prevNenaNumber, setPrevNenaNumber] = useState(
    prevRowData.nenaNoDrawingNumber
  );
  const handlePrevNena = (e) => {
    var data = e.target.value;

    setPrevNenaNumber(data.toString());
  };

  const [prevRevDate, setPrevRevDate] = useState(prevRowData.revisionDate);
  const handlePrevrevDate = (e) => {
    setPrevRevDate(e.target.value);
  };
  const [rdprevcation, setRdLprev] = useState(prevRowData.rdLocationId);
  const handleRDLpre = (e) => {
    setRdLprev(e.target.value);
  };
  const [prevRdCPerson, setPrevRdCPerson] = useState(
    prevRowData.rdcontactPersonId
  );
  const handlePrevRDCPerson = (e) => {
    setPrevRdCPerson(e.target.value);
  };

  const [prevDevelopment, setPrevDevelopment] = useState(
    prevRowData.developmentTypeId
  );
  const handlePrevDv = (e) => {
    setPrevDevelopment(e.target.value);
  };
  const [prevDescr, setPrevDecr] = useState(prevRowData.description);
  const handlePrevDesc = (e) => {
    setPrevDecr(e.target.value);
  };

  const [prevDrawing, setPrevDrawing] = useState(
    prevRowData.drawingRevisionNumber
  );
  const handlePrevDra = (e) => {
    setPrevDrawing(e.target.value);
  };
  const [prevProd, setPrevProd] = useState(prevRowData.product);
  const handlePrevProd = (e) => {
    setPrevProd(e.target.value);
  };
  const [prevSn, setPrevSn] = useState(prevRowData.sesoNo);

  const handlePrevSn = (e) => {
    setPrevSn(e.target.value);
  };
  const [prevCC, setPrevCC] = useState(prevRowData.cehod);
  const handlePrevCC = (e) => {
    setPrevCC(e.target.value);
  };

  const [prevSqe, setPrevSqe] = useState(prevRowData.sqePersonAssigned);
  const handlePrevSqe = (e) => {
    setPrevSqe(e.target.value);
  };
  const [PrevSpr, setPrevSpr] = useState(prevRowData.sprPersonAssigned);
  const handlePrevSpr = (e) => {
    setPrevSpr(e.target.value);
  };

  const [prevOpr, setPrevOpr] = useState(prevRowData.oprPersonAssigned);
  const handlePrevOpr = (e) => {
    setPrevOpr(e.target.value);
  };

  const [prevPQ, setPrevPQ] = useState(prevRowData.pilotQuantity);
  const handlePrevPQ = (e) => {
    setPrevPQ(e.target.value);
  };

  const [prevQInfo, setPrevQInfo] = useState(prevRowData.qinfoRequest);
  const handlePrevQinfo = (e) => {
    setPrevQInfo(e.target.value);
  };

  const [qinfoUdate, setQinfoUdate] = useState(
    renderDateY(prevRowData.pilotlotrealeasetoSqe)
  );
  const handlePrevQinfoUpdated = (e) => {
    setQinfoUdate(e.target.value);
  };

  const [prevMassReleaseD, setPrevMassReleaseD] = useState(
    prevRowData.massReleasetoSQE
  );
  const handlePrevMRsqe = (e) => {
    setPrevMassReleaseD(e.target.value);
  };

  const [supplyChainPrev, setSupplyChainPrev] = useState(
    prevRowData.supplyChainEstablishmentDone
  );
  const handlePrevSupplyChain = (e) => {
    setSupplyChainPrev(e.target.value);
  };

  const [prevSupplyEstD, setPrevSupplyEstD] = useState(
    prevRowData.supplyChainEstablishmentDate
  );
  const handlePrevSupplyEstDate = (e) => {
    setPrevSupplyEstD(e.target.value);
  };

  const [prevPurchaseN, setPrevPurchaseN] = useState(
    prevRowData.purchaseorderNumber
  );
  const handlePrevPurchaseN = (e) => {
    setPrevPurchaseN(e.target.value);
  };

  const [prevPurchaseD, setPrevPurchseD] = useState(
    prevRowData.purchaseorderDate
  );
  const handlePurcahseOrderDate = (e) => {
    setPrevPurchseD(e.target.value);
  };
  const [prevSupplierN, setPrevSupplierN] = useState(prevRowData.supplierName);
  const handlePrevSupplierN = (e) => {
    const enteredVal = e.target.value;
    setPrevSupplierN(e.target.value);
  };

  const handleChange1 = (event, newValue) => {
    //&& (prevRowData.statusId == 2 || prevRowData.statusId == 7 || prevRowData.isApprovedByCe==false ||prevRowData.isApprovedByCe==true ||prevRowData.isRejectedByCe==true || prevRowData.isRejectedByCe==false)
    if (newValue == 1) {
      handleDownloadTb1Data(isirWorkFlowNumber);
      if (uploadFt || getD12) {
        setValue(newValue);
      }
    }
    if (newValue == 0) {
      setValue(newValue);
    }
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };
  const [getDinAddisir, setGetDinAddisir] = useState([]);

  const [toShowCloseBtn, setToShowCloseBtn] = useState(false);
  const [showCloseDate, setShowCloseDate] = useState(false);
  function getDinAddisirpage() {
    setIsLoader(true);

    getAllIsirDetails(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        setGetDinAddisir(response);
        console.log("openIsire", response);
        setIsLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }
  useEffect(() => {
    getDinAddisirpage();
  }, []);

  useEffect(() => {
    dispatch(poTextAction(false));
    dispatch(closeBtnAction(false));
    dispatch(afterClosingIsirAction(false));
    //new
    dispatch(closeEnableForChildTypeAction(false));

    let filterIsirD = getDinAddisir.filter(
      (item) => item.automatedIsirnumber === isirWorkFlowNumber
    );
    filterIsirD.map((x) => {
      if (x.isPotextUploaded) {
        dispatch(poTextAction(true));
      }
    });
    //&& y.isApprovedByCe !==true   y.statusId==4 y.statusName="Approved by CE" y.isApprovedByCe==true y.isRejectedByCe==false
    filterIsirD.map((y) => {
      if (
        (y.statusName == "Submitted" &&
          y.statusId == 2 &&
          y.massReleasetoSQE !== null) ||
        (y.statusId == 4 &&
          y.statusName == "Approved by CE" &&
          y.isApprovedByCe == true &&
          y.isRejectedByCe == false &&
          y.massReleasetoSQE !== null)
      ) {
        setToShowCloseBtn(true);
        dispatch(closeBtnAction(true));
      }
    });
    filterIsirD.map((y) => {
      if (
        y.statusName == "ISIR Closed" &&
        y.statusId == 7 &&
        y.massReleasetoSQE !== null
      ) {
        setShowCloseDate(true);
        dispatch(afterClosingIsirAction(true));
      }
    });

    // dispatch(closeEnableForChildTypeAction(true));

    //filterIsirD.map((y) => {
    //    if (
    //        (y.statusName == "Submitted" &&
    //            y.statusId == 2 &&
    //            y.massReleasetoSQE == null && y.typeId==2) ||
    //        (y.statusId == 4 &&
    //            y.statusName == "Approved by CE" &&
    //            y.isApprovedByCe == true &&
    //            y.isRejectedByCe == false &&
    //            y.massReleasetoSQE == null && y.typeId == 2)
    //    ) {
    //        ///setToShowCloseBtn(true);
    //      //  dispatch(closeBtnAction(true));
    //        dispatch(closeEnableForChildTypeAction(true));
    //    }
    //});
    //filterIsirD.map((y) => {
    //    if (
    //        y.statusName == "ISIR Closed" &&
    //        y.statusId == 7 &&
    //        y.massReleasetoSQE == null && y.typeId==2
    //    ) {
    //       // setShowCloseDate(true);
    //      ///  dispatch(afterClosingIsirAction(true));
    //        dispatch(closeEnableForChildTypeAction(true));
    //    }
    //});
  }, [getDinAddisir]);

  const [getTb1d, setGetTb1d] = useState();
  const [uploadFt, setUploadFt] = useState(false);
  function handleDownloadTb1Data(isirNumberPassed) {
    getuploadedDatainDownLoadFile(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      isirNumberPassed
    )
      .then((response) => {
        setGetTb1d(response);
        let resD = response;
        if (resD.length > 0) {
          setUploadFt(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  //handleDownloadTb1Data(isirWorkFlowNumber);
  const [getD12, setGetD12] = useState(false);

  function handleDownloadTb1Data(isirNumberPassed) {
    getuploadedDatainDownLoadFile(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      isirNumberPassed
    )
      .then((response) => {
        setGetD12(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  useEffect(() => {
    handleDownloadTb1Data(isirWorkFlowNumber);
  }, []);

  function groupCategory() {
    getGroupcategory(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        setGroupState(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  function rdLocation() {
    getRDLocation(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        setRndLocation(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  function developmenType() {
    getDevelopment(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        setDevelopmentType(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  function typeFlowNew() {
    getTypeDDL(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        console.log("type", response);
        setTypeFlow(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  function AutomatedWorkflowNumber() {
    getAutomatedWorkFlowNumber(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        setIsirWorkFlowNumber(response.objResult.automatedISIRNumber);

        setIsirnoId(response.objResult.automatedIsirnoId);
        setCreated(response.objResult.createdby);
        setModified(response.objResult.modifiedby);
        setIsirActive(response.objResult.isActive);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function getSName() {
    getSupplierName(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        setSupplier(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const [rdGetRDemail, setRdGetRDemail] = useState([]);
  //getMasterAttachmentApiData
  function getWholeRDAllEmailId() {
    getWholeRDemailId(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        setRdGetRDemail(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  useEffect(() => {
    getWholeRDAllEmailId();
  }, []);

  function getSEmail() {
    getSupplierEmail(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        setEmailId(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  function statusDDL() {
    getStatus(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      userDetails.userId
    )
      .then((response) => {
        setStatus(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const [getRdData, setGetRdData] = useState([]);
  function getRdUsersData(rdlocationId) {
    getRdUsers(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      rdlocationId
    )
      .then((response) => {
        setGetRdData(response);
      })
      .catch((error) => {
        handleSnackOpen("Error : " + error, "error");
        setIsLoader(false);
      });
  }

  useEffect(() => {
    if (prevRowData.rdLocationId) {
      let newrdemailsidsonPageload = rdGetRDemail.filter(
        (y) => y.rdlocationId === prevRowData.rdLocationId
      );
      setGetRdData(newrdemailsidsonPageload);
    }
  }, [rdGetRDemail]);

  const [getSqePersonData, setGetEqePersonData] = useState([]);
  const handleGetSqe = (e) => {
    getSqe(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        setGetEqePersonData(response);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const [getSprPersonData, setGetSprPersonData] = useState([]);
  const handleGetSpr = (e) => {
    getSpr(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        setGetSprPersonData(response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [getOprPersonData, setGetOprPersonData] = useState([]);
  const handleGetOpr = (e) => {
    getOpr(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        setGetOprPersonData(response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  let closeData = {
    ClearQuestNo: clearQst,
    AutomatedISIRNoId: prevRowData.automatedIsirnoId ? prevNoId : isirnoId,
    automatedIsirnumber: isirWorkFlowNumber,
    CreatedBy: userDetails.userId,
    ModifiedBy: userDetails.userId,
    IsActive: prevRowData.isActive ? prevIsActive : isirActive,
    GroupId: prevRowData.groupId ? prevGrp : groupData,
    SpiridonNumber: prevRowData.spiridonNumber
      ? prevspirisonNumber
      : spiridonNumber,
    NENANoDrawingNumber: prevRowData.nenaNoDrawingNumber
      ? prevNenaNumber
      : drawingNumber,
    RevisionDate: prevRowData.revisionDate ? prevRevDate : dateInputs,
    SupplierCode: prevRowData.supplierCode ? prevVCode : vendorCodeName,
    SuppliercontactpersonemailIdanother: firstsEmailId,
    RdcontactPersonId: rndEmailId,
    RDLocationId: rndLocationData,
    DevelopmentTypeId: prevRowData.developmentTypeId
      ? prevDevelopment
      : developmentData,
    Description: prevRowData.description ? prevDescr : description,
    DrawingRevisionNumber: prevRowData.drawingRevisionNumber
      ? prevDrawing
      : drawingRevisionNumber,
    Product: prevRowData.product ? prevProd : product,
    //SESONo: prevRowData.sesoNo ? prevSn : sesoNo,
    SESONo: sesoNo,
    SupplierName: supplierName,
    SupplierContactpersonEmailIDnotanother: prevSSecondEmailId,
    CehodSeso: cc,
    Cehod: ssiCCemails,
    // Cehod: prevRowData.cehod ? prevCC : ssiCCemails,
    ComponentEngineerInitiator: userDetails.userFirstName,
    SQEPersonAssigned: prevSqe,
    SPRPersonAssigned: sprpValue,
    OPRPersonAssigned: prevOpr,
    // QinfoRequest: qInfo,
    QinfoRequest: qinfoDone,
    PilotQuantity: pilotQuantity,
    PilotlotrealeasetoSQE: pilotRelease,
    SupplyChainEstablishmentDone: establishmentDone,
    SupplyChainEstablishmentDate: supplyChainEstDate,
    PurchaseorderNumber: purchaseOrderNumber,
    PurchaseorderDate: purchaseOrderDate,
    MassReleasetoSQE: requestRaised,
    StatusId: 7,
    Requestopenedon: getTodayDateMoment(),
    Requestclosedon: null,
    UserId: userDetails.userId,
    Sender: userDetails.userFirstName,
    SupplierId: supplierId,
    SupplierNameId: selectedSupplierCode,
    Tfmcheckbox: tfcActiondataState,
    Trmcheckbox: trmActionDataState,
    Ppapcheckbox: ppapActionDataState,
    Dfmcheckbox: dfmActionDataState,
  };

  const [getClosure, setGetClosure] = useState(null);
  const [closureCloseDate, setClosureCloseDate] = useState(false);
  const [takeCloseDFromApi, setTakeCloseDFromApi] = useState();

  // const [getClosure, setGetClosure] = useState(null);
  const [closureCloseDateChild, setClosureCloseDateChild] = useState(false);
  const [takeCloseDFromApiChild, setTakeCloseDFromApiChild] = useState();

  function getClosureCloseDate() {
      //handleCloseDialog();
      //prevRowData.currentPendingWith == "UpdateSupplierAboutPOandIIPUpload" &&
      // setIsLoaderFeedback(true);
      if  (prevRowData.weightOfPart == null || prevRowData.weightOfPart == "")  {
          alert("please fill weight of part");
          return;
      }
    addClosureDate(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      closeData
    )
      .then((response) => {
        if (
          response &&
          response.objResult.massReleasetoSQE &&
          response.objResult.requestclosedon &&
          response.objResult.typeId == 1
        ) {
          setClosureCloseDate(true);
          setTakeCloseDFromApi(response.objResult.requestclosedon);
          /* dispatch(justCloseBtnPress(true));*/
        }

        if (
          response &&
          response.objResult.massReleasetoSQE &&
          response.objResult.requestclosedon &&
          response.objResult.typeId == 2
        ) {
            

          setClosureCloseDateChild(true);
          setTakeCloseDFromApiChild(response.objResult.requestclosedon);
          /* dispatch(justCloseBtnPress(true));*/
        }

        setGetClosure(response);

        if (response.response) {
          //setIsLoaderFeedback(false);
          handleSnackOpen(response.responseMsg, "success");
          setTimeout(() => {
            navigate("/Epwork");
          }, 3000);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  useEffect(() => {
    /* dispatch(justCloseBtnPress(false));*/
    if (takeCloseDFromApi) {
      dispatch(afterClosingIsirAction(true));
    }
  }, [getClosure, takeCloseDFromApi]);

  ///for closing and again opening isir disabled
  //useEffect(() => {
  //    if (takeCloseDFromApiChild) {
  //        dispatch(closeEnableForChildTypeAction(true));
  //    }

    //}, [getClosure, takeCloseDFromApiChild])

  

  let formData = {
    ClearQuestNo: clearQst,
    /// ClearQuestNo: prevRowData.clearQuestNo ? prevRowData.clearQuestNo : clearQst, //prevClearQuest  //prevRowData.clearQuestNo
    AutomatedISIRNoId: prevRowData.automatedIsirnoId ? prevNoId : isirnoId,
    automatedIsirnumber: isirWorkFlowNumber,
    CreatedBy: userDetails.userId,
    ModifiedBy: userDetails.userId,
    IsActive: prevRowData.isActive ? prevIsActive : isirActive,
    GroupId: prevRowData.groupId ? prevGrp : groupData,
    SpiridonNumber: prevRowData.spiridonNumber
      ? prevspirisonNumber
      : spiridonNumber,
    NENANoDrawingNumber: prevRowData.nenaNoDrawingNumber
      ? prevNenaNumber
      : drawingNumber,
    RevisionDate: prevRowData.revisionDate ? prevRevDate : dateInputs,
    SupplierCode: prevRowData.supplierCode ? prevVCode : vendorCodeName,

    SuppliercontactpersonemailIdanother: firstsEmailId,

    RdcontactPersonId: rndEmailId,
    RDLocationId: rndLocationData,
    DevelopmentTypeId: prevRowData.developmentTypeId
      ? prevDevelopment
      : developmentData,

    Description: prevRowData.description ? prevDescr : description,
    DrawingRevisionNumber: prevRowData.drawingRevisionNumber
      ? prevDrawing
      : drawingRevisionNumber,
    Product: prevRowData.product ? prevProd : product,
    SESONo: sesoNo,

    SupplierName: supplierName,

    SupplierContactpersonEmailIDnotanother: prevSSecondEmailId,

    // Cehod: prevRowData.cehod ? prevCC : ssiCCemails,
    CehodSeso: cc,
    Cehod: ssiCCemails,

    ComponentEngineerInitiator: userDetails.userFirstName,
    SQEPersonAssigned: prevSqe,
    SPRPersonAssigned: sprpValue,

    OPRPersonAssigned: prevOpr,
    // QinfoRequest: qInfo,
    QinfoRequest: qinfoDone,
    PilotQuantity: pilotQuantity,
    PilotlotrealeasetoSQE: pilotRelease,

    SupplyChainEstablishmentDone: establishmentDone,
    SupplyChainEstablishmentDate: supplyChainEstDate,
    PurchaseorderNumber: purchaseOrderNumber,
    PurchaseorderDate: purchaseOrderDate,
    MassReleasetoSQE: requestRaised,
    StatusId: 1,
    Requestopenedon: getTodayDateMoment(),

    Requestclosedon: null,

    UserId: userDetails.userId,
    Sender: userDetails.userFirstName,

    SupplierId: supplierId,
    SupplierNameId: selectedSupplierCode,
    Tfmcheckbox: tfcActiondataState,
    Trmcheckbox: trmActionDataState,
    Ppapcheckbox: ppapActionDataState,
    Dfmcheckbox: dfmActionDataState,
      TypeId: type,
      WeightOfPart: prevWeightOfpart || weightPart,
     // WeightOfPart: prevRowData.weightOfPart ? prevWeightOfpart : weightPart,

  };

  let subData = {
    ClearQuestNo: clearQst, //prevRowData.clearQuestNo
    AutomatedISIRNoId: prevRowData.automatedIsirnoId ? prevNoId : isirnoId,
    automatedIsirnumber: isirWorkFlowNumber,

    CreatedBy: userDetails.userId,
    ModifiedBy: userDetails.userId,

    IsActive: prevRowData.isActive ? prevIsActive : isirActive,
    GroupId: prevRowData ? prevGrp : groupData,
    SpiridonNumber: prevRowData ? prevspirisonNumber : spiridonNumber,
    NENANoDrawingNumber: prevRowData ? prevNenaNumber : drawingNumber,
    RevisionDate: prevRowData ? prevRevDate : dateInputs,
      SupplierCode: vendorCodeName,//just changed

    SuppliercontactpersonemailIdanother: firstsEmailId,
    RdcontactPersonId: rndEmailId,
    RDLocationId: rndLocationData,

    DevelopmentTypeId: prevRowData ? prevDevelopment : developmentData,

    Description: prevRowData ? prevDescr : description,
    DrawingRevisionNumber: prevRowData ? prevDrawing : drawingRevisionNumber,
    Product: prevRowData ? prevProd : product,
    SESONo: sesoNo,
    SupplierName: supplierName,

    SupplierContactpersonEmailIDnotanother: prevSSecondEmailId,
    CehodSeso: cc,
    Cehod: ssiCCemails,

    ComponentEngineerInitiator: userDetails.userFirstName,
    SQEPersonAssigned: prevSqe,
    SPRPersonAssigned: sprpValue,

    OPRPersonAssigned: prevOpr,
    // QinfoRequest: qInfo,
    QinfoRequest: qinfoDone,
    PilotQuantity: pilotQuantity,
    PilotlotrealeasetoSQE: pilotRelease,

    SupplyChainEstablishmentDone: establishmentDone,
    SupplyChainEstablishmentDate: supplyChainEstDate,
    PurchaseorderNumber: purchaseOrderNumber,
    PurchaseorderDate: purchaseOrderDate,
    MassReleasetoSQE: requestRaised,
    StatusId: 2,
    Requestopenedon: getTodayDateMoment(),

    Requestclosedon: null,

    UserId: userDetails.userId,
    Sender: userDetails.userFirstName,

     // SupplierId: prevRowData.supplierId ? prevSupId : supplierId,--just changed
      SupplierId:  supplierId,
    SupplierNameId: selectedSupplierCode,
    Tfmcheckbox: tfcActiondataState,
    Trmcheckbox: trmActionDataState,
    Ppapcheckbox: ppapActionDataState,
    Dfmcheckbox: dfmActionDataState,
      TypeId: type,
      WeightOfPart: prevWeightOfpart || weightPart,
  /*  WeightOfPart: prevRowData.weightOfPart ? prevWeightOfpart : weightPart,*/
  };
  
  const [open, setOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const handleSnackOpen = (text, type) => {
    setSnackMessage(text);
    setAlertType(type);
    setOpen(true);
  };

  const [isLoader, setIsLoader] = useState(false);

  const [dialogErrorText, setDialogErrorText] = useState("");

  const [openValidationDialog, setOpenValidationDialog] = useState("");

  const handleClickOpenDialogValidation = (text) => {
    setDialogErrorText(text);
    setOpenValidationDialog(true);
  };
  const [isLoaderFeedback, setIsLoaderFeedback] = useState(false);
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const [openDialog, setOpenDialog] = useState(false);
  const handleSavedraftDataOne = (e) => {
    e.preventDefault();

    // if (!parentSQMAPQPQuestionare) {
    //   alert("Please upload SQM Check_APQP Questionnaire.pdf file");
    //   return;
    // }

    handleCloseDialog();
    setIsLoader(true);
    //setIsLoaderFeedback(true);
    //if (formData.GroupId === 2 && formData.ClearQuestNo === "") {
    //    setIsLoader(false);
    //    alert("Please Fill Clear Quest  Number");
    //    setIsLoader(false);
    //    return;
    //}

    SaveasDraft(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      formData
    )
      .then((response) => {
        formData = response.objResult;
        if (response.response) {
          setIsLoader(false);
          handleSnackOpen(response.responseMsg, "success");
          dispatch(tfcAction(false));
          dispatch(trmAction(false));
          dispatch(ppapAction(false));
          dispatch(dfmAction(false));
          setIsLoaderFeedback(false);
        } else {
          handleSnackOpen(response.responseMsg, "error");
          setIsLoaderFeedback(false);
        }
      })
      .catch((error) => {
        handleSnackOpen("Exception : " + error, "error");
        setIsLoaderFeedback(false);
      });
  };
  const [showCloseWhileSavingD, setShowCloseWhileSavingD] = useState(false);
  //const isirDocumentList = useSelector((state) => state.saveIsirDocumentList.isir);
  const uploadToolSpecification = useSelector(
    (state) => state.toolSpecificationReducer.toolSpecificationValue
  );

  const handleSubmitDataOne = (e) => {
    e.preventDefault();
      ///  if (!parentSQMAPQPQuestionare && isirWorkFlowNumber && !prevRowData.automatedIsirnoId)
      if (!sqmCheckApqpDataState && (groupData == 1 || groupData == 2 || groupData == 4 || groupData == 5 || prevRowData.groupId == 1 || prevRowData.groupId == 2 || prevRowData.groupId == 4 || prevRowData.groupId == 5)) {
      alert("Please upload SQM Check_APQP Questionnaire.pdf file");
      return;
      }
     

    if (!isSavedClicked && selectedRows?.length == 0) {
      handleSnackOpen("Please press SAVE before submitting.", "error");
      return;
    }
    handleCloseDialog();
    setIsLoaderFeedback(true);
    if (
      subData.GroupId == 3 &&
      subData.SESONo == "" &&
      prevRowData.sesoNo == ""
    ) {
      setIsLoaderFeedback(false);
      handleSnackOpen("Please fill SESO Number", "error");
      return;
    } else if (
      subData.GroupId !== 3 &&
      subData.SuppliercontactpersonemailIdanother == ""
    ) {
      setIsLoaderFeedback(false);
      handleSnackOpen("Please Fill Supplier Email Id", "error");
      return;
    } else if (
      subData.GroupId !== 3 &&
      subData.SupplierContactpersonEmailIDnotanother == ""
    ) {
      setIsLoaderFeedback(false);
      handleSnackOpen("Please Fill Supplier Email Id", "error");
      return;
    } else if (subData.GroupId == null || subData.GroupId == undefined) {
      setIsLoaderFeedback(false);
      handleSnackOpen("Please Fill Group Data", "error");
      return;
    } else if (
      subData.SpiridonNumber == null ||
      subData.SpiridonNumber == undefined ||
      subData.SpiridonNumber == ""
    ) {
      setIsLoaderFeedback(false);
      handleSnackOpen("Please Fill Spiridon Number", "error");
      return;
    } else if (
      subData.NENANoDrawingNumber == null ||
      subData.NENANoDrawingNumber == undefined ||
      subData.NENANoDrawingNumber == 0
    ) {
      setIsLoaderFeedback(false);
      handleSnackOpen("Please Fill NENANo/DrawingNumber Number", "error");
      return;
    } else if (subData.GroupId !== 3 && subData.SupplierName === "") {
      setIsLoaderFeedback(false);
      handleSnackOpen("Please Fill Supplier Name", "error");
      return;
    } else if (subData.RevisionDate === "" || subData.RevisionDate == null) {
      setIsLoaderFeedback(false);
      handleSnackOpen("Please Fill Revision Date", "error");
      return;
    } else if (
      subData.GroupId !== 3 &&
      (subData.RDLocationId === "" ||
        subData.RDLocationId == null ||
        subData.RDLocationId == undefined)
    ) {
      setIsLoaderFeedback(false);
      handleSnackOpen("Please Fill R&D Location", "error");
      return;
    } else if (
      subData.GroupId !== 3 &&
      (subData.RdcontactPersonId === "" ||
        subData.RdcontactPersonId == null ||
        subData.RdcontactPersonId == undefined)
    ) {
      setIsLoaderFeedback(false);
      handleSnackOpen("Please Fill R&D Contact person Email Id", "error");
      return;
    } else if (
      subData.DevelopmentTypeId == null ||
      subData.DevelopmentTypeId == undefined
    ) {
      setIsLoaderFeedback(false);
      handleSnackOpen("Please Fill Development Type", "error");
      return;
    } else if (subData.Description == "" || subData.Description == undefined) {
      setIsLoaderFeedback(false);
      handleSnackOpen("Please Fill Description", "error");
      return;
    } else if (
      subData.DrawingRevisionNumber == null ||
      subData.DrawingRevisionNumber == undefined ||
      subData.DrawingRevisionNumber == ""
    ) {
      setIsLoaderFeedback(false);
      handleSnackOpen("Please Fill Drawing Revision Number", "error");
      return;
    } else if (
      subData.GroupId == 2 &&
      subData.ClearQuestNo == "" &&
      prevClearQuest == ""
    ) {
      setIsLoaderFeedback(false);
      handleSnackOpen("Please fill Clear Quest Number", "error");
      return;
    }
    const isEditMode = !!prevRowData.automatedIsirnoId;
    const isRoleMatched = [1, 2, 6].includes(userDetails.roleId);
    const isDrawingUploaded = !!fileUploadDetailss;
    const is3DUploadedFinal = !!is3DUploaded;
    const istoolSpecification = !!isToolSpecification;

    // Check if Drawing and 3D files are mandatory
    const isDrawingMandatory = documentList?.some(
      (doc) => doc.documentName === "Drawings.pdf" && doc.isMandatory
    );

    const is3DMandatory = documentList?.some(
      (doc) =>
        doc.documentName === "3D.stp/.cdr/.igs (Zip file only!)" &&
        doc.isMandatory
    );

    const isToolspec = documentList?.some(
      (doc) =>
        doc.documentName === "Tool Specification for Tool.docx" &&
        doc.isMandatory
    );

    if (isRoleMatched && !isEditMode) {
      //  If thrice are mandatory and thrice are missing
      if (
        isDrawingMandatory &&
        is3DMandatory &&
        isToolspec &&
        !istoolSpecification &&
        !isDrawingUploaded &&
        !is3DUploadedFinal
      ) {
        setIsLoaderFeedback(false);
        handleSnackOpen(
          "Upload Drawing.pdf and 3D file and Tool specification is mandatory files",
          "error"
        );
        return;
      }

      //  If only Drawing is mandatory and not uploaded
      if (isDrawingMandatory && !isDrawingUploaded) {
        setIsLoaderFeedback(false);
        handleSnackOpen("Upload Drawing.pdf is mandatory", "error");
        return;
      }

      // If only 3D is mandatory and not uploaded
      if (is3DMandatory && !is3DUploadedFinal) {
        setIsLoaderFeedback(false);
        handleSnackOpen("Upload 3D file is mandatory", "error");
        return;
      }
      if (isToolspec && !istoolSpecification) {
        setIsLoaderFeedback(false);
        handleSnackOpen("Tool specification file is mandatory", "error");
        return;
      }
    }

    submit(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      subData
    )
      .then((response) => {
        subData = response.objResult;
        if (
          response &&
          response.objResult.statusId == 2 &&
          response.objResult.massReleasetoSQE != null
        ) {
          setShowCloseWhileSavingD(true);
          dispatch(closeBtnAction(true));
        }

        if (
          response.response &&
          response.objResult.groupId !== 0 &&
          response.objResult.spiridonNumber !== ""
        ) {
          setIsLoaderFeedback(false);
            handleSnackOpen(response.responseMsg, "success");
            setTimeout(() => {
                navigate("/Epwork");
            }, 3000);
        } else {
          setIsLoaderFeedback(false);
          handleSnackOpen(response.responseMsg, "error");
        }
      })
      .catch((error) => {
        setIsLoaderFeedback(false);
        handleSnackOpen("Exception : " + error, "error");
      });
  };

  //console.log("prevRowDatapurchaseorderDate", prevRowData.purchaseorderDate);

  const [ccData, setCCdata] = useState([]);
  const [prevSupplierName, setPrevSupplierName] = useState("");
  const [prevSupplierEmailFirst, setPrevSupplierEmailFirst] = useState("");
  const [prevSupplierEmailIdSecond, setPrevSupplierEmailIdSecond] =
    useState("");
  const [prevSupplierRevisionDate, setPrevSupplierRevisionDate] = useState("");
  const [prevQinfoUpDate, setPrevQinfoUpDate] = useState("");
  const [prevMassReleasesqe, setprevMassReleasesqe] = useState("");
  const [prevSupplyChainestDate, setPrevSupplyChainestDate] = useState("");
  const [prevSupplyPurchaseDate, setPrevSupplyPurchaseDate] = useState("");

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(iipAction(false));
    dispatch(sqmCheckApqpAction(false));
    dispatch(storeIsirDocumentList([]));

    setCCdata(prevRowData.cehod);
    groupCategory();
    rdLocation();
    developmenType();
    typeFlowNew();
    getSName();
    getSEmail();
    handleGetSqe();
    handleGetSpr();
    handleGetOpr();
    //getUploadDocumentTableData();
    // getIsirDocumentListData(prevRowData ? prevRowData?.automatedIsirnumber : isirWorkFlowNumber);
  }, []);

  useEffect(() => {
    if (prevRowData.automatedIsirnumber) {
      setIsirWorkFlowNumber(prevRowData.automatedIsirnumber);
    } else {
      AutomatedWorkflowNumber();
    }
  }, []);
  //const [isirDocumentList, setIsirDocumentList] = useState([]);

  function renderDateY(value) {
    let DateFormat = !value ? null : moment(value).format("YYYY-MM-DD");
    return DateFormat;
  }

  function renderDateYC(value) {
    let DateFormatClosedD = !value ? null : moment(value).format("MM/DD/YYYY");
    return DateFormatClosedD;
  }

  function renderDatePrevYC(value) {
    let DateFormatClosedDprev = !value
      ? null
      : moment(value).format("MM/DD/YYYY");
    return DateFormatClosedDprev;
  }

  const columnsUploadData = [
    {
      title: "Upload File List",
      field: "documentName",
      render: (rowData) => <span>{rowData.documentName}</span>,
      headerStyle: { fontWeight: "bold" },
    },
    {
      title: "Tabs",
      field: "tabNumber",
      render: (rowData) => <span>{rowData.tabNumber}</span>,
      headerStyle: { fontWeight: "bold" },
    },
  ];

  const [tableData, setTableData] = useState([]);
  let replicateData;
  function getUploadDocumentTableData(isirNo) {
    setIsLoader(true);

    getUploadDocumentData(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        console.log("tableData", response);
        setTableData(response);
        replicateData = response;
        setIsLoader(false);
        getIsirDocumentListData(isirNo);
      })
      .catch((error) => {
        handleSnackOpen("Error : " + error, "error");
        setIsLoader(false);
      });
  }

  //function closeBtnEnabledConditionData(isirNo) {
  //    setIsLoader(true);

  //    getCloseEnableDataCondition(
  //        siteToken.token,
  //        azureToken.token,
  //        UID.id,
  //        userDetails.userEmail,
  //        userDetails.gid,
  //        userDetails.role,
  //        userDetails.roleId
  //    )
  //        .then((response) => {
  //            console.log("closeDataconditioncheck", response);

  //            setIsLoader(false);

  //        })
  //        .catch((error) => {
  //            handleSnackOpen("Error : " + error, "error");
  //            setIsLoader(false);
  //        });
  //}

  const [isSavedClicked, setIsSavedClicked] = useState(false);

  const handleFileUploadList = () => {
      console.log("selectedRows inside save:", selectedRows);
      console.log("save btn clicked!", developmentData);
    const mandatoryDocuments = [
      "EM EA GF QM FR 056_ISIR.pdf",
      "EM EA GF QM FR 060_Quality Plan.pdf (IIP)",
    ];

    const allMandatorySelected = mandatoryDocuments.every((mandatoryDocName) =>
      (selectedRows || []).some(
        (selected) => selected.documentName === mandatoryDocName
      )
    );

    if (!allMandatorySelected) {
      // Show warning message but do NOT stop save
      alert(
        `Selection of the following two files is mandatory to enable access to Data Two.\n 1.EM EA GF QM FR 056_ISIR.pdf\n2.EM EA GF QM FR 060_Quality Plan.pdf (IIP)`
      );
      }

     // let xyz = selectedRows.documentName == 3D.stp/.cdr/.igs(Zip file only!)
      let sqmCheckApqpFileTick =
          selectedRows &&
          selectedRows.some(
              (item) =>
                  item.documentId == 28 &&
                  item.documentName == "SQM Check_APQP Questionnaire.pdf"
          );
      console.log("sqmCheckApqpFileTick", sqmCheckApqpFileTick);

      let balloningDrawingFileTick =
          selectedRows &&
          selectedRows.some(
              (item) =>
                  item.documentId == 10 &&
                  item.documentName == "Ballooning Drawing.pdf"
          );
      console.log("balloningDrawingFileTick", balloningDrawingFileTick);

      let tfcFileTick = selectedRows && selectedRows.some((item) => item.documentId == 11 && item.documentName == "Filled and Signed EM EA GF QM FR 033_TFC.pdf");
      console.log("tfcFileTick", tfcFileTick);

      let trmFileTick = selectedRows && selectedRows.some((item) => item.documentId == 12 && item.documentName == "Filled and Signed EM EA GF QM FR 046_TRM.pdf");
      console.log("trmFileTick", trmFileTick);

      let dfmFileTick = selectedRows && selectedRows.some((item) => item.documentId == 13 && item.documentName == "DFM.ppt");
      console.log("dfmFileTick", dfmFileTick);

      let toolDesignFileTick = selectedRows && selectedRows.some((item) => item.documentId == 14 && item.documentName == "Tool Design.stp / .igs (Zip file only!)");
      console.log("toolDesignFileTick", toolDesignFileTick);

      let ppaeXlsxReviewFileTick = selectedRows && selectedRows.some((item) => item.documentId == 19 && item.documentName == "PPAP.xlsx for review");
      console.log("ppaeXlsxReviewFileTick", ppaeXlsxReviewFileTick);

      let ppapSignoffFileTick = selectedRows && selectedRows.some((item) => item.documentId == 20 && item.documentName == "PPAP.pdf for signoff");
      console.log("ppapSignoffFileTick", ppapSignoffFileTick);

      let drawingfileTick = selectedRows && selectedRows.some((item) => item.documentId == 1 && item.documentName == "Drawings.pdf");
      console.log("drawingfileTick", drawingfileTick);
      let threeDstpTick = selectedRows && selectedRows.some((item) => item.documentId == 2 && item.documentName == "3D.stp/.cdr/.igs (Zip file only!)");
      console.log("threeDstpTick", threeDstpTick);
      let toolSpecificationfileTick = selectedRows && selectedRows.some((item) => item.documentId == 3 && item.documentName == "Tool Specification for Tool.docx");
      console.log("toolSpecificationfileTick", toolSpecificationfileTick);
      ///for seso tick creation

    

      let AdditionalUploadBySupplierFileTick =
          selectedRows &&
          selectedRows.some(
              (item) =>
                  item.documentId == 16 &&
                  item.documentName ==
                  "Additional Uploads By Supplier (Zip file only!)"
          );
      console.log(
          "AdditionalUploadBySupplierFileTick",
          AdditionalUploadBySupplierFileTick
      );

      let isirPdfFileTick =
          selectedRows &&
          selectedRows.some(
              (item) =>
                  item.documentId == 17 &&
                  item.documentName == "EM EA GF QM FR 056_ISIR.pdf"
          );
      console.log("isirPdfFileTick", isirPdfFileTick);

      let qualityPlanFileTick =
          selectedRows &&
          selectedRows.some(
              (item) =>
                  item.documentId == 18 &&
                  item.documentName == "EM EA GF QM FR 060_Quality Plan.pdf (IIP)" 
                  
          );
      console.log("qualityPlanFileTick", qualityPlanFileTick);

     

      let incomingQulaityReportFileTick =
          selectedRows &&
          selectedRows.some(
              (item) =>
                  item.documentId == 21 &&
                  item.documentName == "Incoming Quality Report.pdf (Pilot Batch)" 
          );
      console.log("incomingQulaityReportFileTick", incomingQulaityReportFileTick);

      let HebburnApprovalFileTick =
          selectedRows &&
          selectedRows.some(
              (item) =>
                  item.documentId == 22 &&
                  item.documentName == "Approval from SPDL,Hebburn"
                
          );
      console.log("HebburnApprovalFileTick", HebburnApprovalFileTick);

      let crerPdfFileTick =
          selectedRows &&
          selectedRows.some(
              (item) =>
                  item.documentId == 23 &&
                  item.documentName == "CRER.pdf"
          );
      console.log("crerPdfFileTick", crerPdfFileTick);

      let componentApprovalFileTick =
          selectedRows &&
          selectedRows.some(
              (item) =>
                  item.documentId == 24 &&
                  item.documentName == "Component Approval form.pdf" 
          );
      console.log("componentApprovalFileTick", componentApprovalFileTick);

      let AdditionalUploadByCEFileTick =
          selectedRows &&
          selectedRows.some(
              (item) =>
                  item.documentId == 25 &&
                  item.documentName == "Additional upload By CE (Zip file only!)" 
                
          );
      console.log("AdditionalUploadByCEFileTick", AdditionalUploadByCEFileTick);



    
      //if ((developmentData == 1 || prevRowData.developmentTypeId == 1) && (tfcFileTick || trmFileTick || dfmFileTick || toolDesignFileTick || ppaeXlsxReviewFileTick || ppapSignoffFileTick || drawingfileTick || threeDstpTick || toolSpecificationfileTick)) {
      //    alert("The selected files are not applicable for the Development Type �Catalogue� in either Tab 1 or Tab 2. This includes: TFC, TRM, DFM, Tool Specification, PPAP Review, PPAP Signoff, Drawings (PDF), 3D files, and Tool Design.");
      //    return;
      //}
      ///seso-catlogue
      if (((developmentData == 1 || prevRowData.developmentTypeId == 1) && (groupData == 3 || prevRowData.groupId)) && (balloningDrawingFileTick || tfcFileTick || trmFileTick || dfmFileTick || toolDesignFileTick || ppaeXlsxReviewFileTick || ppapSignoffFileTick || drawingfileTick || threeDstpTick || toolSpecificationfileTick || AdditionalUploadBySupplierFileTick || isirPdfFileTick || qualityPlanFileTick || incomingQulaityReportFileTick || crerPdfFileTick || sqmCheckApqpFileTick)) {
          alert("Please select only Additional upload by CE,FileComponentApproval");
          return;
      } 

     
      //seso-customize
      if (((developmentData == 2 || prevRowData.developmentTypeId == 2) && (groupData == 3 || prevRowData.groupId == 3)) && (balloningDrawingFileTick || tfcFileTick || trmFileTick || dfmFileTick || toolDesignFileTick || ppaeXlsxReviewFileTick || ppapSignoffFileTick || drawingfileTick || threeDstpTick || toolSpecificationfileTick || AdditionalUploadBySupplierFileTick || isirPdfFileTick || qualityPlanFileTick || incomingQulaityReportFileTick || sqmCheckApqpFileTick)) {
          alert("Please select only Additional upload by CE,FileComponentApproval and crer");
          return;
      }
      //otherThan seso--catlogue
      if (((developmentData == 1 || prevRowData.developmentTypeId == 1) && (groupData !== 3 || prevRowData.groupId !== 3)) && (tfcFileTick || trmFileTick || dfmFileTick || toolDesignFileTick || ppaeXlsxReviewFileTick || ppapSignoffFileTick || drawingfileTick || threeDstpTick || toolSpecificationfileTick)) {
          alert("The selected files are not applicable for the Development Type �Catalogue� in either Tab 1 or Tab 2. This includes: TFC, TRM, DFM, Tool Specification, PPAP Review, PPAP Signoff, Drawings (PDF), 3D files, and Tool Design.");
          return;
      }

      //if (((developmentData == 2 || prevRowData.developmentTypeId == 2) && (groupData == 3 || prevRowData.groupId)) && (tfcFileTick || trmFileTick || dfmFileTick || toolDesignFileTick || ppaeXlsxReviewFileTick || ppapSignoffFileTick || drawingfileTick || threeDstpTick || toolSpecificationfileTick)) {
      //    alert("Please select only Additional upload by CE,FileComponentApproval and crer");
      //    return;
      //}

    
    setIsLoaderFeedback(true);
    setIsSavedClicked(true);
    const inputs = []; // Array to collect all input objects

    tableData.forEach((row, index) => {
      const input = {};
      input.Id = documentList[index]?.id || 0; // If exists, use saved ID; else 0 for first time
      input.Isir = prevRowData?.automatedIsirnumber || isirWorkFlowNumber;
      input.DocumentId = row?.documentId;
      input.IsMandatory = false; // Boolean true/false

      inputs.push(input);
    });
    const data = inputs;
    console.log("ismandatory", data);
    const safeSelectedRows = selectedRows || [];
    if (safeSelectedRows.length > 0) {
      for (let i = 0; i < safeSelectedRows?.length; i++) {
        for (let j = 0; j < data?.length; j++) {
          if (safeSelectedRows[i]?.documentId == data[j]?.DocumentId) {
            data[j].IsMandatory = true;
          }
        }
      }
    }

    console.log("data", data);

    // Single call with all inputs in one array
    saveOrUpdateIsirDocumentList(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      data // passing the array of input objects
    )
      .then((response) => {
        setIsLoaderFeedback(false); // Always stop the loader
        console.log("responseonSave", response);
        if (response?.response) {
          handleSnackOpen(
            response.responseMsg || "Saved successfully",
            "success"
          );
          getIsirDocumentListData(
            prevRowData?.automatedIsirnumber || isirWorkFlowNumber
          );
          //  This will now run as expected
        } else {
          handleSnackOpen(
            response?.responseMsg || "Something went wrong!",
            "error"
          );
        }
      })
      .catch((error) => {
        setIsLoaderFeedback(false);
        handleSnackOpen("Exception: " + (error?.message || error), "error");
      });
  };

  function getIsirDocumentListData(isirNo) {
    setIsLoader(true);
    if (isirNo == null || isirNo == "") {
      return;
    }
    //const isirNo = prevRowData ? prevRowData?.automatedIsirnumber : isirWorkFlowNumber
    getIsirDocumentList(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      isirNo
    )
      .then((response) => {
        //setTest(response);
        setDocumentList(response);

        if (response?.length > 0) {
          let flterdData = replicateData?.filter(
            (x, i) =>
              x.documentId == response[i].documentId && response[i].isMandatory
          );
          console.log("flterdData", flterdData);

          for (let i = 0; i < flterdData?.length; i++) {
            if (!flterdData[i].tableData) {
              flterdData[i].tableData = {};
            }
            flterdData[i].tableData.checked = true;
          }

          setSelectedRows(flterdData);

          dispatch(storeIsirDocumentList(response));

          //console.log('isirDocumentList',isirDocumentList);
          setIsLoader(false);
        } else {
          setIsLoader(false);
        }
      })
      .catch((error) => {
        handleSnackOpen("Error : " + error, "error");
        setIsLoader(false);
      });
  }

  useEffect(() => {
    if (prevRowData) {
      console.log("prevRowData", prevRowData);
      handleDownloadTb2Data(prevRowData.automatedIsirnumber);
      getUploadDocumentTableData(prevRowData.automatedIsirnumber);
      //   closeBtnEnabledConditionData(prevRowData.automatedIsirnumber);

      //  getUploadDocumentTableData
    } else {
      console.log("isirWorkFlowNumber", isirWorkFlowNumber);
      handleDownloadTb2Data(isirWorkFlowNumber);

      //if (documentList && dataTb2 && prevRowData.typeId == 2) {

      //    let makeCloseEnable = dataTb2.every(item => documentList.includes(item));
      //    console.log("makeCloseEnable", makeCloseEnable);
      //}

      getUploadDocumentTableData(isirWorkFlowNumber);
      //   closeBtnEnabledConditionData(isirWorkFlowNumber);
    }
  }, [isirWorkFlowNumber, prevRowData.automatedIsirnumber]);

  const [dataTb2, setDataTb2] = useState();
  function handleDownloadTb2Data(isirNumberPassed) {
    getuploadedDatainDownLoadFile(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      isirNumberPassed
    )
      .then((response) => {
        console.log("mainisirdownloadfiledata", response);
        //   getIsirDocumentListData(isirNumberPassed || prevRowData.automatedIsirnumber)

        setDataTb2(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  // const [uploadImageData, setUploadImageData] = useState("");
  // const [poTextImgData, setPoTextImgData] = useState();

  console.log("selectedRows", selectedRows);
  console.log("dataTb2", dataTb2);
  if (
    selectedRows &&
    selectedRows.length > 0 &&
    dataTb2 &&
    prevRowData.typeId == 2
  ) {
    let makeCloseEnable = dataTb2.every((item) => selectedRows.includes(item));
    console.log("makeCloseEnable", makeCloseEnable);
  }

  return (
    <div>
      <div className="main-heading">
        <div className="left-div">
          <h3 className="heading">Add ISIR fields</h3>
        </div>
        <div className="date">
          <div container spacing={2} className="request-part">
            <div item className="date-id" xs={12} sm={5} md={2}>
              <h4 style={{ background: "var(--btn-hero-bg-hover)" }}>
                Request Raised On:&nbsp;{formattedDate || getTodayDate()}
              </h4>
            </div>
            {prevRowData && prevRowData.typeId == 1 ? (
              <div item className="date-id" xs={12} sm={5} md={2}>
                <h4 style={{ background: "var(--btn-hero-bg-hover)" }}>
                  Request Closed On:&nbsp;
                  {prevRowData &&
                  prevRowData.statusName == "ISIR Closed" &&
                  prevRowData.typeId == 1 &&
                  prevRowData.statusId == 7 &&
                  prevRowData.massReleasetoSQE != null
                    ? renderDatePrevYC(prevRowData.requestclosedon)
                    : closureCloseDate
                    ? renderDateYC(takeCloseDFromApi)
                    : null}
                </h4>
              </div>
            ) : (
              <></>
            )}
            {prevRowData && prevRowData.typeId == 2 ? (
              <div item className="date-id" xs={12} sm={5} md={2}>
                <h4 style={{ background: "var(--btn-hero-bg-hover)" }}>
                  Request Closed On:&nbsp;
                  {prevRowData &&
                  prevRowData.statusName == "ISIR Closed" &&
                  prevRowData.typeId == 2 &&
                  prevRowData.statusId == 7 &&
                  prevRowData.massReleasetoSQE != null
                    ? renderDatePrevYC(prevRowData.requestclosedon)
                    : closureCloseDateChild
                    ? renderDateYC(takeCloseDFromApiChild)
                    : null}
                </h4>
              </div>
            ) : (
              <></>
            )}
            <div item className="date-id" xs={12} sm={5} md={2}>
              <h4 style={{ background: "var(--btn-hero-bg-hover)" }}>
                ISIR NUMBER:&nbsp;{" "}
                {prevRowData
                  ? prevRowData?.automatedIsirnumber
                  : isirWorkFlowNumber}
              </h4>
            </div>
          </div>
        </div>
      </div>

      <Grid container spacing={2} className="fields">
        {prevRowData ? (
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                Group*
              </InputLabel>
              <Select
                labelId="Group"
                id="group"
                name="group"
                onChange={handleChangeGroup}
                value={prevGrp}
                disabled={
                  userDetails.roleId == 3 ||
                  userDetails.roleId == 4 ||
                  userDetails.roleId == 5 ||
                  userDetails.roleId == 7 ||
                  userDetails.roleId == 8 ||
                  userDetails.roleId == 9 ||
                  userDetails.roleId == 10
                }
                input={<BootstrapInput />}
              >
                {groupState.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                Group*
              </InputLabel>
              <Select
                labelId="Group"
                id="group"
                name="group"
                onChange={handleChange}
                value={groupData}
                disabled={
                  userDetails.roleId == 3 ||
                  userDetails.roleId == 4 ||
                  userDetails.roleId == 5 ||
                  userDetails.roleId == 7 ||
                  userDetails.roleId == 8 ||
                  userDetails.roleId == 9 ||
                  userDetails.roleId == 10
                }
                input={<BootstrapInput />}
              >
                {groupState.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}

        {prevRowData ? (
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                Development Type*
              </InputLabel>
              <Select
                labelId="developmenttype"
                id="developmentType"
                name="developmenttype"
                onChange={handlePrevDv}
                value={prevDevelopment}
                disabled={
                  userDetails.roleId == 3 ||
                  userDetails.roleId == 4 ||
                  userDetails.roleId == 5 ||
                  userDetails.roleId == 7 ||
                  userDetails.roleId == 8 ||
                  userDetails.roleId == 9 ||
                  userDetails.roleId == 10
                }
                input={<BootstrapInput />}
              >
                {developmentType.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                Development Type*
              </InputLabel>
              <Select
                labelId="developmenttype"
                id="developmentType"
                name="developmenttype"
                onChange={handleDevelopmentType}
                value={developmentData}
                disabled={
                  userDetails.roleId == 3 ||
                  userDetails.roleId == 4 ||
                  userDetails.roleId == 5 ||
                  userDetails.roleId == 7 ||
                  userDetails.roleId == 8 ||
                  userDetails.roleId == 9 ||
                  userDetails.roleId == 10
                }
                input={<BootstrapInput />}
              >
                {developmentType.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
        {prevRowData ? (
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                Product
              </InputLabel>
              <BootstrapInput
                id="Sender-Name"
                name="product"
                onChange={handlePrevProd}
                disabled={
                  userDetails.roleId == 3 ||
                  userDetails.roleId == 4 ||
                  userDetails.roleId == 5 ||
                  userDetails.roleId == 7 ||
                  userDetails.roleId == 8 ||
                  userDetails.roleId == 9 ||
                  userDetails.roleId == 10
                }
                value={prevProd}
              />
            </FormControl>
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                Product
              </InputLabel>
              <BootstrapInput
                id="Sender-Name"
                name="product"
                onChange={handleProduct}
                disabled={
                  userDetails.roleId == 3 ||
                  userDetails.roleId == 4 ||
                  userDetails.roleId == 5 ||
                  userDetails.roleId == 7 ||
                  userDetails.roleId == 8 ||
                  userDetails.roleId == 9 ||
                  userDetails.roleId == 10
                }
                value={prevRowData ? prevRowData.product : product}
              />
            </FormControl>
          </Grid>
        )}

        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <InputLabel shrink htmlFor="bootstrap-input">
              {" "}
              Type
            </InputLabel>
            <Select
              labelId="type"
              id="typeflow"
              name="type"
              onChange={handleType}
              value={type}
              disabled={
                userDetails.roleId == 3 ||
                userDetails.roleId == 4 ||
                userDetails.roleId == 5 ||
                userDetails.roleId == 7 ||
                userDetails.roleId == 8 ||
                userDetails.roleId == 9 ||
                userDetails.roleId == 10
              }
              input={<BootstrapInput />}
            >
              {typeFlow.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <InputLabel shrink htmlFor="bootstrap-input">
              {groupData === 3 || prevRowData.groupId == 3
                ? "SESO No.*"
                : "SESO No."}
            </InputLabel>
            <BootstrapInput
              id="Sender-Name"
              name="sesono"
              onChange={handleSESONo}
              value={sesoNo}
              disabled={
                groupData == 1 ||
                groupData == 2 ||
                groupData == 4 ||
                groupData == 5 ||
                prevRowData.groupId == 1 ||
                prevRowData.groupId == 2 ||
                prevRowData.groupId == 4 ||
                prevRowData.groupId == 5 ||
                userDetails.roleId == 3 ||
                userDetails.roleId == 4 ||
                userDetails.roleId == 5 ||
                userDetails.roleId == 7 ||
                userDetails.roleId == 8 ||
                userDetails.roleId == 9 ||
                userDetails.roleId == 10
              }
              required
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <InputLabel shrink htmlFor="bootstrap-input">
              {groupData === 2 || prevRowData.clearQuestNo == 2
                ? "CI App ID No.*"
                : "CI App ID No."}
            </InputLabel>
            <BootstrapInput
              id="Sender-Name"
              name="sesono"
              onChange={handleClearQst}
              value={clearQst}
              disabled={
                groupData == 1 ||
                groupData == 3 ||
                groupData == 4 ||
                groupData == 5 ||
                prevRowData.clearQuestNo == 1 ||
                prevRowData.clearQuestNo == 3 ||
                prevRowData.clearQuestNo == 4 ||
                prevRowData.clearQuestNo == 5 ||
                userDetails.roleId == 3 ||
                userDetails.roleId == 4 ||
                userDetails.roleId == 5 ||
                userDetails.roleId == 7 ||
                userDetails.roleId == 8 ||
                userDetails.roleId == 9 ||
                userDetails.roleId == 10
              }
              required
            />
          </FormControl>
        </Grid>

        {prevRowData ? (
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                Spiridon Number*
              </InputLabel>
              <BootstrapInput
                name="spirinumber"
                type="string"
                onChange={handlePrevSpiri}
                disabled={
                  userDetails.roleId == 3 ||
                  userDetails.roleId == 4 ||
                  userDetails.roleId == 5 ||
                  userDetails.roleId == 7 ||
                  userDetails.roleId == 8 ||
                  userDetails.roleId == 9 ||
                  userDetails.roleId == 10
                }
                value={prevspirisonNumber}
              />
            </FormControl>
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                Spiridon Number*
              </InputLabel>
              <BootstrapInput
                name="spirinumber"
                type="string"
                onChange={handleSpiridonNumber}
                disabled={
                  userDetails.roleId == 3 ||
                  userDetails.roleId == 4 ||
                  userDetails.roleId == 5 ||
                  userDetails.roleId == 7 ||
                  userDetails.roleId == 8 ||
                  userDetails.roleId == 9 ||
                  userDetails.roleId == 10
                }
                value={
                  prevRowData ? prevRowData.spiridonNumber : spiridonNumber
                }
              />
            </FormControl>
          </Grid>
              )}

              

        {prevRowData ? (
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                Description*
              </InputLabel>
              <BootstrapInput
                id="Sender-Name"
                name="rndLocation"
                onChange={handlePrevDesc}
                disabled={
                  userDetails.roleId == 3 ||
                  userDetails.roleId == 4 ||
                  userDetails.roleId == 5 ||
                  userDetails.roleId == 7 ||
                  userDetails.roleId == 8 ||
                  userDetails.roleId == 9 ||
                  userDetails.roleId == 10
                }
                value={prevDescr}
              />
            </FormControl>
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                Description*
              </InputLabel>
              <BootstrapInput
                id="Sender-Name"
                name="rndLocation"
                onChange={handleDescription}
                disabled={
                  userDetails.roleId == 3 ||
                  userDetails.roleId == 4 ||
                  userDetails.roleId == 5 ||
                  userDetails.roleId == 7 ||
                  userDetails.roleId == 8 ||
                  userDetails.roleId == 9 ||
                  userDetails.roleId == 10
                }
                value={prevRowData ? prevRowData.description : description}
              />
            </FormControl>
          </Grid>
        )}

        {prevRowData ? (
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                NENA No./Drawing Number*
              </InputLabel>
              <BootstrapInput
                id="Sender-Name"
                name="senderName"
                onChange={handlePrevNena}
                value={prevNenaNumber}
                disabled={
                  userDetails.roleId == 3 ||
                  userDetails.roleId == 4 ||
                  userDetails.roleId == 5 ||
                  userDetails.roleId == 7 ||
                  userDetails.roleId == 8 ||
                  userDetails.roleId == 9 ||
                  userDetails.roleId == 10
                }
                required
              />
            </FormControl>
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                NENA No./Drawing Number*
              </InputLabel>
              <BootstrapInput
                id="Sender-Name"
                name="senderName"
                onChange={handleDrawingNumber}
                value={
                  prevRowData ? prevRowData.nenaNoDrawingNumber : drawingNumber
                }
                disabled={
                  userDetails.roleId == 3 ||
                  userDetails.roleId == 4 ||
                  userDetails.roleId == 5 ||
                  userDetails.roleId == 7 ||
                  userDetails.roleId == 8 ||
                  userDetails.roleId == 9 ||
                  userDetails.roleId == 10
                }
                required
              />
            </FormControl>
          </Grid>
        )}

        {prevRowData ? (
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                Drawing Revision Number*
              </InputLabel>
              <BootstrapInput
                id="Sender-Name"
                name="drawingrevisionnumber"
                onChange={handlePrevDra}
                disabled={
                  userDetails.roleId == 3 ||
                  userDetails.roleId == 4 ||
                  userDetails.roleId == 5 ||
                  userDetails.roleId == 7 ||
                  userDetails.roleId == 8 ||
                  userDetails.roleId == 9 ||
                  userDetails.roleId == 10
                }
                value={prevDrawing}
              />
            </FormControl>
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                Drawing Revision Number*
              </InputLabel>
              <BootstrapInput
                id="Sender-Name"
                name="drawingrevisionnumber"
                onChange={handleDrawingRebisionNumber}
                disabled={
                  userDetails.roleId == 3 ||
                  userDetails.roleId == 4 ||
                  userDetails.roleId == 5 ||
                  userDetails.roleId == 7 ||
                  userDetails.roleId == 8 ||
                  userDetails.roleId == 9 ||
                  userDetails.roleId == 10
                }
                value={
                  prevRowData
                    ? prevRowData.drawingRevisionNumber
                    : drawingRevisionNumber
                }
              />
            </FormControl>
          </Grid>
        )}

        {prevRowData ? (
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                Drawing Revision Date*
              </InputLabel>
              <BootstrapInput
                type="date"
                id="bootstrap-input"
                name="revisiondate"
                onChange={handlePrevrevDate}
                disabled={
                  userDetails.roleId == 3 ||
                  userDetails.roleId == 4 ||
                  userDetails.roleId == 5 ||
                  userDetails.roleId == 7 ||
                  userDetails.roleId == 8 ||
                  userDetails.roleId == 9 ||
                  userDetails.roleId == 10
                }
                value={renderDateY(prevRevDate)}
              />
            </FormControl>
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                Drawing Revision Date*
              </InputLabel>
              <BootstrapInput
                type="date"
                id="bootstrap-input"
                name="revisiondate"
                onChange={handleDateChange}
                disabled={
                  userDetails.roleId == 3 ||
                  userDetails.roleId == 4 ||
                  userDetails.roleId == 5 ||
                  userDetails.roleId == 7 ||
                  userDetails.roleId == 8 ||
                  userDetails.roleId == 9 ||
                  userDetails.roleId == 10
                }
                value={dateInputs}
              />
            </FormControl>
          </Grid>
        )}

        <Grid item xs={12} sm={6} md={3} style={{ opacity: 0 }}>
          <FormControl fullWidth>
            <InputLabel shrink htmlFor="bootstrap-input">
              Supplier Name*
            </InputLabel>
            <Select
              labelId="supplier name"
              id="severity"
              name="suppliernm"
              // onChange={newHandleSupplierName}
              // value={selectedSupplierCode}
              disabled={
                groupData === 3 ||
                prevRowData.groupId == 3 ||
                userDetails.roleId == 3 ||
                userDetails.roleId == 4 ||
                userDetails.roleId == 5 ||
                userDetails.roleId == 7 ||
                userDetails.roleId == 8 ||
                userDetails.roleId == 9 ||
                userDetails.roleId == 10 ||
                userDetails.roleId == 1 ||
                userDetails.roleId == 2 ||
                userDetails.roleId == 6
              }
              input={<BootstrapInput />}
            >
              {supplier.map((item, index) => (
                <MenuItem key={index} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <InputLabel shrink htmlFor="bootstrap-input">
              Supplier Name*
            </InputLabel>
            <Select
              labelId="supplier name"
              id="severity"
              name="suppliernm"
              onChange={newHandleSupplierName}
              value={selectedSupplierCode}
              disabled={
                groupData === 3 ||
                prevRowData.groupId == 3 ||
                userDetails.roleId == 3 ||
                userDetails.roleId == 4 ||
                userDetails.roleId == 5 ||
                userDetails.roleId == 7 ||
                userDetails.roleId == 8 ||
                userDetails.roleId == 9 ||
                userDetails.roleId == 10
              }
              input={<BootstrapInput />}
            >
              {supplier.map((item, index) => (
                <MenuItem key={index} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <InputLabel shrink htmlFor="bootstrap-input">
              Supplier Code*
            </InputLabel>

            <BootstrapInput
              id="Sender-Name"
              name="vendorCodeName"
              value={vendorCodeName}
              disabled={
                userDetails.roleId == 2 ||
                prevRowData.groupId == 3 ||
                userDetails.roleId == 3 ||
                userDetails.roleId == 4 ||
                userDetails.roleId == 5 ||
                userDetails.roleId == 7 ||
                userDetails.roleId == 8 ||
                userDetails.roleId == 9 ||
                userDetails.roleId == 10 ||
                !disable
              }
              required
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <InputLabel shrink htmlFor="bootstrap-input">
              Supplier Contact Person Email Id*
            </InputLabel>
            <Select
              labelId=" SuppliercontactpersonemailId*"
              id="scontactpersonemail"
              name="scontpemail"
              value={firstsEmailId}
              disabled={
                groupData === 3 ||
                prevRowData.groupId == 3 ||
                userDetails.roleId == 3 ||
                userDetails.roleId == 4 ||
                userDetails.roleId == 5 ||
                userDetails.roleId == 7 ||
                userDetails.roleId == 8 ||
                userDetails.roleId == 9 ||
                userDetails.roleId == 10
              }
              onChange={handleFirstsEmailId}
              input={<BootstrapInput />}
            >
              {supplierEmailIds.map((item) => (
                <MenuItem key={item.id} value={item.email}>
                  {item.email}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <InputLabel shrink htmlFor="bootstrap-input">
              Supplier Contact Person Email Id2*
            </InputLabel>
            <BootstrapInput
              name="spirinumber"
              onChange={handleSSecondEmail}
              value={prevSSecondEmailId}
              disabled={
                prevRowData.groupId == 3 ||
                groupData === 3 ||
                userDetails.roleId == 3 ||
                userDetails.roleId == 4 ||
                userDetails.roleId == 5 ||
                userDetails.roleId == 7 ||
                userDetails.roleId == 8 ||
                userDetails.roleId == 9 ||
                userDetails.roleId == 10
              }
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <InputLabel shrink htmlFor="bootstrap-input">
              {" "}
              R&D Location*
            </InputLabel>
            <Select
              labelId="developmenttype"
              id="rdloction"
              name="rdlocation"
              onChange={handleRndLocation}
              value={rndLocationData}
              disabled={
                groupData === 3 ||
                prevRowData.groupId == 3 ||
                userDetails.roleId == 3 ||
                userDetails.roleId == 4 ||
                userDetails.roleId == 5 ||
                userDetails.roleId == 7 ||
                userDetails.roleId == 8 ||
                userDetails.roleId == 9 ||
                userDetails.roleId == 10
              }
              input={<BootstrapInput />}
            >
              {rndLocation.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <InputLabel shrink htmlFor="bootstrap-input">
              R&D Contact Person Email Id*
            </InputLabel>
            <Select
              labelId="r&dcontactpersonemailid"
              id="randcontactpersonemailid"
              name="r&dcontactperson"
              onChange={handlerndEmail}
              value={rndEmailId}
              disabled={
                groupData === 3 ||
                prevRowData.groupId == 3 ||
                userDetails.roleId == 3 ||
                userDetails.roleId == 4 ||
                userDetails.roleId == 5 ||
                userDetails.roleId == 7 ||
                userDetails.roleId == 8 ||
                userDetails.roleId == 9 ||
                userDetails.roleId == 10
              }
              input={<BootstrapInput />}
            >
              {getRdData.map((item) => (
                <MenuItem key={item.id} value={item.userId}>
                  {item.userEmail}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {(groupData == 1 ||
          groupData == 2 ||
          groupData == 4 ||
          groupData == 5 ||
          prevRowData.groupId == 1 ||
          prevRowData.groupId == 2 ||
          prevRowData.groupId == 4 ||
          prevRowData.groupId == 5) &&
        (groupData !== 3 || prevRowData.groupId !== 3) ? (
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                CC(CE HOD)*
              </InputLabel>
              <BootstrapInput
                id="Sender-Name"
                name="cchod"
                //onChange={handleCcForOtherThanseso}
                //prevRowData ? ccData
                value={ssiCCemails}
                disabled={
                  userDetails.roleId == 3 ||
                  userDetails.roleId == 4 ||
                  userDetails.roleId == 5 ||
                  userDetails.roleId == 7 ||
                  userDetails.roleId == 8 ||
                  userDetails.roleId == 9 ||
                  userDetails.roleId == 10
                }
              />
            </FormControl>
          </Grid>
        ) : (
          <></>
        )}
        {groupData == 3 || prevRowData.groupId == 3 ? (
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                CC(CE HOD)*
              </InputLabel>
              <BootstrapInput
                id="Sender-Name"
                name="cehod1"
                onChange={handleCc}
                //prevRowData ? ccData
                value={cc}
                disabled={
                  userDetails.roleId == 3 ||
                  userDetails.roleId == 4 ||
                  userDetails.roleId == 5 ||
                  userDetails.roleId == 7 ||
                  userDetails.roleId == 8 ||
                  userDetails.roleId == 9 ||
                  userDetails.roleId == 10
                }
              />
            </FormControl>
          </Grid>
        ) : (
          <></>
        )}

        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <InputLabel shrink htmlFor="bootstrap-input">
              SQM Engineer/Initiator*
            </InputLabel>
            <BootstrapInput
              id="Sender-Name"
              name="clearquesnumber"
              value={
                prevRowData
                  ? prevRowData.componentEngineerInitiator
                  : userDetails.userFirstName
              }
              disabled={
                userDetails.roleId == 3 ||
                userDetails.roleId == 4 ||
                userDetails.roleId == 5 ||
                userDetails.roleId == 7 ||
                userDetails.roleId == 8 ||
                userDetails.roleId == 9 ||
                userDetails.roleId == 10
              }
            />
          </FormControl>
              </Grid>

            

        {prevRowData ? (
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                Weight of Part
              </InputLabel>
              <BootstrapInput
                id="Sender-Name"
                name="senderName"
                onChange={handlePrevWeightOfpart}
                value={prevWeightOfpart}
                disabled={
                  userDetails.roleId == 3 ||
                  userDetails.roleId == 4 ||
                  userDetails.roleId == 5 ||
                  userDetails.roleId == 7 ||
                  userDetails.roleId == 8 ||
                  userDetails.roleId == 9 ||
                  userDetails.roleId == 10
                }
                required
              />
            </FormControl>
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                Weight of Part
              </InputLabel>
              <BootstrapInput
                id="Sender-Name"
                name="senderName"
                onChange={handleWeightPart}
                value={weightPart}
                disabled={
                  userDetails.roleId == 3 ||
                  userDetails.roleId == 4 ||
                  userDetails.roleId == 5 ||
                  userDetails.roleId == 7 ||
                  userDetails.roleId == 8 ||
                  userDetails.roleId == 9 ||
                  userDetails.roleId == 10
                }
                required
              />
            </FormControl>
          </Grid>
        )}
      </Grid>

      {(userDetails.roleId === 1 ||
        userDetails.roleId === 2 ||
        userDetails.roleId === 6) && (
        <Grid container spacing={3}>
          <Grid item xs={12} md={8} className="fileMatTable">
            <MaterialTable
              title={"File Upload Table"}
              columns={columnsUploadData}
              data={tableData}
              //icons={tableIcons}
              //isLoading={isLoader}
              options={{
                selection: true,
                search: false,
              }}
              onSelectionChange={(rows) => {
                console.log("selected rows:", rows);
                setSelectedRows(rows);
                //const selectedIds = rows.map(row=>row.tableData.id);
                // subData.selectedIds = selectedIds;
              }}
              selectedRows={selectedRows}
            />
            <>
              <SnackbarCustom
                open={open}
                message={snackMessage}
                alertType={alertType}
                handleClose={handleClose}
              />
            </>
          </Grid>
          <Grid
            item
            xs={12}
            md={8}
            style={{
              textAlign: "center",
              marginTop: "20px",
              marginBottom: "40px",
            }}
          >
            <Button
              className="pr-button--secondary bulk-upload-submit-btn submit"
              onClick={handleFileUploadList}
              disabled={selectedRows?.length === 0}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      )}

      <Grid className="data-part">
        {userDetails.roleId === 1 ||
        userDetails.roleId === 2 ||
        userDetails.roleId === 4 ||
        userDetails.roleId === 5 ||
        userDetails.roleId === 6 ||
        userDetails.roleId === 7 ||
        userDetails.roleId === 8 ||
        userDetails.roleId === 9 ||
        userDetails.roleId === 10 ? (
          <button
            className="datatwo-part"
            onClick={
              (iipActionDataState && poTextActionDataState) ||
              (prevRowData.groupId == 3 && poTextActionDataState)
                ? openDataTwo
                : " "
            }
            disabled={prevRowData.typeId == 2}
          >
            Data Two
          </button>
        ) : (
          <></>
        )}

        {dataTwo ? (
          <Grid container spacing={2}>
            <Grid container spacing={2} className="mandatory-fields">
              {prevRowData ? (
                <Grid item xs={12} sm={6} md={3}>
                  <FormControl fullWidth>
                    <InputLabel shrink htmlFor="bootstrap-input">
                      SQE Person Assigned
                    </InputLabel>
                    <Select
                      labelId="sqeperson"
                      id="sqep"
                      name="sqepa"
                      onChange={handlePrevSqe}
                      value={prevSqe}
                      disabled={
                        userDetails.roleId == 3 ||
                        userDetails.roleId == 4 ||
                        userDetails.roleId == 5 ||
                        userDetails.roleId == 7 ||
                        userDetails.roleId == 8 ||
                        userDetails.roleId == 9 ||
                        userDetails.roleId == 10
                      }
                      input={<BootstrapInput />}
                    >
                      {getSqePersonData.map((item) => (
                        <MenuItem key={item.id} value={item.userId}>
                          {item.userEmail}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              ) : (
                <Grid item xs={12} sm={6} md={3}>
                  <FormControl fullWidth>
                    <InputLabel shrink htmlFor="bootstrap-input">
                      SQE Person Assigned
                    </InputLabel>
                    <Select
                      labelId="sqeperson"
                      id="sqep"
                      name="sqepa"
                      onChange={handleCsQE}
                      value={sqepValue}
                      disabled={
                        userDetails.roleId == 3 ||
                        userDetails.roleId == 4 ||
                        userDetails.roleId == 5 ||
                        userDetails.roleId == 7 ||
                        userDetails.roleId == 8 ||
                        userDetails.roleId == 9 ||
                        userDetails.roleId == 10
                      }
                      input={<BootstrapInput />}
                    >
                      {getSqePersonData.map((item) => (
                        <MenuItem key={item.id} value={item.userId}>
                          {item.userEmail}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}

              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth>
                  <InputLabel shrink htmlFor="bootstrap-input">
                    {" "}
                    SPR Person Assigned
                  </InputLabel>
                  <Select
                    labelId="SPR Person Assigned"
                    id="sprperson"
                    name="sprperson"
                    onChange={handleChangeSpr}
                    value={sprpValue}
                    disabled={
                      userDetails.roleId == 3 ||
                      userDetails.roleId == 4 ||
                      userDetails.roleId == 5 ||
                      userDetails.roleId == 9 ||
                      userDetails.roleId == 7 ||
                      userDetails.roleId == 8 ||
                      userDetails.roleId == 10
                    }
                    input={<BootstrapInput />}
                  >
                    {getSprPersonData.map((item) => (
                      <MenuItem key={item.id} value={item.userId}>
                        {item.userEmail}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {prevRowData ? (
                <Grid item xs={12} sm={6} md={3}>
                  <FormControl fullWidth>
                    <InputLabel shrink htmlFor="bootstrap-input">
                      {" "}
                      OPR Person Assigned
                    </InputLabel>
                    <Select
                      labelId="OPR Person Assigned"
                      id="oprperson"
                      name="oprperson"
                      onChange={handlePrevOpr}
                      value={prevOpr}
                      disabled={
                        userDetails.roleId == 3 ||
                        userDetails.roleId == 4 ||
                        userDetails.roleId == 5 ||
                        userDetails.roleId == 7 ||
                        userDetails.roleId == 8 ||
                        userDetails.roleId == 9 ||
                        userDetails.roleId == 10
                      }
                      input={<BootstrapInput />}
                    >
                      {getOprPersonData.map((item) => (
                        <MenuItem key={item.id} value={item.userId}>
                          {item.userEmail}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              ) : (
                <Grid item xs={12} sm={6} md={3}>
                  <FormControl fullWidth>
                    <InputLabel shrink htmlFor="bootstrap-input">
                      {" "}
                      OPR Person Assigned
                    </InputLabel>
                    <Select
                      labelId="OPR Person Assigned"
                      id="oprperson"
                      name="oprperson"
                      onChange={handleChangeOpr}
                      value={oprpValue}
                      disabled={
                        userDetails.roleId == 3 ||
                        userDetails.roleId == 4 ||
                        userDetails.roleId == 5 ||
                        userDetails.roleId == 7 ||
                        userDetails.roleId == 8 ||
                        userDetails.roleId == 9 ||
                        userDetails.roleId == 10
                      }
                      input={<BootstrapInput />}
                    >
                      {getOprPersonData.map((item) => (
                        <MenuItem key={item.id} value={item.userId}>
                          {item.userEmail}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}

              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth>
                  <InputLabel shrink htmlFor="bootstrap-input">
                    Pilot Quantity
                  </InputLabel>
                  <BootstrapInput
                    id="Sender-Name"
                    name="pilotQuantity"
                    onChange={handlePilotQunatity}
                    value={pilotQuantity}
                    disabled={
                      userDetails.roleId == 3 ||
                      userDetails.roleId == 4 ||
                      userDetails.roleId == 5 ||
                      userDetails.roleId == 7 ||
                      userDetails.roleId == 8 ||
                      userDetails.roleId == 9 ||
                      userDetails.roleId == 10
                    }
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={2} className="spr-fields">
              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth>
                  <InputLabel shrink htmlFor="bootstrap-input">
                    {" "}
                    Q-info Request Done?
                  </InputLabel>
                  <Select
                    labelId="qInfoReqDone"
                    id="qInfoReqDone"
                    name="qInfoReqDone"
                    onChange={handleQInfoReq}
                    value={qinfoDone}
                    disabled={
                      userDetails.roleId == 2 ||
                      userDetails.roleId == 3 ||
                      userDetails.roleId == 4 ||
                      userDetails.roleId == 5 ||
                      userDetails.roleId == 6 ||
                      userDetails.roleId == 7 ||
                      //userDetails.roleId == 8 ||
                      userDetails.roleId == 10
                    }
                    input={<BootstrapInput />}
                  >
                    <MenuItem value="true">Yes</MenuItem>
                    <MenuItem value="false">No</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* <Grid item xs={12} sm={6} md={3}>
                            <FormControl fullWidth>
                                <InputLabel shrink htmlFor="bootstrap-input" >
                                    Q-info Request

                                </InputLabel>
                                <BootstrapInput id="Sender-Name"
                                    name="qinfor"
                                    onChange={handleQinfo}
                                    value={qInfo}
                                    disabled={userDetails.roleId == 2 || userDetails.roleId == 3 || userDetails.roleId == 4 || userDetails.roleId == 5 || userDetails.roleId == 6 || userDetails.roleId == 7 || userDetails.roleId == 9 || userDetails.roleId == 10}
                                />

                            </FormControl>
                        </Grid> */}

              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth>
                  <InputLabel shrink htmlFor="bootstrap-input">
                    Qinfo Updated Date
                  </InputLabel>
                  <BootstrapInput
                    type="date"
                    id="bootstrap-input"
                    name="qud"
                    onChange={handlePilotRelease}
                    value={pilotRelease}
                    disabled={
                      userDetails.roleId == 2 ||
                      userDetails.roleId == 3 ||
                      userDetails.roleId == 4 ||
                      userDetails.roleId == 6 ||
                      userDetails.roleId == 5 ||
                      userDetails.roleId == 7 ||
                      userDetails.roleId == 9 ||
                      userDetails.roleId == 10
                    }
                  />
                </FormControl>
              </Grid>

              {prevRowData.groupId == 3 &&
              prevRowData.developmentTypeId == 1 &&
              prevRowData.purchaseorderDate !== null &&
              prevRowData.purchaseorderNumber !== null ? (
                <Grid item xs={12} sm={6} md={3}>
                  <FormControl fullWidth>
                    <InputLabel shrink htmlFor="bootstrap-input">
                      Mass Release Date
                    </InputLabel>
                    <BootstrapInput
                      type="date"
                      id="bootstrap-input"
                      name="requestraisedby"
                      onChange={handleRequestRaisedBy}
                      value={requestRaised}
                      disabled={
                        userDetails.roleId == 2 ||
                        userDetails.roleId == 3 ||
                        userDetails.roleId == 4 ||
                        userDetails.roleId == 5 ||
                        userDetails.roleId == 7 ||
                        userDetails.roleId == 6 ||
                        userDetails.roleId == 9 ||
                        userDetails.roleId == 10
                      }
                      //disabled={(!incomingQualityReportValue && !ppapXlsmActionDataState) || userDetails.roleId == 1 || userDetails.roleId == 2 || userDetails.roleId == 3 || userDetails.roleId == 4 || userDetails.roleId == 5 || userDetails.roleId == 7 || userDetails.roleId == 6 || userDetails.roleId == 9 || userDetails.roleId == 10}
                    />
                  </FormControl>
                </Grid>
              ) : (
                <></>
              )}
              {prevRowData.groupId == 3 &&
              prevRowData.developmentTypeId == 2 &&
              prevRowData.purchaseorderDate !== null &&
              prevRowData.purchaseorderNumber !== null ? (
                <Grid item xs={12} sm={6} md={3}>
                  <FormControl fullWidth>
                    <InputLabel shrink htmlFor="bootstrap-input">
                      Mass Release Date
                    </InputLabel>
                    <BootstrapInput
                      type="date"
                      id="bootstrap-input"
                      name="requestraisedby"
                      onChange={handleRequestRaisedBy}
                      value={requestRaised}
                      disabled={
                        userDetails.roleId == 2 ||
                        userDetails.roleId == 3 ||
                        userDetails.roleId == 4 ||
                        userDetails.roleId == 5 ||
                        userDetails.roleId == 7 ||
                        userDetails.roleId == 6 ||
                        userDetails.roleId == 9 ||
                        userDetails.roleId == 10
                      }
                      //disabled={(!incomingQualityReportValue && !ppapXlsmActionDataState) || userDetails.roleId == 1 || userDetails.roleId == 2 || userDetails.roleId == 3 || userDetails.roleId == 4 || userDetails.roleId == 5 || userDetails.roleId == 7 || userDetails.roleId == 6 || userDetails.roleId == 9 || userDetails.roleId == 10}
                    />
                  </FormControl>
                </Grid>
              ) : (
                <></>
              )}

              {(prevRowData.groupId == 1 ||
                prevRowData.groupId == 2 ||
                prevRowData.groupId == 4 ||
                prevRowData.groupId == 5) &&
              prevRowData.developmentTypeId == 1 &&
              prevRowData.purchaseorderDate !== null &&
              prevRowData.purchaseorderNumber !== null ? (
                <Grid item xs={12} sm={6} md={3}>
                  <FormControl fullWidth>
                    <InputLabel shrink htmlFor="bootstrap-input">
                      Mass Release Date
                    </InputLabel>
                    <BootstrapInput
                      type="date"
                      id="bootstrap-input"
                      name="requestraisedby"
                      onChange={handleRequestRaisedBy}
                      value={requestRaised}
                      disabled={
                        userDetails.roleId == 2 ||
                        userDetails.roleId == 3 ||
                        userDetails.roleId == 4 ||
                        userDetails.roleId == 5 ||
                        userDetails.roleId == 7 ||
                        userDetails.roleId == 6 ||
                        userDetails.roleId == 9 ||
                        userDetails.roleId == 10
                      }
                    />
                  </FormControl>
                </Grid>
              ) : (
                <></>
              )}
              {(prevRowData.groupId == 1 ||
                prevRowData.groupId == 2 ||
                prevRowData.groupId == 4 ||
                prevRowData.groupId == 5) &&
              prevRowData.developmentTypeId == 2 &&
              incomingQualityReportValue !== null &&
              ppapXlsmActionDataState !== null &&
              prevRowData.purchaseorderDate !== null &&
              prevRowData.purchaseorderNumber !== null ? (
                <Grid item xs={12} sm={6} md={3}>
                  <FormControl fullWidth>
                    <InputLabel shrink htmlFor="bootstrap-input">
                      Mass Release Date
                    </InputLabel>
                    <BootstrapInput
                      type="date"
                      id="bootstrap-input"
                      name="requestraisedby"
                      onChange={handleRequestRaisedBy}
                      value={requestRaised}
                      disabled={
                        userDetails.roleId == 2 ||
                        userDetails.roleId == 3 ||
                        userDetails.roleId == 4 ||
                        userDetails.roleId == 5 ||
                        userDetails.roleId == 7 ||
                        userDetails.roleId == 6 ||
                        userDetails.roleId == 9 ||
                        userDetails.roleId == 10
                      }
                    />
                  </FormControl>
                </Grid>
              ) : (
                <></>
              )}
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel shrink htmlFor="bootstrap-input">
                  {" "}
                  Supply Chain Establishment Done?
                </InputLabel>
                <Select
                  labelId="supplychainestdone"
                  id="estdone"
                  name="estcdone"
                  onChange={handleEstablishment}
                  value={establishmentDone}
                  disabled={
                    userDetails.roleId == 2 ||
                    userDetails.roleId == 3 ||
                    userDetails.roleId == 4 ||
                    userDetails.roleId == 5 ||
                    userDetails.roleId == 6 ||
                    userDetails.roleId == 7 ||
                    //userDetails.roleId == 8 ||
                    userDetails.roleId == 10
                  }
                  input={<BootstrapInput />}
                >
                  <MenuItem value="true">Yes</MenuItem>
                  <MenuItem value="false">No</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {establishmentDone == "true" ? (
              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth>
                  <InputLabel shrink htmlFor="bootstrap-input">
                    Supply Chain Establishment Date
                  </InputLabel>
                  <BootstrapInput
                    type="date"
                    id="bootstrap-input"
                    name="supplyChainEstDate"
                    onChange={handleSupplyChainEstDate}
                    disabled={
                      userDetails.roleId == 2 ||
                      userDetails.roleId == 3 ||
                      userDetails.roleId == 4 ||
                      userDetails.roleId == 6 ||
                      userDetails.roleId == 5 ||
                      userDetails.roleId == 7 ||
                      userDetails.roleId == 8 ||
                      userDetails.roleId == 10
                    }
                    value={supplyChainEstDate}
                  />
                </FormControl>
              </Grid>
            ) : (
              <></>
            )}

            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel shrink htmlFor="bootstrap-input">
                  Purchase Order Number
                </InputLabel>
                <BootstrapInput
                  id="Sender-Name"
                  name="purchaseOrderNumber"
                  onChange={handlePurchaseOrderNumber}
                  value={purchaseOrderNumber}
                  disabled={
                    userDetails.roleId == 2 ||
                    userDetails.roleId == 3 ||
                    userDetails.roleId == 4 ||
                    userDetails.roleId == 5 ||
                    userDetails.roleId == 6 ||
                    userDetails.roleId == 7 ||
                    userDetails.roleId == 8 ||
                    userDetails.roleId == 9
                  }
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel shrink htmlFor="bootstrap-input">
                  Purchase Order Date
                </InputLabel>
                <BootstrapInput
                  type="date"
                  id="bootstrap-input"
                  name="purchaseOrderDate"
                  onChange={handlePurchaseOrderDate}
                  disabled={
                    userDetails.roleId === 6 ||
                    userDetails.roleId == 2 ||
                    userDetails.roleId == 3 ||
                    userDetails.roleId == 4 ||
                    userDetails.roleId == 6 ||
                    userDetails.roleId == 5 ||
                    userDetails.roleId == 7 ||
                    userDetails.roleId == 8 ||
                    userDetails.roleId == 9
                  }
                  value={purchaseOrderDate}
                />
              </FormControl>
            </Grid>
          </Grid>
        ) : (
          <></>
        )}
      </Grid>

      <div className={classes.root}>
        <AppBar position="static" color="default">
          <Tabs
            value={value}
            onChange={handleChange1}
            indicatorColor="primary"
            textColor="secondary"
            variant="fullWidth"
            aria-label="full width tabs example"
          >
            <Tab label="Tab One" {...a11yProps(0)} />
            <Tab label="Tab Two" {...a11yProps(1)} />
          </Tabs>
        </AppBar>
        <SwipeableViews
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={value}
          onChangeIndex={handleChangeIndex}
        >
          <TabPanel value={value} index={0} dir={theme.direction}>
            <PartOne
              isirNumberPassed={isirWorkFlowNumber}
              groupData={groupData}
              developmentData={developmentData}
              prevDataAdd={prevRowData}
              formData={formData}
              documentList={documentList}
              test={test}
            />
          </TabPanel>
          <TabPanel value={value} index={1} dir={theme.direction}>
            <PartTwo
                          isirNumberPassed={isirWorkFlowNumber}
                          prevDataAdd2={prevRowData}
                          groupData={groupData}
                          developmentData={developmentData}
                          documentList={documentList}
                          onFileChange={(file) => setParentSQMAPQPQuestionare(file)}
                          onFileChangeCrer={(file) => setParentCrerFile(file)}
                          tableData={tableData}
                      
            />
          </TabPanel>
        </SwipeableViews>
      </div>

      <SnackbarCustom
        open={open}
        message={snackMessage}
        alertType={alertType}
        handleClose={handleClose}
      />
      {/*  || (closeBtnEnableDataStateFromTB2ChildType && prevRowData.typeId==2)*/}
      <div className="btn-section">
        {userDetails.roleId == 1 ||
        userDetails.roleId == 6 ||
        userDetails.roleId == 2 ||
        userDetails.roleId == 8 ||
        userDetails.roleId == 9 ||
        userDetails.roleId == 10 ? (
          <DialogActions>
            <Button
              className="pr-button--secondary bulk-upload-submit-btn submit"
              onClick={handleSavedraftDataOne}
              disabled={
                afterClosingIsirActionDataState ||
                (prevRowData.statusName == "ISIR Closed" &&
                  prevRowData.statusId == 7 &&
                  prevRowData.massReleasetoSQE != null) ||
                (prevRowData.statusName == "ISIR Closed" &&
                  prevRowData.statusId == 7 &&
                  prevRowData.massReleasetoSQE == null &&
                  prevRowData.typeId == 2) ||
                (prevRowData.statusName == "Submitted" &&
                  prevRowData.statusId == 2 &&
                  prevRowData.typeId == 2)
              }
            >
              Save as Draft
            </Button>
          </DialogActions>
        ) : (
          <></>
        )}
        {/*   || (closeBtnEnableDataStateFromTB2ChildType && prevRowData.typeId==2)*/}
        {userDetails.roleId == 1 ||
        userDetails.roleId == 6 ||
        userDetails.roleId == 2 ||
        userDetails.roleId == 8 ||
        userDetails.roleId == 9 ||
        userDetails.roleId == 10 ? (
          <DialogActions>
            <Button
              className="pr-button--secondary bulk-upload-submit-btn submit"
              onClick={handleSubmitDataOne}
              disabled={
                afterClosingIsirActionDataState ||
                (prevRowData.statusName == "ISIR Closed" &&
                  prevRowData.statusId == 7 &&
                  prevRowData.massReleasetoSQE != null) ||
                (prevRowData.statusName == "ISIR Closed" &&
                  prevRowData.statusId == 7 &&
                  prevRowData.massReleasetoSQE == null &&
                  prevRowData.typeId == 2)
              }
            >
              Submit
            </Button>
          </DialogActions>
        ) : (
          <></>
        )}
        {prevRowData.typeId == 2 &&
        (userDetails.roleId == 6 ||
          userDetails.roleId == 1 ||
          userDetails.roleId == 2 ||
          userDetails.roleId == 8) ? (
          <DialogActions>
            <Button
              className="pr-button--secondary bulk-upload-submit-btn submit"
              onClick={getClosureCloseDate}
              disabled={
                !closeBtnEnableDataStateFromTB2ChildType ||
                (prevRowData.statusName == "ISIR Closed" &&
                  prevRowData.statusId == 7 &&
                  prevRowData.massReleasetoSQE == null &&
                      prevRowData.typeId == 2) 
              }
            >
              Close Child
            </Button>{" "}
          </DialogActions>
        ) : (
          <></>
        )}
        {prevRowData.typeId == 1 &&
        (userDetails.roleId == 6 ||
          userDetails.roleId == 1 ||
          userDetails.roleId == 2 ||
          userDetails.roleId == 8) ? (
          <DialogActions>
            <Button
              className="pr-button--secondary bulk-upload-submit-btn submit"
              onClick={getClosureCloseDate}
              disabled={!closeBtnActionDataState}

              //disabled={toShowCloseBtn == false || showCloseWhileSavingD==false}   //&& !userDetails.roleId === 8
            >
              Close
            </Button>
          </DialogActions>
        ) : (
          <></>
        )}
      </div>
      {isLoaderFeedback ? <Loading loaderText="Loading...." /> : <></>}
    </div>
  );
};
export default AddIsir;
